import "core-js/modules/es.promise.finally";
import * as firebase from 'firebase/app';
import 'firebase/auth';
import dialogPolyfill from 'dialog-polyfill';
import 'material-design-lite/src/mdlComponentHandler';
import 'material-design-lite/src/button/button';
import 'material-design-lite/src/progress/progress';
import 'material-design-lite/src/spinner/spinner';
import 'material-design-lite/src/textfield/textfield';
(function () {
  (function () {
    var l,
        aa = "function" == typeof Object.create ? Object.create : function (a) {
      function b() {}

      b.prototype = a;
      return new b();
    },
        ba;
    if ("function" == typeof Object.setPrototypeOf) ba = Object.setPrototypeOf;else {
      var ca;

      a: {
        var da = {
          xb: !0
        },
            ea = {};

        try {
          ea.__proto__ = da;
          ca = ea.xb;
          break a;
        } catch (a) {}

        ca = !1;
      }

      ba = ca ? function (a, b) {
        a.__proto__ = b;
        if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
        return a;
      } : null;
    }
    var fa = ba;

    function m(a, b) {
      a.prototype = aa(b.prototype);
      a.prototype.constructor = a;
      if (fa) fa(a, b);else for (var c in b) {
        if ("prototype" != c) if (Object.defineProperties) {
          var d = Object.getOwnPropertyDescriptor(b, c);
          d && Object.defineProperty(a, c, d);
        } else a[c] = b[c];
      }
      a.K = b.prototype;
    }

    var ha = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
      a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    },
        ia = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this;

    function ja(a, b) {
      if (b) {
        var c = ia;
        a = a.split(".");

        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          e in c || (c[e] = {});
          c = c[e];
        }

        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && ha(c, a, {
          configurable: !0,
          writable: !0,
          value: b
        });
      }
    }

    ja("Object.is", function (a) {
      return a ? a : function (b, c) {
        return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
      };
    });
    ja("Array.prototype.includes", function (a) {
      return a ? a : function (b, c) {
        var d = this;
        d instanceof String && (d = String(d));
        var e = d.length;
        c = c || 0;

        for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
          var f = d[c];
          if (f === b || Object.is(f, b)) return !0;
        }

        return !1;
      };
    });
    var n = this;

    function ka(a) {
      return void 0 !== a;
    }

    function q(a) {
      return "string" == typeof a;
    }

    var la = /^[\w+/_-]+[=]{0,2}$/,
        ma = null;

    function na() {}

    function oa(a) {
      a.W = void 0;

      a.Xa = function () {
        return a.W ? a.W : a.W = new a();
      };
    }

    function pa(a) {
      var b = typeof a;
      if ("object" == b) {
        if (a) {
          if (a instanceof Array) return "array";
          if (a instanceof Object) return b;
          var c = Object.prototype.toString.call(a);
          if ("[object Window]" == c) return "object";
          if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
          if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
      } else if ("function" == b && "undefined" == typeof a.call) return "object";
      return b;
    }

    function qa(a) {
      return "array" == pa(a);
    }

    function ra(a) {
      var b = pa(a);
      return "array" == b || "object" == b && "number" == typeof a.length;
    }

    function sa(a) {
      return "function" == pa(a);
    }

    function ta(a) {
      var b = typeof a;
      return "object" == b && null != a || "function" == b;
    }

    var ua = "closure_uid_" + (1E9 * Math.random() >>> 0),
        va = 0;

    function wa(a, b, c) {
      return a.call.apply(a.bind, arguments);
    }

    function ya(a, b, c) {
      if (!a) throw Error();

      if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function () {
          var e = Array.prototype.slice.call(arguments);
          Array.prototype.unshift.apply(e, d);
          return a.apply(b, e);
        };
      }

      return function () {
        return a.apply(b, arguments);
      };
    }

    function t(a, b, c) {
      Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? t = wa : t = ya;
      return t.apply(null, arguments);
    }

    function za(a, b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return function () {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
      };
    }

    function u(a, b) {
      for (var c in b) {
        a[c] = b[c];
      }
    }

    var Aa = Date.now || function () {
      return +new Date();
    };

    function v(a, b) {
      a = a.split(".");
      var c = n;
      a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);

      for (var d; a.length && (d = a.shift());) {
        !a.length && ka(b) ? c[d] = b : c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {};
      }
    }

    function w(a, b) {
      function c() {}

      c.prototype = b.prototype;
      a.K = b.prototype;
      a.prototype = new c();
      a.prototype.constructor = a;

      a.tc = function (d, e, f) {
        for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) {
          g[h - 2] = arguments[h];
        }

        return b.prototype[e].apply(d, g);
      };
    }

    function Ca(a) {
      if (Error.captureStackTrace) Error.captureStackTrace(this, Ca);else {
        var b = Error().stack;
        b && (this.stack = b);
      }
      a && (this.message = String(a));
    }

    w(Ca, Error);
    Ca.prototype.name = "CustomError";
    var Da;

    function Ea(a, b) {
      a = a.split("%s");

      for (var c = "", d = a.length - 1, e = 0; e < d; e++) {
        c += a[e] + (e < b.length ? b[e] : "%s");
      }

      Ca.call(this, c + a[d]);
    }

    w(Ea, Ca);
    Ea.prototype.name = "AssertionError";

    function Fa(a, b) {
      throw new Ea("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }

    var Ga = Array.prototype.indexOf ? function (a, b) {
      return Array.prototype.indexOf.call(a, b, void 0);
    } : function (a, b) {
      if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, 0) : -1;

      for (var c = 0; c < a.length; c++) {
        if (c in a && a[c] === b) return c;
      }

      return -1;
    },
        Ha = Array.prototype.forEach ? function (a, b, c) {
      Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++) {
        f in e && b.call(c, e[f], f, a);
      }
    };

    function Ia(a, b) {
      for (var c = q(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d) {
        d in c && b.call(void 0, c[d], d, a);
      }
    }

    var Ja = Array.prototype.filter ? function (a, b) {
      return Array.prototype.filter.call(a, b, void 0);
    } : function (a, b) {
      for (var c = a.length, d = [], e = 0, f = q(a) ? a.split("") : a, g = 0; g < c; g++) {
        if (g in f) {
          var h = f[g];
          b.call(void 0, h, g, a) && (d[e++] = h);
        }
      }

      return d;
    },
        Ka = Array.prototype.map ? function (a, b) {
      return Array.prototype.map.call(a, b, void 0);
    } : function (a, b) {
      for (var c = a.length, d = Array(c), e = q(a) ? a.split("") : a, f = 0; f < c; f++) {
        f in e && (d[f] = b.call(void 0, e[f], f, a));
      }

      return d;
    },
        La = Array.prototype.some ? function (a, b) {
      return Array.prototype.some.call(a, b, void 0);
    } : function (a, b) {
      for (var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++) {
        if (e in d && b.call(void 0, d[e], e, a)) return !0;
      }

      return !1;
    };

    function Ma(a, b) {
      return 0 <= Ga(a, b);
    }

    function Na(a, b) {
      b = Ga(a, b);
      var c;
      (c = 0 <= b) && Oa(a, b);
      return c;
    }

    function Oa(a, b) {
      return 1 == Array.prototype.splice.call(a, b, 1).length;
    }

    function Pa(a, b) {
      a: {
        for (var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++) {
          if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
          }
        }

        b = -1;
      }

      0 <= b && Oa(a, b);
    }

    function Qa(a, b) {
      var c = 0;
      Ia(a, function (d, e) {
        b.call(void 0, d, e, a) && Oa(a, e) && c++;
      });
    }

    function Ra(a) {
      return Array.prototype.concat.apply([], arguments);
    }

    function Sa(a) {
      var b = a.length;

      if (0 < b) {
        for (var c = Array(b), d = 0; d < b; d++) {
          c[d] = a[d];
        }

        return c;
      }

      return [];
    }

    function Ta(a, b, c, d) {
      return Array.prototype.splice.apply(a, Ua(arguments, 1));
    }

    function Ua(a, b, c) {
      return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
    }

    var Va = String.prototype.trim ? function (a) {
      return a.trim();
    } : function (a) {
      return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    },
        Wa = /&/g,
        Xa = /</g,
        Ya = />/g,
        Za = /"/g,
        $a = /'/g,
        ab = /\x00/g,
        bb = /[\x00&<>"']/;

    function cb(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    }

    function db(a) {
      bb.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Wa, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(Xa, "&lt;")), -1 != a.indexOf(">") && (a = a.replace(Ya, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(Za, "&quot;")), -1 != a.indexOf("'") && (a = a.replace($a, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(ab, "&#0;")));
      return a;
    }

    function eb(a, b, c) {
      for (var d in a) {
        b.call(c, a[d], d, a);
      }
    }

    function fb(a) {
      var b = {},
          c;

      for (c in a) {
        b[c] = a[c];
      }

      return b;
    }

    var gb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

    function hb(a, b) {
      for (var c, d, e = 1; e < arguments.length; e++) {
        d = arguments[e];

        for (c in d) {
          a[c] = d[c];
        }

        for (var f = 0; f < gb.length; f++) {
          c = gb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
      }
    }

    var ib = "StopIteration" in n ? n.StopIteration : {
      message: "StopIteration",
      stack: ""
    };

    function jb() {}

    jb.prototype.next = function () {
      throw ib;
    };

    jb.prototype.ha = function () {
      return this;
    };

    function kb(a) {
      if (a instanceof jb) return a;
      if ("function" == typeof a.ha) return a.ha(!1);

      if (ra(a)) {
        var b = 0,
            c = new jb();

        c.next = function () {
          for (;;) {
            if (b >= a.length) throw ib;
            if (b in a) return a[b++];
            b++;
          }
        };

        return c;
      }

      throw Error("Not implemented");
    }

    function lb(a, b) {
      if (ra(a)) try {
        Ha(a, b, void 0);
      } catch (c) {
        if (c !== ib) throw c;
      } else {
        a = kb(a);

        try {
          for (;;) {
            b.call(void 0, a.next(), void 0, a);
          }
        } catch (c$0) {
          if (c$0 !== ib) throw c$0;
        }
      }
    }

    function mb(a) {
      if (ra(a)) return Sa(a);
      a = kb(a);
      var b = [];
      lb(a, function (c) {
        b.push(c);
      });
      return b;
    }

    function nb(a, b) {
      this.g = {};
      this.a = [];
      this.j = this.h = 0;
      var c = arguments.length;

      if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");

        for (var d = 0; d < c; d += 2) {
          this.set(arguments[d], arguments[d + 1]);
        }
      } else if (a) if (a instanceof nb) for (c = a.ja(), d = 0; d < c.length; d++) {
        this.set(c[d], a.get(c[d]));
      } else for (d in a) {
        this.set(d, a[d]);
      }
    }

    l = nb.prototype;

    l.la = function () {
      ob(this);

      for (var a = [], b = 0; b < this.a.length; b++) {
        a.push(this.g[this.a[b]]);
      }

      return a;
    };

    l.ja = function () {
      ob(this);
      return this.a.concat();
    };

    l.clear = function () {
      this.g = {};
      this.j = this.h = this.a.length = 0;
    };

    function ob(a) {
      if (a.h != a.a.length) {
        for (var b = 0, c = 0; b < a.a.length;) {
          var d = a.a[b];
          pb(a.g, d) && (a.a[c++] = d);
          b++;
        }

        a.a.length = c;
      }

      if (a.h != a.a.length) {
        var e = {};

        for (c = b = 0; b < a.a.length;) {
          d = a.a[b], pb(e, d) || (a.a[c++] = d, e[d] = 1), b++;
        }

        a.a.length = c;
      }
    }

    l.get = function (a, b) {
      return pb(this.g, a) ? this.g[a] : b;
    };

    l.set = function (a, b) {
      pb(this.g, a) || (this.h++, this.a.push(a), this.j++);
      this.g[a] = b;
    };

    l.forEach = function (a, b) {
      for (var c = this.ja(), d = 0; d < c.length; d++) {
        var e = c[d],
            f = this.get(e);
        a.call(b, f, e, this);
      }
    };

    l.ha = function (a) {
      ob(this);
      var b = 0,
          c = this.j,
          d = this,
          e = new jb();

      e.next = function () {
        if (c != d.j) throw Error("The map has changed since the iterator was created");
        if (b >= d.a.length) throw ib;
        var f = d.a[b++];
        return a ? f : d.g[f];
      };

      return e;
    };

    function pb(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    var qb = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

    function rb(a, b) {
      if (a) {
        a = a.split("&");

        for (var c = 0; c < a.length; c++) {
          var d = a[c].indexOf("="),
              e = null;

          if (0 <= d) {
            var f = a[c].substring(0, d);
            e = a[c].substring(d + 1);
          } else f = a[c];

          b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
      }
    }

    function sb(a, b, c, d) {
      for (var e = c.length; 0 <= (b = a.indexOf(c, b)) && b < d;) {
        var f = a.charCodeAt(b - 1);
        if (38 == f || 63 == f) if (f = a.charCodeAt(b + e), !f || 61 == f || 38 == f || 35 == f) return b;
        b += e + 1;
      }

      return -1;
    }

    var tb = /#|$/;

    function ub(a, b) {
      var c = a.search(tb),
          d = sb(a, 0, b, c);
      if (0 > d) return null;
      var e = a.indexOf("&", d);
      if (0 > e || e > c) e = c;
      d += b.length + 1;
      return decodeURIComponent(a.substr(d, e - d).replace(/\+/g, " "));
    }

    var vb = /[?&]($|#)/;

    function wb(a, b) {
      this.h = this.A = this.j = "";
      this.C = null;
      this.s = this.g = "";
      this.i = !1;
      var c;
      a instanceof wb ? (this.i = ka(b) ? b : a.i, xb(this, a.j), this.A = a.A, this.h = a.h, yb(this, a.C), this.g = a.g, zb(this, Ab(a.a)), this.s = a.s) : a && (c = String(a).match(qb)) ? (this.i = !!b, xb(this, c[1] || "", !0), this.A = Bb(c[2] || ""), this.h = Bb(c[3] || "", !0), yb(this, c[4]), this.g = Bb(c[5] || "", !0), zb(this, c[6] || "", !0), this.s = Bb(c[7] || "")) : (this.i = !!b, this.a = new Cb(null, this.i));
    }

    wb.prototype.toString = function () {
      var a = [],
          b = this.j;
      b && a.push(Db(b, Eb, !0), ":");
      var c = this.h;
      if (c || "file" == b) a.push("//"), (b = this.A) && a.push(Db(b, Eb, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.C, null != c && a.push(":", String(c));
      if (c = this.g) this.h && "/" != c.charAt(0) && a.push("/"), a.push(Db(c, "/" == c.charAt(0) ? Fb : Gb, !0));
      (c = this.a.toString()) && a.push("?", c);
      (c = this.s) && a.push("#", Db(c, Hb));
      return a.join("");
    };

    function xb(a, b, c) {
      a.j = c ? Bb(b, !0) : b;
      a.j && (a.j = a.j.replace(/:$/, ""));
    }

    function yb(a, b) {
      if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.C = b;
      } else a.C = null;
    }

    function zb(a, b, c) {
      b instanceof Cb ? (a.a = b, Ib(a.a, a.i)) : (c || (b = Db(b, Jb)), a.a = new Cb(b, a.i));
    }

    function Kb(a) {
      return a instanceof wb ? new wb(a) : new wb(a, void 0);
    }

    function Bb(a, b) {
      return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }

    function Db(a, b, c) {
      return q(a) ? (a = encodeURI(a).replace(b, Lb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }

    function Lb(a) {
      a = a.charCodeAt(0);
      return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }

    var Eb = /[#\/\?@]/g,
        Gb = /[#\?:]/g,
        Fb = /[#\?]/g,
        Jb = /[#\?@]/g,
        Hb = /#/g;

    function Cb(a, b) {
      this.g = this.a = null;
      this.h = a || null;
      this.j = !!b;
    }

    function Mb(a) {
      a.a || (a.a = new nb(), a.g = 0, a.h && rb(a.h, function (b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
      }));
    }

    l = Cb.prototype;

    l.add = function (a, b) {
      Mb(this);
      this.h = null;
      a = Nb(this, a);
      var c = this.a.get(a);
      c || this.a.set(a, c = []);
      c.push(b);
      this.g += 1;
      return this;
    };

    function Ob(a, b) {
      Mb(a);
      b = Nb(a, b);
      pb(a.a.g, b) && (a.h = null, a.g -= a.a.get(b).length, a = a.a, pb(a.g, b) && (delete a.g[b], a.h--, a.j++, a.a.length > 2 * a.h && ob(a)));
    }

    l.clear = function () {
      this.a = this.h = null;
      this.g = 0;
    };

    function Pb(a, b) {
      Mb(a);
      b = Nb(a, b);
      return pb(a.a.g, b);
    }

    l.forEach = function (a, b) {
      Mb(this);
      this.a.forEach(function (c, d) {
        Ha(c, function (e) {
          a.call(b, e, d, this);
        }, this);
      }, this);
    };

    l.ja = function () {
      Mb(this);

      for (var a = this.a.la(), b = this.a.ja(), c = [], d = 0; d < b.length; d++) {
        for (var e = a[d], f = 0; f < e.length; f++) {
          c.push(b[d]);
        }
      }

      return c;
    };

    l.la = function (a) {
      Mb(this);
      var b = [];
      if (q(a)) Pb(this, a) && (b = Ra(b, this.a.get(Nb(this, a))));else {
        a = this.a.la();

        for (var c = 0; c < a.length; c++) {
          b = Ra(b, a[c]);
        }
      }
      return b;
    };

    l.set = function (a, b) {
      Mb(this);
      this.h = null;
      a = Nb(this, a);
      Pb(this, a) && (this.g -= this.a.get(a).length);
      this.a.set(a, [b]);
      this.g += 1;
      return this;
    };

    l.get = function (a, b) {
      if (!a) return b;
      a = this.la(a);
      return 0 < a.length ? String(a[0]) : b;
    };

    l.toString = function () {
      if (this.h) return this.h;
      if (!this.a) return "";

      for (var a = [], b = this.a.ja(), c = 0; c < b.length; c++) {
        var d = b[c],
            e = encodeURIComponent(String(d));
        d = this.la(d);

        for (var f = 0; f < d.length; f++) {
          var g = e;
          "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
          a.push(g);
        }
      }

      return this.h = a.join("&");
    };

    function Ab(a) {
      var b = new Cb();
      b.h = a.h;
      a.a && (b.a = new nb(a.a), b.g = a.g);
      return b;
    }

    function Nb(a, b) {
      b = String(b);
      a.j && (b = b.toLowerCase());
      return b;
    }

    function Ib(a, b) {
      b && !a.j && (Mb(a), a.h = null, a.a.forEach(function (c, d) {
        var e = d.toLowerCase();
        d != e && (Ob(this, d), Ob(this, e), 0 < c.length && (this.h = null, this.a.set(Nb(this, e), Sa(c)), this.g += c.length));
      }, a));
      a.j = b;
    }

    function Qb(a) {
      this.a = Kb(a);
    }

    function Rb(a, b) {
      b ? a.a.a.set(x.Sa, b) : Ob(a.a.a, x.Sa);
    }

    function Sb(a, b) {
      null !== b ? a.a.a.set(x.Qa, b ? "1" : "0") : Ob(a.a.a, x.Qa);
    }

    function Tb(a) {
      return a.a.a.get(x.Pa) || null;
    }

    function Ub(a, b) {
      b ? a.a.a.set(x.PROVIDER_ID, b) : Ob(a.a.a, x.PROVIDER_ID);
    }

    Qb.prototype.toString = function () {
      return this.a.toString();
    };

    var x = {
      Pa: "ui_auid",
      jc: "apiKey",
      Qa: "ui_sd",
      ub: "mode",
      $a: "oobCode",
      PROVIDER_ID: "ui_pid",
      Sa: "ui_sid",
      vb: "tenantId"
    };
    var Vb;

    a: {
      var Wb = n.navigator;

      if (Wb) {
        var Xb = Wb.userAgent;

        if (Xb) {
          Vb = Xb;
          break a;
        }
      }

      Vb = "";
    }

    function y(a) {
      return -1 != Vb.indexOf(a);
    }

    function Yb() {
      return (y("Chrome") || y("CriOS")) && !y("Edge");
    }

    function Zb(a) {
      Zb[" "](a);
      return a;
    }

    Zb[" "] = na;

    function $b(a, b) {
      var c = ac;
      return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }

    var bc = y("Opera"),
        z = y("Trident") || y("MSIE"),
        cc = y("Edge"),
        dc = cc || z,
        ec = y("Gecko") && !(-1 != Vb.toLowerCase().indexOf("webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"),
        fc = -1 != Vb.toLowerCase().indexOf("webkit") && !y("Edge"),
        gc = fc && y("Mobile"),
        hc = y("Macintosh");

    function ic() {
      var a = n.document;
      return a ? a.documentMode : void 0;
    }

    var jc;

    a: {
      var kc = "",
          lc = function () {
        var a = Vb;
        if (ec) return /rv:([^\);]+)(\)|;)/.exec(a);
        if (cc) return /Edge\/([\d\.]+)/.exec(a);
        if (z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if (fc) return /WebKit\/(\S+)/.exec(a);
        if (bc) return /(?:Version)[ \/]?(\S+)/.exec(a);
      }();

      lc && (kc = lc ? lc[1] : "");

      if (z) {
        var mc = ic();

        if (null != mc && mc > parseFloat(kc)) {
          jc = String(mc);
          break a;
        }
      }

      jc = kc;
    }

    var ac = {};

    function nc(a) {
      return $b(a, function () {
        for (var b = 0, c = Va(String(jc)).split("."), d = Va(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
          var g = c[f] || "",
              h = d[f] || "";

          do {
            g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
            h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
            if (0 == g[0].length && 0 == h[0].length) break;
            b = cb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || cb(0 == g[2].length, 0 == h[2].length) || cb(g[2], h[2]);
            g = g[3];
            h = h[3];
          } while (0 == b);
        }

        return 0 <= b;
      });
    }

    var oc;
    var pc = n.document;
    oc = pc && z ? ic() || ("CSS1Compat" == pc.compatMode ? parseInt(jc, 10) : 5) : void 0;

    function qc(a, b) {
      this.a = a === rc && b || "";
      this.g = sc;
    }

    qc.prototype.ma = !0;

    qc.prototype.ka = function () {
      return this.a;
    };

    qc.prototype.toString = function () {
      return "Const{" + this.a + "}";
    };

    var sc = {},
        rc = {};

    function tc() {
      this.a = "";
      this.h = uc;
    }

    tc.prototype.ma = !0;

    tc.prototype.ka = function () {
      return this.a.toString();
    };

    tc.prototype.g = function () {
      return 1;
    };

    tc.prototype.toString = function () {
      return "TrustedResourceUrl{" + this.a + "}";
    };

    function vc(a) {
      if (a instanceof tc && a.constructor === tc && a.h === uc) return a.a;
      Fa("expected object of type TrustedResourceUrl, got '" + a + "' of type " + pa(a));
      return "type_error:TrustedResourceUrl";
    }

    function wc() {
      var a = xc;
      a instanceof qc && a.constructor === qc && a.g === sc ? a = a.a : (Fa("expected object of type Const, got '" + a + "'"), a = "type_error:Const");
      var b = new tc();
      b.a = a;
      return b;
    }

    var uc = {};

    function yc() {
      this.a = "";
      this.h = zc;
    }

    yc.prototype.ma = !0;

    yc.prototype.ka = function () {
      return this.a.toString();
    };

    yc.prototype.g = function () {
      return 1;
    };

    yc.prototype.toString = function () {
      return "SafeUrl{" + this.a + "}";
    };

    function Ac(a) {
      if (a instanceof yc && a.constructor === yc && a.h === zc) return a.a;
      Fa("expected object of type SafeUrl, got '" + a + "' of type " + pa(a));
      return "type_error:SafeUrl";
    }

    var Bc = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;

    function Cc(a) {
      if (a instanceof yc) return a;
      a = "object" == typeof a && a.ma ? a.ka() : String(a);
      Bc.test(a) || (a = "about:invalid#zClosurez");
      return Dc(a);
    }

    function Ec(a) {
      if (a instanceof yc) return a;
      a = "object" == typeof a && a.ma ? a.ka() : String(a);
      Bc.test(a) || (a = "about:invalid#zClosurez");
      return Dc(a);
    }

    var zc = {};

    function Dc(a) {
      var b = new yc();
      b.a = a;
      return b;
    }

    Dc("about:blank");

    function Fc() {
      this.a = "";
      this.g = Gc;
    }

    Fc.prototype.ma = !0;
    var Gc = {};

    Fc.prototype.ka = function () {
      return this.a;
    };

    Fc.prototype.toString = function () {
      return "SafeStyle{" + this.a + "}";
    };

    function Hc() {
      this.a = "";
      this.j = Ic;
      this.h = null;
    }

    Hc.prototype.g = function () {
      return this.h;
    };

    Hc.prototype.ma = !0;

    Hc.prototype.ka = function () {
      return this.a.toString();
    };

    Hc.prototype.toString = function () {
      return "SafeHtml{" + this.a + "}";
    };

    function Jc(a) {
      if (a instanceof Hc && a.constructor === Hc && a.j === Ic) return a.a;
      Fa("expected object of type SafeHtml, got '" + a + "' of type " + pa(a));
      return "type_error:SafeHtml";
    }

    var Ic = {};

    function Kc(a, b) {
      var c = new Hc();
      c.a = a;
      c.h = b;
      return c;
    }

    Kc("<!DOCTYPE html>", 0);
    var Lc = Kc("", 0);
    Kc("<br>", 0);

    var Mc = function (a) {
      var b = !1,
          c;
      return function () {
        b || (c = a(), b = !0);
        return c;
      };
    }(function () {
      if ("undefined" === typeof document) return !1;
      var a = document.createElement("div"),
          b = document.createElement("div");
      b.appendChild(document.createElement("div"));
      a.appendChild(b);
      if (!a.firstChild) return !1;
      b = a.firstChild.firstChild;
      a.innerHTML = Jc(Lc);
      return !b.parentElement;
    });

    function Nc(a, b) {
      a.src = vc(b);
      if (null === ma) b: {
        b = n.document;

        if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && la.test(b)) {
          ma = b;
          break b;
        }

        ma = "";
      }
      b = ma;
      b && a.setAttribute("nonce", b);
    }

    function Oc(a, b) {
      b = b instanceof yc ? b : Ec(b);
      a.assign(Ac(b));
    }

    function Pc(a, b) {
      this.a = ka(a) ? a : 0;
      this.g = ka(b) ? b : 0;
    }

    Pc.prototype.toString = function () {
      return "(" + this.a + ", " + this.g + ")";
    };

    Pc.prototype.ceil = function () {
      this.a = Math.ceil(this.a);
      this.g = Math.ceil(this.g);
      return this;
    };

    Pc.prototype.floor = function () {
      this.a = Math.floor(this.a);
      this.g = Math.floor(this.g);
      return this;
    };

    Pc.prototype.round = function () {
      this.a = Math.round(this.a);
      this.g = Math.round(this.g);
      return this;
    };

    function Qc(a, b) {
      this.width = a;
      this.height = b;
    }

    l = Qc.prototype;

    l.toString = function () {
      return "(" + this.width + " x " + this.height + ")";
    };

    l.aspectRatio = function () {
      return this.width / this.height;
    };

    l.ceil = function () {
      this.width = Math.ceil(this.width);
      this.height = Math.ceil(this.height);
      return this;
    };

    l.floor = function () {
      this.width = Math.floor(this.width);
      this.height = Math.floor(this.height);
      return this;
    };

    l.round = function () {
      this.width = Math.round(this.width);
      this.height = Math.round(this.height);
      return this;
    };

    function Rc(a) {
      return a ? new Sc(Tc(a)) : Da || (Da = new Sc());
    }

    function Uc(a, b) {
      var c = b || document;
      return c.querySelectorAll && c.querySelector ? c.querySelectorAll("." + a) : Vc(document, a, b);
    }

    function Wc(a, b) {
      var c = b || document;
      if (c.getElementsByClassName) a = c.getElementsByClassName(a)[0];else {
        c = document;
        var d = b || c;
        a = d.querySelectorAll && d.querySelector && a ? d.querySelector(a ? "." + a : "") : Vc(c, a, b)[0] || null;
      }
      return a || null;
    }

    function Vc(a, b, c) {
      var d;
      a = c || a;
      if (a.querySelectorAll && a.querySelector && b) return a.querySelectorAll(b ? "." + b : "");

      if (b && a.getElementsByClassName) {
        var e = a.getElementsByClassName(b);
        return e;
      }

      e = a.getElementsByTagName("*");

      if (b) {
        var f = {};

        for (c = d = 0; a = e[c]; c++) {
          var g = a.className;
          "function" == typeof g.split && Ma(g.split(/\s+/), b) && (f[d++] = a);
        }

        f.length = d;
        return f;
      }

      return e;
    }

    function Xc(a, b) {
      eb(b, function (c, d) {
        c && "object" == typeof c && c.ma && (c = c.ka());
        "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : Yc.hasOwnProperty(d) ? a.setAttribute(Yc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
      });
    }

    var Yc = {
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      colspan: "colSpan",
      frameborder: "frameBorder",
      height: "height",
      maxlength: "maxLength",
      nonce: "nonce",
      role: "role",
      rowspan: "rowSpan",
      type: "type",
      usemap: "useMap",
      valign: "vAlign",
      width: "width"
    };

    function Zc(a) {
      return a.scrollingElement ? a.scrollingElement : fc || "CSS1Compat" != a.compatMode ? a.body || a.documentElement : a.documentElement;
    }

    function $c(a) {
      a && a.parentNode && a.parentNode.removeChild(a);
    }

    function Tc(a) {
      return 9 == a.nodeType ? a : a.ownerDocument || a.document;
    }

    function ad(a, b) {
      if ("textContent" in a) a.textContent = b;else if (3 == a.nodeType) a.data = String(b);else if (a.firstChild && 3 == a.firstChild.nodeType) {
        for (; a.lastChild != a.firstChild;) {
          a.removeChild(a.lastChild);
        }

        a.firstChild.data = String(b);
      } else {
        for (var c; c = a.firstChild;) {
          a.removeChild(c);
        }

        a.appendChild(Tc(a).createTextNode(String(b)));
      }
    }

    function bd(a, b) {
      return b ? cd(a, function (c) {
        return !b || q(c.className) && Ma(c.className.split(/\s+/), b);
      }) : null;
    }

    function cd(a, b) {
      for (var c = 0; a;) {
        if (b(a)) return a;
        a = a.parentNode;
        c++;
      }

      return null;
    }

    function Sc(a) {
      this.a = a || n.document || document;
    }

    Sc.prototype.N = function () {
      return q(void 0) ? this.a.getElementById(void 0) : void 0;
    };

    var dd = {
      Dc: !0
    },
        ed = {
      Fc: !0
    },
        fd = {
      Cc: !0
    },
        gd = {
      Ec: !0
    };

    function hd() {
      throw Error("Do not instantiate directly");
    }

    hd.prototype.va = null;

    hd.prototype.toString = function () {
      return this.content;
    };

    function id(a, b, c, d) {
      a = a(b || ld, void 0, c);
      d = (d || Rc()).a.createElement("DIV");
      a = md(a);
      a.match(nd);
      a = Kc(a, null);
      if (Mc()) for (; d.lastChild;) {
        d.removeChild(d.lastChild);
      }
      d.innerHTML = Jc(a);
      1 == d.childNodes.length && (a = d.firstChild, 1 == a.nodeType && (d = a));
      return d;
    }

    function md(a) {
      if (!ta(a)) return db(String(a));

      if (a instanceof hd) {
        if (a.fa === dd) return a.content;
        if (a.fa === gd) return db(a.content);
      }

      Fa("Soy template output is unsafe for use as HTML: " + a);
      return "zSoyz";
    }

    var nd = /^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,
        ld = {};

    function od(a) {
      if (null != a) switch (a.va) {
        case 1:
          return 1;

        case -1:
          return -1;

        case 0:
          return 0;
      }
      return null;
    }

    function pd() {
      hd.call(this);
    }

    w(pd, hd);
    pd.prototype.fa = dd;

    function A(a) {
      return null != a && a.fa === dd ? a : a instanceof Hc ? B(Jc(a).toString(), a.g()) : B(db(String(String(a))), od(a));
    }

    function qd() {
      hd.call(this);
    }

    w(qd, hd);
    qd.prototype.fa = ed;
    qd.prototype.va = 1;

    function rd(a, b) {
      this.content = String(a);
      this.va = null != b ? b : null;
    }

    w(rd, hd);
    rd.prototype.fa = gd;

    function C(a) {
      return new rd(a, void 0);
    }

    var B = function (a) {
      function b(c) {
        this.content = c;
      }

      b.prototype = a.prototype;
      return function (c, d) {
        c = new b(String(c));
        void 0 !== d && (c.va = d);
        return c;
      };
    }(pd),
        sd = function (a) {
      function b(c) {
        this.content = c;
      }

      b.prototype = a.prototype;
      return function (c) {
        return new b(String(c));
      };
    }(qd);

    function td(a) {
      function b() {}

      var c = {
        label: D("New password")
      };
      b.prototype = a;
      a = new b();

      for (var d in c) {
        a[d] = c[d];
      }

      return a;
    }

    function D(a) {
      return (a = String(a)) ? new rd(a, void 0) : "";
    }

    var ud = function (a) {
      function b(c) {
        this.content = c;
      }

      b.prototype = a.prototype;
      return function (c, d) {
        c = String(c);
        if (!c) return "";
        c = new b(c);
        void 0 !== d && (c.va = d);
        return c;
      };
    }(pd);

    function vd(a) {
      return null != a && a.fa === dd ? String(String(a.content).replace(wd, "").replace(xd, "&lt;")).replace(yd, zd) : db(String(a));
    }

    function Ad(a) {
      null != a && a.fa === ed ? a = String(a).replace(Bd, Cd) : a instanceof yc ? a = String(Ac(a).toString()).replace(Bd, Cd) : (a = String(a), Dd.test(a) ? a = a.replace(Bd, Cd) : (Fa("Bad value `%s` for |filterNormalizeUri", [a]), a = "#zSoyz"));
      return a;
    }

    function Ed(a) {
      null != a && a.fa === fd ? a = a.content : null == a ? a = "" : a instanceof Fc ? a instanceof Fc && a.constructor === Fc && a.g === Gc ? a = a.a : (Fa("expected object of type SafeStyle, got '" + a + "' of type " + pa(a)), a = "type_error:SafeStyle") : (a = String(a), Fd.test(a) || (Fa("Bad value `%s` for |filterCssValue", [a]), a = "zSoyz"));
      return a;
    }

    var Gd = {
      "\x00": "&#0;",
      "\t": "&#9;",
      "\n": "&#10;",
      "\x0B": "&#11;",
      "\f": "&#12;",
      "\r": "&#13;",
      " ": "&#32;",
      '"': "&quot;",
      "&": "&amp;",
      "'": "&#39;",
      "-": "&#45;",
      "/": "&#47;",
      "<": "&lt;",
      "=": "&#61;",
      ">": "&gt;",
      "`": "&#96;",
      "\x85": "&#133;",
      "\xA0": "&#160;",
      "\u2028": "&#8232;",
      "\u2029": "&#8233;"
    };

    function zd(a) {
      return Gd[a];
    }

    var Hd = {
      "\x00": "%00",
      "\x01": "%01",
      "\x02": "%02",
      "\x03": "%03",
      "\x04": "%04",
      "\x05": "%05",
      "\x06": "%06",
      "\x07": "%07",
      "\b": "%08",
      "\t": "%09",
      "\n": "%0A",
      "\x0B": "%0B",
      "\f": "%0C",
      "\r": "%0D",
      "\x0E": "%0E",
      "\x0F": "%0F",
      "\x10": "%10",
      "\x11": "%11",
      "\x12": "%12",
      "\x13": "%13",
      "\x14": "%14",
      "\x15": "%15",
      "\x16": "%16",
      "\x17": "%17",
      "\x18": "%18",
      "\x19": "%19",
      "\x1A": "%1A",
      "\x1B": "%1B",
      "\x1C": "%1C",
      "\x1D": "%1D",
      "\x1E": "%1E",
      "\x1F": "%1F",
      " ": "%20",
      '"': "%22",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "<": "%3C",
      ">": "%3E",
      "\\": "%5C",
      "{": "%7B",
      "}": "%7D",
      "\x7F": "%7F",
      "\x85": "%C2%85",
      "\xA0": "%C2%A0",
      "\u2028": "%E2%80%A8",
      "\u2029": "%E2%80%A9",
      "\uFF01": "%EF%BC%81",
      "\uFF03": "%EF%BC%83",
      "\uFF04": "%EF%BC%84",
      "\uFF06": "%EF%BC%86",
      "\uFF07": "%EF%BC%87",
      "\uFF08": "%EF%BC%88",
      "\uFF09": "%EF%BC%89",
      "\uFF0A": "%EF%BC%8A",
      "\uFF0B": "%EF%BC%8B",
      "\uFF0C": "%EF%BC%8C",
      "\uFF0F": "%EF%BC%8F",
      "\uFF1A": "%EF%BC%9A",
      "\uFF1B": "%EF%BC%9B",
      "\uFF1D": "%EF%BC%9D",
      "\uFF1F": "%EF%BC%9F",
      "\uFF20": "%EF%BC%A0",
      "\uFF3B": "%EF%BC%BB",
      "\uFF3D": "%EF%BC%BD"
    };

    function Cd(a) {
      return Hd[a];
    }

    var yd = /[\x00\x22\x27\x3c\x3e]/g,
        Bd = /[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
        Fd = /^(?!-*(?:expression|(?:moz-)?binding))(?:[.#]?-?(?:[_a-z0-9-]+)(?:-[_a-z0-9-]+)*-?|-?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)(?:[a-z]{1,2}|%)?|!important|)$/i,
        Dd = /^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,
        wd = /<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,
        xd = /</g;

    function Id() {
      return C("Enter a valid phone number");
    }

    function Jd() {
      return C("Unable to send password reset code to specified email");
    }

    function Kd() {
      return C("Something went wrong. Please try again.");
    }

    function Ld() {
      return C("This email already exists without any means of sign-in. Please reset the password to recover.");
    }

    function Md(a) {
      a = a || {};
      var b = "";

      switch (a.code) {
        case "invalid-argument":
          b += "Client specified an invalid argument.";
          break;

        case "invalid-configuration":
          b += "Client specified an invalid project configuration.";
          break;

        case "failed-precondition":
          b += "Request can not be executed in the current system state.";
          break;

        case "out-of-range":
          b += "Client specified an invalid range.";
          break;

        case "unauthenticated":
          b += "Request not authenticated due to missing, invalid, or expired OAuth token.";
          break;

        case "permission-denied":
          b += "Client does not have sufficient permission.";
          break;

        case "not-found":
          b += "Specified resource is not found.";
          break;

        case "aborted":
          b += "Concurrency conflict, such as read-modify-write conflict.";
          break;

        case "already-exists":
          b += "The resource that a client tried to create already exists.";
          break;

        case "resource-exhausted":
          b += "Either out of resource quota or reaching rate limiting.";
          break;

        case "cancelled":
          b += "Request cancelled by the client.";
          break;

        case "data-loss":
          b += "Unrecoverable data loss or data corruption.";
          break;

        case "unknown":
          b += "Unknown server error.";
          break;

        case "internal":
          b += "Internal server error.";
          break;

        case "not-implemented":
          b += "API method not implemented by the server.";
          break;

        case "unavailable":
          b += "Service unavailable.";
          break;

        case "deadline-exceeded":
          b += "Request deadline exceeded.";
          break;

        case "auth/user-disabled":
          b += "The user account has been disabled by an administrator.";
          break;

        case "auth/timeout":
          b += "The operation has timed out.";
          break;

        case "auth/too-many-requests":
          b += "We have blocked all requests from this device due to unusual activity. Try again later.";
          break;

        case "auth/quota-exceeded":
          b += "The quota for this operation has been exceeded. Try again later.";
          break;

        case "auth/network-request-failed":
          b += "A network error has occurred. Try again later.";
          break;

        case "restart-process":
          b += "An issue was encountered when authenticating your request. Please visit the URL that redirected you to this page again to restart the authentication process.";
          break;

        case "no-matching-tenant-for-email":
          b += "No sign-in provider is available for the given email, please try with a different email.";
      }

      return C(b);
    }

    function Nd() {
      return C("Please login again to perform this operation");
    }

    function Od(a, b, c) {
      var d = Error.call(this);
      this.message = d.message;
      "stack" in d && (this.stack = d.stack);
      this.code = Pd + a;

      if (!(a = b)) {
        a = "";

        switch (this.code) {
          case "firebaseui/merge-conflict":
            a += "The current anonymous user failed to upgrade. The non-anonymous credential is already associated with a different user account.";
            break;

          default:
            a += Kd();
        }

        a = C(a).toString();
      }

      this.message = a || "";
      this.credential = c || null;
    }

    m(Od, Error);

    Od.prototype.toJSON = function () {
      return {
        code: this.code,
        message: this.message
      };
    };

    var Pd = "firebaseui/";

    function Qd() {
      0 != Rd && (Sd[this[ua] || (this[ua] = ++va)] = this);
      this.T = this.T;
      this.C = this.C;
    }

    var Rd = 0,
        Sd = {};
    Qd.prototype.T = !1;

    Qd.prototype.o = function () {
      if (!this.T && (this.T = !0, this.m(), 0 != Rd)) {
        var a = this[ua] || (this[ua] = ++va);
        if (0 != Rd && this.C && 0 < this.C.length) throw Error(this + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
        delete Sd[a];
      }
    };

    function Td(a, b) {
      a.T ? ka(void 0) ? b.call(void 0) : b() : (a.C || (a.C = []), a.C.push(ka(void 0) ? t(b, void 0) : b));
    }

    Qd.prototype.m = function () {
      if (this.C) for (; this.C.length;) {
        this.C.shift()();
      }
    };

    function Ud(a) {
      a && "function" == typeof a.o && a.o();
    }

    var Vd = Object.freeze || function (a) {
      return a;
    };

    var Wd = !z || 9 <= Number(oc),
        Xd = z && !nc("9"),
        Yd = function () {
      if (!n.addEventListener || !Object.defineProperty) return !1;
      var a = !1,
          b = Object.defineProperty({}, "passive", {
        get: function get() {
          a = !0;
        }
      });

      try {
        n.addEventListener("test", na, b), n.removeEventListener("test", na, b);
      } catch (c) {}

      return a;
    }();

    function Zd(a, b) {
      this.type = a;
      this.g = this.target = b;
      this.h = !1;
      this.qb = !0;
    }

    Zd.prototype.stopPropagation = function () {
      this.h = !0;
    };

    Zd.prototype.preventDefault = function () {
      this.qb = !1;
    };

    function $d(a, b) {
      Zd.call(this, a ? a.type : "");
      this.relatedTarget = this.g = this.target = null;
      this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
      this.key = "";
      this.j = this.keyCode = 0;
      this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
      this.pointerId = 0;
      this.pointerType = "";
      this.a = null;

      if (a) {
        var c = this.type = a.type,
            d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;

        if (b = a.relatedTarget) {
          if (ec) {
            a: {
              try {
                Zb(b.nodeName);
                var e = !0;
                break a;
              } catch (f) {}

              e = !1;
            }

            e || (b = null);
          }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);

        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.keyCode = a.keyCode || 0;
        this.key = a.key || "";
        this.j = a.charCode || ("keypress" == c ? a.keyCode : 0);
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = q(a.pointerType) ? a.pointerType : ae[a.pointerType] || "";
        this.a = a;
        a.defaultPrevented && this.preventDefault();
      }
    }

    w($d, Zd);
    var ae = Vd({
      2: "touch",
      3: "pen",
      4: "mouse"
    });

    $d.prototype.stopPropagation = function () {
      $d.K.stopPropagation.call(this);
      this.a.stopPropagation ? this.a.stopPropagation() : this.a.cancelBubble = !0;
    };

    $d.prototype.preventDefault = function () {
      $d.K.preventDefault.call(this);
      var a = this.a;
      if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Xd) try {
        if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
      } catch (b) {}
    };

    var be = "closure_listenable_" + (1E6 * Math.random() | 0),
        ce = 0;

    function de(a, b, c, d, e) {
      this.listener = a;
      this.proxy = null;
      this.src = b;
      this.type = c;
      this.capture = !!d;
      this.La = e;
      this.key = ++ce;
      this.sa = this.Ia = !1;
    }

    function ee(a) {
      a.sa = !0;
      a.listener = null;
      a.proxy = null;
      a.src = null;
      a.La = null;
    }

    function fe(a) {
      this.src = a;
      this.a = {};
      this.g = 0;
    }

    fe.prototype.add = function (a, b, c, d, e) {
      var f = a.toString();
      a = this.a[f];
      a || (a = this.a[f] = [], this.g++);
      var g = ge(a, b, d, e);
      -1 < g ? (b = a[g], c || (b.Ia = !1)) : (b = new de(b, this.src, f, !!d, e), b.Ia = c, a.push(b));
      return b;
    };

    function he(a, b) {
      var c = b.type;
      c in a.a && Na(a.a[c], b) && (ee(b), 0 == a.a[c].length && (delete a.a[c], a.g--));
    }

    function ge(a, b, c, d) {
      for (var e = 0; e < a.length; ++e) {
        var f = a[e];
        if (!f.sa && f.listener == b && f.capture == !!c && f.La == d) return e;
      }

      return -1;
    }

    var ie = "closure_lm_" + (1E6 * Math.random() | 0),
        je = {},
        ke = 0;

    function le(a, b, c, d, e) {
      if (d && d.once) return me(a, b, c, d, e);

      if (qa(b)) {
        for (var f = 0; f < b.length; f++) {
          le(a, b[f], c, d, e);
        }

        return null;
      }

      c = ne(c);
      return a && a[be] ? a.J.add(String(b), c, !1, ta(d) ? !!d.capture : !!d, e) : oe(a, b, c, !1, d, e);
    }

    function oe(a, b, c, d, e, f) {
      if (!b) throw Error("Invalid event type");
      var g = ta(e) ? !!e.capture : !!e,
          h = pe(a);
      h || (a[ie] = h = new fe(a));
      c = h.add(b, c, d, g, f);
      if (c.proxy) return c;
      d = qe();
      c.proxy = d;
      d.src = a;
      d.listener = c;
      if (a.addEventListener) Yd || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(re(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");
      ke++;
      return c;
    }

    function qe() {
      var a = se,
          b = Wd ? function (c) {
        return a.call(b.src, b.listener, c);
      } : function (c) {
        c = a.call(b.src, b.listener, c);
        if (!c) return c;
      };
      return b;
    }

    function me(a, b, c, d, e) {
      if (qa(b)) {
        for (var f = 0; f < b.length; f++) {
          me(a, b[f], c, d, e);
        }

        return null;
      }

      c = ne(c);
      return a && a[be] ? a.J.add(String(b), c, !0, ta(d) ? !!d.capture : !!d, e) : oe(a, b, c, !0, d, e);
    }

    function te(a, b, c, d, e) {
      if (qa(b)) for (var f = 0; f < b.length; f++) {
        te(a, b[f], c, d, e);
      } else (d = ta(d) ? !!d.capture : !!d, c = ne(c), a && a[be]) ? (a = a.J, b = String(b).toString(), b in a.a && (f = a.a[b], c = ge(f, c, d, e), -1 < c && (ee(f[c]), Oa(f, c), 0 == f.length && (delete a.a[b], a.g--)))) : a && (a = pe(a)) && (b = a.a[b.toString()], a = -1, b && (a = ge(b, c, d, e)), (c = -1 < a ? b[a] : null) && ue(c));
    }

    function ue(a) {
      if ("number" != typeof a && a && !a.sa) {
        var b = a.src;
        if (b && b[be]) he(b.J, a);else {
          var c = a.type,
              d = a.proxy;
          b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(re(c), d) : b.addListener && b.removeListener && b.removeListener(d);
          ke--;
          (c = pe(b)) ? (he(c, a), 0 == c.g && (c.src = null, b[ie] = null)) : ee(a);
        }
      }
    }

    function re(a) {
      return a in je ? je[a] : je[a] = "on" + a;
    }

    function ve(a, b, c, d) {
      var e = !0;
      if (a = pe(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
        var f = b[a];
        f && f.capture == c && !f.sa && (f = we(f, d), e = e && !1 !== f);
      }
      return e;
    }

    function we(a, b) {
      var c = a.listener,
          d = a.La || a.src;
      a.Ia && ue(a);
      return c.call(d, b);
    }

    function se(a, b) {
      if (a.sa) return !0;

      if (!Wd) {
        if (!b) a: {
          b = ["window", "event"];

          for (var c = n, d = 0; d < b.length; d++) {
            if (c = c[b[d]], null == c) {
              b = null;
              break a;
            }
          }

          b = c;
        }
        d = b;
        b = new $d(d, this);
        c = !0;

        if (!(0 > d.keyCode || void 0 != d.returnValue)) {
          a: {
            var e = !1;
            if (0 == d.keyCode) try {
              d.keyCode = -1;
              break a;
            } catch (g) {
              e = !0;
            }
            if (e || void 0 == d.returnValue) d.returnValue = !0;
          }

          d = [];

          for (e = b.g; e; e = e.parentNode) {
            d.push(e);
          }

          a = a.type;

          for (e = d.length - 1; !b.h && 0 <= e; e--) {
            b.g = d[e];
            var f = ve(d[e], a, !0, b);
            c = c && f;
          }

          for (e = 0; !b.h && e < d.length; e++) {
            b.g = d[e], f = ve(d[e], a, !1, b), c = c && f;
          }
        }

        return c;
      }

      return we(a, new $d(b, this));
    }

    function pe(a) {
      a = a[ie];
      return a instanceof fe ? a : null;
    }

    var xe = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

    function ne(a) {
      if (sa(a)) return a;
      a[xe] || (a[xe] = function (b) {
        return a.handleEvent(b);
      });
      return a[xe];
    }

    function E() {
      Qd.call(this);
      this.J = new fe(this);
      this.wb = this;
      this.Ha = null;
    }

    w(E, Qd);
    E.prototype[be] = !0;

    E.prototype.Za = function (a) {
      this.Ha = a;
    };

    E.prototype.removeEventListener = function (a, b, c, d) {
      te(this, a, b, c, d);
    };

    function ye(a, b) {
      var c,
          d = a.Ha;
      if (d) for (c = []; d; d = d.Ha) {
        c.push(d);
      }
      a = a.wb;
      d = b.type || b;
      if (q(b)) b = new Zd(b, a);else if (b instanceof Zd) b.target = b.target || a;else {
        var e = b;
        b = new Zd(d, a);
        hb(b, e);
      }
      e = !0;
      if (c) for (var f = c.length - 1; !b.h && 0 <= f; f--) {
        var g = b.g = c[f];
        e = ze(g, d, !0, b) && e;
      }
      b.h || (g = b.g = a, e = ze(g, d, !0, b) && e, b.h || (e = ze(g, d, !1, b) && e));
      if (c) for (f = 0; !b.h && f < c.length; f++) {
        g = b.g = c[f], e = ze(g, d, !1, b) && e;
      }
      return e;
    }

    E.prototype.m = function () {
      E.K.m.call(this);

      if (this.J) {
        var a = this.J,
            b = 0,
            c;

        for (c in a.a) {
          for (var d = a.a[c], e = 0; e < d.length; e++) {
            ++b, ee(d[e]);
          }

          delete a.a[c];
          a.g--;
        }
      }

      this.Ha = null;
    };

    function ze(a, b, c, d) {
      b = a.J.a[String(b)];
      if (!b) return !0;
      b = b.concat();

      for (var e = !0, f = 0; f < b.length; ++f) {
        var g = b[f];

        if (g && !g.sa && g.capture == c) {
          var h = g.listener,
              k = g.La || g.src;
          g.Ia && he(a.J, g);
          e = !1 !== h.call(k, d) && e;
        }
      }

      return e && 0 != d.qb;
    }

    var Ae = {},
        Be = 0;

    function Ce(a, b) {
      if (!a) throw Error("Event target element must be provided!");
      a = De(a);
      if (Ae[a] && Ae[a].length) for (var c = 0; c < Ae[a].length; c++) {
        ye(Ae[a][c], b);
      }
    }

    function Ee(a) {
      var b = De(a.N());
      Ae[b] && Ae[b].length && (Pa(Ae[b], function (c) {
        return c == a;
      }), Ae[b].length || delete Ae[b]);
    }

    function De(a) {
      "undefined" === typeof a.a && (a.a = Be, Be++);
      return a.a;
    }

    function Fe(a) {
      if (!a) throw Error("Event target element must be provided!");
      E.call(this);
      this.a = a;
    }

    m(Fe, E);

    Fe.prototype.N = function () {
      return this.a;
    };

    Fe.prototype.register = function () {
      var a = De(this.N());
      Ae[a] ? Ma(Ae[a], this) || Ae[a].push(this) : Ae[a] = [this];
    };

    function Ge(a) {
      if (!a) return !1;

      try {
        return !!a.$goog_Thenable;
      } catch (b) {
        return !1;
      }
    }

    function He(a, b) {
      this.h = a;
      this.j = b;
      this.g = 0;
      this.a = null;
    }

    He.prototype.get = function () {
      if (0 < this.g) {
        this.g--;
        var a = this.a;
        this.a = a.next;
        a.next = null;
      } else a = this.h();

      return a;
    };

    function Ie(a, b) {
      a.j(b);
      100 > a.g && (a.g++, b.next = a.a, a.a = b);
    }

    function Je() {
      this.g = this.a = null;
    }

    var Le = new He(function () {
      return new Ke();
    }, function (a) {
      a.reset();
    });

    Je.prototype.add = function (a, b) {
      var c = Le.get();
      c.set(a, b);
      this.g ? this.g.next = c : this.a = c;
      this.g = c;
    };

    function Me() {
      var a = Ne,
          b = null;
      a.a && (b = a.a, a.a = a.a.next, a.a || (a.g = null), b.next = null);
      return b;
    }

    function Ke() {
      this.next = this.g = this.a = null;
    }

    Ke.prototype.set = function (a, b) {
      this.a = a;
      this.g = b;
      this.next = null;
    };

    Ke.prototype.reset = function () {
      this.next = this.g = this.a = null;
    };

    function Oe(a) {
      n.setTimeout(function () {
        throw a;
      }, 0);
    }

    var Pe;

    function Qe() {
      var a = n.MessageChannel;
      "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function a() {
        var e = document.createElement("IFRAME");
        e.style.display = "none";
        e.src = "";
        document.documentElement.appendChild(e);
        var f = e.contentWindow;
        e = f.document;
        e.open();
        e.write("");
        e.close();
        var g = "callImmediate" + Math.random(),
            h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
        e = t(function (k) {
          if (("*" == h || k.origin == h) && k.data == g) this.port1.onmessage();
        }, this);
        f.addEventListener("message", e, !1);
        this.port1 = {};
        this.port2 = {
          postMessage: function postMessage() {
            f.postMessage(g, h);
          }
        };
      });

      if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
        var b = new a(),
            c = {},
            d = c;

        b.port1.onmessage = function () {
          if (ka(c.next)) {
            c = c.next;
            var e = c.gb;
            c.gb = null;
            e();
          }
        };

        return function (e) {
          d.next = {
            gb: e
          };
          d = d.next;
          b.port2.postMessage(0);
        };
      }

      return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (e) {
        var f = document.createElement("SCRIPT");

        f.onreadystatechange = function () {
          f.onreadystatechange = null;
          f.parentNode.removeChild(f);
          f = null;
          e();
          e = null;
        };

        document.documentElement.appendChild(f);
      } : function (e) {
        n.setTimeout(e, 0);
      };
    }

    function Re(a, b) {
      Se || Te();
      Ue || (Se(), Ue = !0);
      Ne.add(a, b);
    }

    var Se;

    function Te() {
      if (n.Promise && n.Promise.resolve) {
        var a = n.Promise.resolve(void 0);

        Se = function Se() {
          a.then(Ve);
        };
      } else Se = function Se() {
        var b = Ve;
        !sa(n.setImmediate) || n.Window && n.Window.prototype && !y("Edge") && n.Window.prototype.setImmediate == n.setImmediate ? (Pe || (Pe = Qe()), Pe(b)) : n.setImmediate(b);
      };
    }

    var Ue = !1,
        Ne = new Je();

    function Ve() {
      for (var a; a = Me();) {
        try {
          a.a.call(a.g);
        } catch (b) {
          Oe(b);
        }

        Ie(Le, a);
      }

      Ue = !1;
    }

    function F(a) {
      this.a = We;
      this.A = void 0;
      this.j = this.g = this.h = null;
      this.s = this.i = !1;
      if (a != na) try {
        var b = this;
        a.call(void 0, function (c) {
          Xe(b, Ye, c);
        }, function (c) {
          if (!(c instanceof Ze)) try {
            if (c instanceof Error) throw c;
            throw Error("Promise rejected.");
          } catch (d) {}
          Xe(b, $e, c);
        });
      } catch (c) {
        Xe(this, $e, c);
      }
    }

    var We = 0,
        Ye = 2,
        $e = 3;

    function af() {
      this.next = this.j = this.g = this.s = this.a = null;
      this.h = !1;
    }

    af.prototype.reset = function () {
      this.j = this.g = this.s = this.a = null;
      this.h = !1;
    };

    var bf = new He(function () {
      return new af();
    }, function (a) {
      a.reset();
    });

    function cf(a, b, c) {
      var d = bf.get();
      d.s = a;
      d.g = b;
      d.j = c;
      return d;
    }

    function G(a) {
      if (a instanceof F) return a;
      var b = new F(na);
      Xe(b, Ye, a);
      return b;
    }

    function df(a) {
      return new F(function (b, c) {
        c(a);
      });
    }

    F.prototype.then = function (a, b, c) {
      return ef(this, sa(a) ? a : null, sa(b) ? b : null, c);
    };

    F.prototype.$goog_Thenable = !0;
    l = F.prototype;

    l.dc = function (a, b) {
      a = cf(a, a, b);
      a.h = !0;
      ff(this, a);
      return this;
    };

    l.Ca = function (a, b) {
      return ef(this, null, a, b);
    };

    l.cancel = function (a) {
      this.a == We && Re(function () {
        var b = new Ze(a);
        gf(this, b);
      }, this);
    };

    function gf(a, b) {
      if (a.a == We) if (a.h) {
        var c = a.h;

        if (c.g) {
          for (var d = 0, e = null, f = null, g = c.g; g && (g.h || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next) {
            e || (f = g);
          }

          e && (c.a == We && 1 == d ? gf(c, b) : (f ? (d = f, d.next == c.j && (c.j = d), d.next = d.next.next) : hf(c), jf(c, e, $e, b)));
        }

        a.h = null;
      } else Xe(a, $e, b);
    }

    function ff(a, b) {
      a.g || a.a != Ye && a.a != $e || kf(a);
      a.j ? a.j.next = b : a.g = b;
      a.j = b;
    }

    function ef(a, b, c, d) {
      var e = cf(null, null, null);
      e.a = new F(function (f, g) {
        e.s = b ? function (h) {
          try {
            var k = b.call(d, h);
            f(k);
          } catch (p) {
            g(p);
          }
        } : f;
        e.g = c ? function (h) {
          try {
            var k = c.call(d, h);
            !ka(k) && h instanceof Ze ? g(h) : f(k);
          } catch (p) {
            g(p);
          }
        } : g;
      });
      e.a.h = a;
      ff(a, e);
      return e.a;
    }

    l.fc = function (a) {
      this.a = We;
      Xe(this, Ye, a);
    };

    l.gc = function (a) {
      this.a = We;
      Xe(this, $e, a);
    };

    function Xe(a, b, c) {
      if (a.a == We) {
        a === c && (b = $e, c = new TypeError("Promise cannot resolve to itself"));
        a.a = 1;

        a: {
          var d = c,
              e = a.fc,
              f = a.gc;

          if (d instanceof F) {
            ff(d, cf(e || na, f || null, a));
            var g = !0;
          } else if (Ge(d)) d.then(e, f, a), g = !0;else {
            if (ta(d)) try {
              var h = d.then;

              if (sa(h)) {
                lf(d, h, e, f, a);
                g = !0;
                break a;
              }
            } catch (k) {
              f.call(a, k);
              g = !0;
              break a;
            }
            g = !1;
          }
        }

        g || (a.A = c, a.a = b, a.h = null, kf(a), b != $e || c instanceof Ze || mf(a, c));
      }
    }

    function lf(a, b, c, d, e) {
      function f(k) {
        h || (h = !0, d.call(e, k));
      }

      function g(k) {
        h || (h = !0, c.call(e, k));
      }

      var h = !1;

      try {
        b.call(a, g, f);
      } catch (k) {
        f(k);
      }
    }

    function kf(a) {
      a.i || (a.i = !0, Re(a.Fb, a));
    }

    function hf(a) {
      var b = null;
      a.g && (b = a.g, a.g = b.next, b.next = null);
      a.g || (a.j = null);
      return b;
    }

    l.Fb = function () {
      for (var a; a = hf(this);) {
        jf(this, a, this.a, this.A);
      }

      this.i = !1;
    };

    function jf(a, b, c, d) {
      if (c == $e && b.g && !b.h) for (; a && a.s; a = a.h) {
        a.s = !1;
      }
      if (b.a) b.a.h = null, nf(b, c, d);else try {
        b.h ? b.s.call(b.j) : nf(b, c, d);
      } catch (e) {
        of.call(null, e);
      }
      Ie(bf, b);
    }

    function nf(a, b, c) {
      b == Ye ? a.s.call(a.j, c) : a.g && a.g.call(a.j, c);
    }

    function mf(a, b) {
      a.s = !0;
      Re(function () {
        a.s && of.call(null, b);
      });
    }

    var of = Oe;

    function Ze(a) {
      Ca.call(this, a);
    }

    w(Ze, Ca);
    Ze.prototype.name = "cancel";

    function pf(a, b, c) {
      b || (b = {});
      c = c || window;
      var d = a instanceof yc ? a : Cc("undefined" != typeof a.href ? a.href : String(a));
      a = b.target || a.target;
      var e = [];

      for (f in b) {
        switch (f) {
          case "width":
          case "height":
          case "top":
          case "left":
            e.push(f + "=" + b[f]);
            break;

          case "target":
          case "noopener":
          case "noreferrer":
            break;

          default:
            e.push(f + "=" + (b[f] ? 1 : 0));
        }
      }

      var f = e.join(",");
      (y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && c.navigator && c.navigator.standalone && a && "_self" != a ? (f = c.document.createElement("A"), d = d instanceof yc ? d : Ec(d), f.href = Ac(d), f.setAttribute("target", a), b.noreferrer && f.setAttribute("rel", "noreferrer"), b = document.createEvent("MouseEvent"), b.initMouseEvent("click", !0, !0, c, 1), f.dispatchEvent(b), c = {}) : b.noreferrer ? (c = c.open("", a, f), b = Ac(d).toString(), c && (dc && -1 != b.indexOf(";") && (b = "'" + b.replace(/'/g, "%27") + "'"), c.opener = null, b = Kc('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + db(b) + '">', null), c.document.write(Jc(b)), c.document.close())) : (c = c.open(Ac(d).toString(), a, f)) && b.noopener && (c.opener = null);
      return c;
    }

    function qf() {
      try {
        return !(!window.opener || !window.opener.location || window.opener.location.hostname !== window.location.hostname || window.opener.location.protocol !== window.location.protocol);
      } catch (a$1) {}

      return !1;
    }

    function rf(a) {
      pf(a, {
        target: window.cordova && window.cordova.InAppBrowser ? "_system" : "_blank"
      }, void 0);
    }

    function sf(a, b) {
      a = ta(a) && 1 == a.nodeType ? a : document.querySelector(String(a));
      if (null == a) throw Error(b || "Cannot find element.");
      return a;
    }

    function tf() {
      return window.location.href;
    }

    function uf() {
      var a = null;
      return new F(function (b) {
        "complete" == n.document.readyState ? b() : (a = function a() {
          b();
        }, me(window, "load", a));
      }).Ca(function (b) {
        te(window, "load", a);
        throw b;
      });
    }

    function vf() {
      for (var a = 32, b = []; 0 < a;) {
        b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
      }

      return b.join("");
    }

    function wf(a, b, c) {
      c = void 0 === c ? {} : c;
      return Object.keys(a).filter(function (d) {
        return b.includes(d);
      }).reduce(function (d, e) {
        d[e] = a[e];
        return d;
      }, c);
    }

    function xf(a) {
      var b = yf;
      this.s = [];
      this.T = b;
      this.O = a || null;
      this.j = this.a = !1;
      this.h = void 0;
      this.J = this.l = this.A = !1;
      this.i = 0;
      this.g = null;
      this.C = 0;
    }

    xf.prototype.cancel = function (a) {
      if (this.a) this.h instanceof xf && this.h.cancel();else {
        if (this.g) {
          var b = this.g;
          delete this.g;
          a ? b.cancel(a) : (b.C--, 0 >= b.C && b.cancel());
        }

        this.T ? this.T.call(this.O, this) : this.J = !0;
        this.a || (a = new zf(this), Af(this), Bf(this, !1, a));
      }
    };

    xf.prototype.L = function (a, b) {
      this.A = !1;
      Bf(this, a, b);
    };

    function Bf(a, b, c) {
      a.a = !0;
      a.h = c;
      a.j = !b;
      Cf(a);
    }

    function Af(a) {
      if (a.a) {
        if (!a.J) throw new Df(a);
        a.J = !1;
      }
    }

    xf.prototype.callback = function (a) {
      Af(this);
      Bf(this, !0, a);
    };

    function Ef(a, b, c) {
      a.s.push([b, c, void 0]);
      a.a && Cf(a);
    }

    xf.prototype.then = function (a, b, c) {
      var d,
          e,
          f = new F(function (g, h) {
        d = g;
        e = h;
      });
      Ef(this, d, function (g) {
        g instanceof zf ? f.cancel() : e(g);
      });
      return f.then(a, b, c);
    };

    xf.prototype.$goog_Thenable = !0;

    function Ff(a) {
      return La(a.s, function (b) {
        return sa(b[1]);
      });
    }

    function Cf(a) {
      if (a.i && a.a && Ff(a)) {
        var b = a.i,
            c = Gf[b];
        c && (n.clearTimeout(c.a), delete Gf[b]);
        a.i = 0;
      }

      a.g && (a.g.C--, delete a.g);
      b = a.h;

      for (var d = c = !1; a.s.length && !a.A;) {
        var e = a.s.shift(),
            f = e[0],
            g = e[1];
        e = e[2];
        if (f = a.j ? g : f) try {
          var h = f.call(e || a.O, b);
          ka(h) && (a.j = a.j && (h == b || h instanceof Error), a.h = b = h);
          if (Ge(b) || "function" === typeof n.Promise && b instanceof n.Promise) d = !0, a.A = !0;
        } catch (k) {
          b = k, a.j = !0, Ff(a) || (c = !0);
        }
      }

      a.h = b;
      d && (h = t(a.L, a, !0), d = t(a.L, a, !1), b instanceof xf ? (Ef(b, h, d), b.l = !0) : b.then(h, d));
      c && (b = new Hf(b), Gf[b.a] = b, a.i = b.a);
    }

    function Df() {
      Ca.call(this);
    }

    w(Df, Ca);
    Df.prototype.message = "Deferred has already fired";
    Df.prototype.name = "AlreadyCalledError";

    function zf() {
      Ca.call(this);
    }

    w(zf, Ca);
    zf.prototype.message = "Deferred was canceled";
    zf.prototype.name = "CanceledError";

    function Hf(a) {
      this.a = n.setTimeout(t(this.h, this), 0);
      this.g = a;
    }

    Hf.prototype.h = function () {
      delete Gf[this.a];
      throw this.g;
    };

    var Gf = {};

    function If(a) {
      var b = {},
          c = b.document || document,
          d = vc(a).toString(),
          e = document.createElement("SCRIPT"),
          f = {
        rb: e,
        sb: void 0
      },
          g = new xf(f),
          h = null,
          k = null != b.timeout ? b.timeout : 5E3;
      0 < k && (h = window.setTimeout(function () {
        Jf(e, !0);
        var p = new Kf(Lf, "Timeout reached for loading script " + d);
        Af(g);
        Bf(g, !1, p);
      }, k), f.sb = h);

      e.onload = e.onreadystatechange = function () {
        e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Jf(e, b.vc || !1, h), g.callback(null));
      };

      e.onerror = function () {
        Jf(e, !0, h);
        var p = new Kf(Mf, "Error while loading script " + d);
        Af(g);
        Bf(g, !1, p);
      };

      f = b.attributes || {};
      hb(f, {
        type: "text/javascript",
        charset: "UTF-8"
      });
      Xc(e, f);
      Nc(e, a);
      Nf(c).appendChild(e);
      return g;
    }

    function Nf(a) {
      var b = (a || document).getElementsByTagName("HEAD");
      return b && 0 != b.length ? b[0] : a.documentElement;
    }

    function yf() {
      if (this && this.rb) {
        var a = this.rb;
        a && "SCRIPT" == a.tagName && Jf(a, !0, this.sb);
      }
    }

    function Jf(a, b, c) {
      null != c && n.clearTimeout(c);
      a.onload = na;
      a.onerror = na;
      a.onreadystatechange = na;
      b && window.setTimeout(function () {
        $c(a);
      }, 0);
    }

    var Mf = 0,
        Lf = 1;

    function Kf(a, b) {
      var c = "Jsloader error (code #" + a + ")";
      b && (c += ": " + b);
      Ca.call(this, c);
      this.code = a;
    }

    w(Kf, Ca);

    function Of() {
      return n.google && n.google.accounts && n.google.accounts.id || null;
    }

    function Pf(a) {
      this.a = a || Of();
      this.h = !1;
      this.g = null;
    }

    Pf.prototype.cancel = function () {
      this.a && this.h && (this.g && this.g(null), this.a.cancel());
    };

    function Qf(a, b, c) {
      if (a.a && b) return function () {
        a.h = !0;
        return new F(function (e) {
          a.g = e;
          a.a.initialize({
            client_id: b,
            callback: e,
            auto_select: !c
          });
          a.a.prompt();
        });
      }();

      if (b) {
        var d = Rf.Xa().load().then(function () {
          a.a = Of();
          return Qf(a, b, c);
        }).Ca(function () {
          return null;
        });
        return G(d);
      }

      return G(null);
    }

    oa(Pf);
    var xc = new qc(rc, "https://accounts.google.com/gsi/client");

    function Rf() {
      this.a = null;
    }

    Rf.prototype.load = function () {
      var a = this;
      if (this.a) return this.a;
      var b = wc();
      return Of() ? G() : this.a = uf().then(function () {
        if (!Of()) return new F(function (c, d) {
          var e = setTimeout(function () {
            a.a = null;
            d(Error("Network error!"));
          }, 1E4);

          n.onGoogleLibraryLoad = function () {
            clearTimeout(e);
            c();
          };

          G(If(b)).then(function () {
            Of() && c();
          }).Ca(function (f) {
            clearTimeout(e);
            a.a = null;
            d(f);
          });
        });
      });
    };

    oa(Rf);

    function Sf(a, b) {
      this.a = a;

      this.g = b || function (c) {
        throw c;
      };
    }

    Sf.prototype.confirm = function (a) {
      return G(this.a.confirm(a)).Ca(this.g);
    };

    function Tf(a, b, c) {
      this.reset(a, b, c, void 0, void 0);
    }

    Tf.prototype.a = null;
    var Uf = 0;

    Tf.prototype.reset = function (a, b, c, d, e) {
      "number" == typeof e || Uf++;
      this.h = d || Aa();
      this.j = a;
      this.s = b;
      this.g = c;
      delete this.a;
    };

    function Vf(a) {
      this.s = a;
      this.a = this.h = this.j = this.g = null;
    }

    function Wf(a, b) {
      this.name = a;
      this.value = b;
    }

    Wf.prototype.toString = function () {
      return this.name;
    };

    var Xf = new Wf("SEVERE", 1E3),
        Yf = new Wf("WARNING", 900),
        Zf = new Wf("CONFIG", 700);

    function $f(a) {
      if (a.j) return a.j;
      if (a.g) return $f(a.g);
      Fa("Root logger has no level set.");
      return null;
    }

    Vf.prototype.log = function (a, b, c) {
      if (a.value >= $f(this).value) for (sa(b) && (b = b()), a = new Tf(a, String(b), this.s), c && (a.a = c), c = this; c;) {
        var d = c,
            e = a;
        if (d.a) for (var f = 0; b = d.a[f]; f++) {
          b(e);
        }
        c = c.g;
      }
    };

    var ag = {},
        bg = null;

    function cg() {
      bg || (bg = new Vf(""), ag[""] = bg, bg.j = Zf);
    }

    function dg(a) {
      cg();
      var b;

      if (!(b = ag[a])) {
        b = new Vf(a);
        var c = a.lastIndexOf("."),
            d = a.substr(c + 1);
        c = dg(a.substr(0, c));
        c.h || (c.h = {});
        c.h[d] = b;
        b.g = c;
        ag[a] = b;
      }

      return b;
    }

    function eg() {
      this.a = Aa();
    }

    var fg = null;

    eg.prototype.set = function (a) {
      this.a = a;
    };

    eg.prototype.reset = function () {
      this.set(Aa());
    };

    eg.prototype.get = function () {
      return this.a;
    };

    function gg(a) {
      this.j = a || "";
      fg || (fg = new eg());
      this.s = fg;
    }

    gg.prototype.a = !0;
    gg.prototype.g = !0;
    gg.prototype.h = !1;

    function hg(a) {
      return 10 > a ? "0" + a : String(a);
    }

    function ig(a, b) {
      a = (a.h - b) / 1E3;
      b = a.toFixed(3);
      var c = 0;
      if (1 > a) c = 2;else for (; 100 > a;) {
        c++, a *= 10;
      }

      for (; 0 < c--;) {
        b = " " + b;
      }

      return b;
    }

    function jg(a) {
      gg.call(this, a);
    }

    w(jg, gg);

    function kg(a, b) {
      var c = [];
      c.push(a.j, " ");

      if (a.g) {
        var d = new Date(b.h);
        c.push("[", hg(d.getFullYear() - 2E3) + hg(d.getMonth() + 1) + hg(d.getDate()) + " " + hg(d.getHours()) + ":" + hg(d.getMinutes()) + ":" + hg(d.getSeconds()) + "." + hg(Math.floor(d.getMilliseconds() / 10)), "] ");
      }

      c.push("[", ig(b, a.s.get()), "s] ");
      c.push("[", b.g, "] ");
      c.push(b.s);
      a.h && (b = b.a) && c.push("\n", b instanceof Error ? b.message : b.toString());
      a.a && c.push("\n");
      return c.join("");
    }

    function lg() {
      this.s = t(this.h, this);
      this.a = new jg();
      this.a.g = !1;
      this.a.h = !1;
      this.g = this.a.a = !1;
      this.j = {};
    }

    lg.prototype.h = function (a) {
      function b(f) {
        if (f) {
          if (f.value >= Xf.value) return "error";
          if (f.value >= Yf.value) return "warn";
          if (f.value >= Zf.value) return "log";
        }

        return "debug";
      }

      if (!this.j[a.g]) {
        var c = kg(this.a, a),
            d = mg;

        if (d) {
          var e = b(a.j);
          ng(d, e, c, a.a);
        }
      }
    };

    var mg = n.console;

    function ng(a, b, c, d) {
      if (a[b]) a[b](c, d || "");else a.log(c, d || "");
    }

    function og(a, b) {
      var c = pg;
      c && c.log(Xf, a, b);
    }

    var pg;
    pg = dg("firebaseui");
    var qg = new lg();

    if (1 != qg.g) {
      var rg;
      cg();
      rg = bg;
      var sg = qg.s;
      rg.a || (rg.a = []);
      rg.a.push(sg);
      qg.g = !0;
    }

    function tg(a) {
      var b = pg;
      b && b.log(Yf, a, void 0);
    }

    function vg() {
      this.a = ("undefined" == typeof document ? null : document) || {
        cookie: ""
      };
    }

    l = vg.prototype;

    l.set = function (a, b, c, d, e, f) {
      if (/[;=\s]/.test(a)) throw Error('Invalid cookie name "' + a + '"');
      if (/[;\r\n]/.test(b)) throw Error('Invalid cookie value "' + b + '"');
      ka(c) || (c = -1);
      e = e ? ";domain=" + e : "";
      d = d ? ";path=" + d : "";
      f = f ? ";secure" : "";
      c = 0 > c ? "" : 0 == c ? ";expires=" + new Date(1970, 1, 1).toUTCString() : ";expires=" + new Date(Aa() + 1E3 * c).toUTCString();
      this.a.cookie = a + "=" + b + e + d + c + f;
    };

    l.get = function (a, b) {
      for (var c = a + "=", d = (this.a.cookie || "").split(";"), e = 0, f; e < d.length; e++) {
        f = Va(d[e]);
        if (0 == f.lastIndexOf(c, 0)) return f.substr(c.length);
        if (f == a) return "";
      }

      return b;
    };

    l.ja = function () {
      return wg(this).keys;
    };

    l.la = function () {
      return wg(this).values;
    };

    l.clear = function () {
      for (var a = wg(this).keys, b = a.length - 1; 0 <= b; b--) {
        var c = a[b];
        this.get(c);
        this.set(c, "", 0, void 0, void 0);
      }
    };

    function wg(a) {
      a = (a.a.cookie || "").split(";");

      for (var b = [], c = [], d, e, f = 0; f < a.length; f++) {
        e = Va(a[f]), d = e.indexOf("="), -1 == d ? (b.push(""), c.push(e)) : (b.push(e.substring(0, d)), c.push(e.substring(d + 1)));
      }

      return {
        keys: b,
        values: c
      };
    }

    var xg = new vg();

    function yg() {}

    function zg(a, b, c, d) {
      this.h = "undefined" !== typeof a && null !== a ? a : -1;
      this.g = b || null;
      this.a = c || null;
      this.j = !!d;
    }

    m(zg, yg);

    zg.prototype.set = function (a, b) {
      xg.set(a, b, this.h, this.g, this.a, this.j);
    };

    zg.prototype.get = function (a) {
      return xg.get(a) || null;
    };

    zg.prototype.ra = function (a) {
      var b = this.g,
          c = this.a;
      xg.get(a);
      xg.set(a, "", 0, b, c);
    };

    function Ag(a, b) {
      this.g = a;
      this.a = b || null;
    }

    function Bg(a) {
      return {
        email: a.g,
        credential: a.a && a.a.toJSON()
      };
    }

    function Cg(a) {
      if (a && a.email) {
        var b = a.credential && firebase.auth.AuthCredential.fromJSON(a.credential);
        return new Ag(a.email, b);
      }

      return null;
    }

    function Dg(a) {
      this.a = a || null;
    }

    function Eg(a) {
      for (var b = [], c = 0, d = 0; d < a.length; d++) {
        var e = a.charCodeAt(d);
        255 < e && (b[c++] = e & 255, e >>= 8);
        b[c++] = e;
      }

      return b;
    }

    function Fg(a) {
      return Ka(a, function (b) {
        b = b.toString(16);
        return 1 < b.length ? b : "0" + b;
      }).join("");
    }

    function Gg(a) {
      this.i = a;
      this.g = this.i.length / 4;
      this.j = this.g + 6;
      this.h = [[], [], [], []];
      this.s = [[], [], [], []];
      this.a = Array(Hg * (this.j + 1));

      for (a = 0; a < this.g; a++) {
        this.a[a] = [this.i[4 * a], this.i[4 * a + 1], this.i[4 * a + 2], this.i[4 * a + 3]];
      }

      var b = Array(4);

      for (a = this.g; a < Hg * (this.j + 1); a++) {
        b[0] = this.a[a - 1][0];
        b[1] = this.a[a - 1][1];
        b[2] = this.a[a - 1][2];
        b[3] = this.a[a - 1][3];

        if (0 == a % this.g) {
          var c = b,
              d = c[0];
          c[0] = c[1];
          c[1] = c[2];
          c[2] = c[3];
          c[3] = d;
          Ig(b);
          b[0] ^= Jg[a / this.g][0];
          b[1] ^= Jg[a / this.g][1];
          b[2] ^= Jg[a / this.g][2];
          b[3] ^= Jg[a / this.g][3];
        } else 6 < this.g && 4 == a % this.g && Ig(b);

        this.a[a] = Array(4);
        this.a[a][0] = this.a[a - this.g][0] ^ b[0];
        this.a[a][1] = this.a[a - this.g][1] ^ b[1];
        this.a[a][2] = this.a[a - this.g][2] ^ b[2];
        this.a[a][3] = this.a[a - this.g][3] ^ b[3];
      }
    }

    Gg.prototype.A = 16;
    var Hg = Gg.prototype.A / 4;

    function Kg(a, b) {
      for (var c, d = 0; d < Hg; d++) {
        for (var e = 0; 4 > e; e++) {
          c = 4 * e + d, c = b[c], a.h[d][e] = c;
        }
      }
    }

    function Lg(a) {
      for (var b = [], c = 0; c < Hg; c++) {
        for (var d = 0; 4 > d; d++) {
          b[4 * d + c] = a.h[c][d];
        }
      }

      return b;
    }

    function Mg(a, b) {
      for (var c = 0; 4 > c; c++) {
        for (var d = 0; 4 > d; d++) {
          a.h[c][d] ^= a.a[4 * b + d][c];
        }
      }
    }

    function Ng(a, b) {
      for (var c = 0; 4 > c; c++) {
        for (var d = 0; 4 > d; d++) {
          a.h[c][d] = b[a.h[c][d]];
        }
      }
    }

    function Og(a) {
      for (var b = 1; 4 > b; b++) {
        for (var c = 0; 4 > c; c++) {
          a.s[b][c] = a.h[b][c];
        }
      }

      for (b = 1; 4 > b; b++) {
        for (c = 0; 4 > c; c++) {
          a.h[b][c] = a.s[b][(c + b) % Hg];
        }
      }
    }

    function Pg(a) {
      for (var b = 1; 4 > b; b++) {
        for (var c = 0; 4 > c; c++) {
          a.s[b][(c + b) % Hg] = a.h[b][c];
        }
      }

      for (b = 1; 4 > b; b++) {
        for (c = 0; 4 > c; c++) {
          a.h[b][c] = a.s[b][c];
        }
      }
    }

    function Ig(a) {
      a[0] = Qg[a[0]];
      a[1] = Qg[a[1]];
      a[2] = Qg[a[2]];
      a[3] = Qg[a[3]];
    }

    var Qg = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22],
        Rg = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125],
        Jg = [[0, 0, 0, 0], [1, 0, 0, 0], [2, 0, 0, 0], [4, 0, 0, 0], [8, 0, 0, 0], [16, 0, 0, 0], [32, 0, 0, 0], [64, 0, 0, 0], [128, 0, 0, 0], [27, 0, 0, 0], [54, 0, 0, 0]],
        Sg = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164, 166, 168, 170, 172, 174, 176, 178, 180, 182, 184, 186, 188, 190, 192, 194, 196, 198, 200, 202, 204, 206, 208, 210, 212, 214, 216, 218, 220, 222, 224, 226, 228, 230, 232, 234, 236, 238, 240, 242, 244, 246, 248, 250, 252, 254, 27, 25, 31, 29, 19, 17, 23, 21, 11, 9, 15, 13, 3, 1, 7, 5, 59, 57, 63, 61, 51, 49, 55, 53, 43, 41, 47, 45, 35, 33, 39, 37, 91, 89, 95, 93, 83, 81, 87, 85, 75, 73, 79, 77, 67, 65, 71, 69, 123, 121, 127, 125, 115, 113, 119, 117, 107, 105, 111, 109, 99, 97, 103, 101, 155, 153, 159, 157, 147, 145, 151, 149, 139, 137, 143, 141, 131, 129, 135, 133, 187, 185, 191, 189, 179, 177, 183, 181, 171, 169, 175, 173, 163, 161, 167, 165, 219, 217, 223, 221, 211, 209, 215, 213, 203, 201, 207, 205, 195, 193, 199, 197, 251, 249, 255, 253, 243, 241, 247, 245, 235, 233, 239, 237, 227, 225, 231, 229],
        Tg = [0, 3, 6, 5, 12, 15, 10, 9, 24, 27, 30, 29, 20, 23, 18, 17, 48, 51, 54, 53, 60, 63, 58, 57, 40, 43, 46, 45, 36, 39, 34, 33, 96, 99, 102, 101, 108, 111, 106, 105, 120, 123, 126, 125, 116, 119, 114, 113, 80, 83, 86, 85, 92, 95, 90, 89, 72, 75, 78, 77, 68, 71, 66, 65, 192, 195, 198, 197, 204, 207, 202, 201, 216, 219, 222, 221, 212, 215, 210, 209, 240, 243, 246, 245, 252, 255, 250, 249, 232, 235, 238, 237, 228, 231, 226, 225, 160, 163, 166, 165, 172, 175, 170, 169, 184, 187, 190, 189, 180, 183, 178, 177, 144, 147, 150, 149, 156, 159, 154, 153, 136, 139, 142, 141, 132, 135, 130, 129, 155, 152, 157, 158, 151, 148, 145, 146, 131, 128, 133, 134, 143, 140, 137, 138, 171, 168, 173, 174, 167, 164, 161, 162, 179, 176, 181, 182, 191, 188, 185, 186, 251, 248, 253, 254, 247, 244, 241, 242, 227, 224, 229, 230, 239, 236, 233, 234, 203, 200, 205, 206, 199, 196, 193, 194, 211, 208, 213, 214, 223, 220, 217, 218, 91, 88, 93, 94, 87, 84, 81, 82, 67, 64, 69, 70, 79, 76, 73, 74, 107, 104, 109, 110, 103, 100, 97, 98, 115, 112, 117, 118, 127, 124, 121, 122, 59, 56, 61, 62, 55, 52, 49, 50, 35, 32, 37, 38, 47, 44, 41, 42, 11, 8, 13, 14, 7, 4, 1, 2, 19, 16, 21, 22, 31, 28, 25, 26],
        Ug = [0, 9, 18, 27, 36, 45, 54, 63, 72, 65, 90, 83, 108, 101, 126, 119, 144, 153, 130, 139, 180, 189, 166, 175, 216, 209, 202, 195, 252, 245, 238, 231, 59, 50, 41, 32, 31, 22, 13, 4, 115, 122, 97, 104, 87, 94, 69, 76, 171, 162, 185, 176, 143, 134, 157, 148, 227, 234, 241, 248, 199, 206, 213, 220, 118, 127, 100, 109, 82, 91, 64, 73, 62, 55, 44, 37, 26, 19, 8, 1, 230, 239, 244, 253, 194, 203, 208, 217, 174, 167, 188, 181, 138, 131, 152, 145, 77, 68, 95, 86, 105, 96, 123, 114, 5, 12, 23, 30, 33, 40, 51, 58, 221, 212, 207, 198, 249, 240, 235, 226, 149, 156, 135, 142, 177, 184, 163, 170, 236, 229, 254, 247, 200, 193, 218, 211, 164, 173, 182, 191, 128, 137, 146, 155, 124, 117, 110, 103, 88, 81, 74, 67, 52, 61, 38, 47, 16, 25, 2, 11, 215, 222, 197, 204, 243, 250, 225, 232, 159, 150, 141, 132, 187, 178, 169, 160, 71, 78, 85, 92, 99, 106, 113, 120, 15, 6, 29, 20, 43, 34, 57, 48, 154, 147, 136, 129, 190, 183, 172, 165, 210, 219, 192, 201, 246, 255, 228, 237, 10, 3, 24, 17, 46, 39, 60, 53, 66, 75, 80, 89, 102, 111, 116, 125, 161, 168, 179, 186, 133, 140, 151, 158, 233, 224, 251, 242, 205, 196, 223, 214, 49, 56, 35, 42, 21, 28, 7, 14, 121, 112, 107, 98, 93, 84, 79, 70],
        Vg = [0, 11, 22, 29, 44, 39, 58, 49, 88, 83, 78, 69, 116, 127, 98, 105, 176, 187, 166, 173, 156, 151, 138, 129, 232, 227, 254, 245, 196, 207, 210, 217, 123, 112, 109, 102, 87, 92, 65, 74, 35, 40, 53, 62, 15, 4, 25, 18, 203, 192, 221, 214, 231, 236, 241, 250, 147, 152, 133, 142, 191, 180, 169, 162, 246, 253, 224, 235, 218, 209, 204, 199, 174, 165, 184, 179, 130, 137, 148, 159, 70, 77, 80, 91, 106, 97, 124, 119, 30, 21, 8, 3, 50, 57, 36, 47, 141, 134, 155, 144, 161, 170, 183, 188, 213, 222, 195, 200, 249, 242, 239, 228, 61, 54, 43, 32, 17, 26, 7, 12, 101, 110, 115, 120, 73, 66, 95, 84, 247, 252, 225, 234, 219, 208, 205, 198, 175, 164, 185, 178, 131, 136, 149, 158, 71, 76, 81, 90, 107, 96, 125, 118, 31, 20, 9, 2, 51, 56, 37, 46, 140, 135, 154, 145, 160, 171, 182, 189, 212, 223, 194, 201, 248, 243, 238, 229, 60, 55, 42, 33, 16, 27, 6, 13, 100, 111, 114, 121, 72, 67, 94, 85, 1, 10, 23, 28, 45, 38, 59, 48, 89, 82, 79, 68, 117, 126, 99, 104, 177, 186, 167, 172, 157, 150, 139, 128, 233, 226, 255, 244, 197, 206, 211, 216, 122, 113, 108, 103, 86, 93, 64, 75, 34, 41, 52, 63, 14, 5, 24, 19, 202, 193, 220, 215, 230, 237, 240, 251, 146, 153, 132, 143, 190, 181, 168, 163],
        Wg = [0, 13, 26, 23, 52, 57, 46, 35, 104, 101, 114, 127, 92, 81, 70, 75, 208, 221, 202, 199, 228, 233, 254, 243, 184, 181, 162, 175, 140, 129, 150, 155, 187, 182, 161, 172, 143, 130, 149, 152, 211, 222, 201, 196, 231, 234, 253, 240, 107, 102, 113, 124, 95, 82, 69, 72, 3, 14, 25, 20, 55, 58, 45, 32, 109, 96, 119, 122, 89, 84, 67, 78, 5, 8, 31, 18, 49, 60, 43, 38, 189, 176, 167, 170, 137, 132, 147, 158, 213, 216, 207, 194, 225, 236, 251, 246, 214, 219, 204, 193, 226, 239, 248, 245, 190, 179, 164, 169, 138, 135, 144, 157, 6, 11, 28, 17, 50, 63, 40, 37, 110, 99, 116, 121, 90, 87, 64, 77, 218, 215, 192, 205, 238, 227, 244, 249, 178, 191, 168, 165, 134, 139, 156, 145, 10, 7, 16, 29, 62, 51, 36, 41, 98, 111, 120, 117, 86, 91, 76, 65, 97, 108, 123, 118, 85, 88, 79, 66, 9, 4, 19, 30, 61, 48, 39, 42, 177, 188, 171, 166, 133, 136, 159, 146, 217, 212, 195, 206, 237, 224, 247, 250, 183, 186, 173, 160, 131, 142, 153, 148, 223, 210, 197, 200, 235, 230, 241, 252, 103, 106, 125, 112, 83, 94, 73, 68, 15, 2, 21, 24, 59, 54, 33, 44, 12, 1, 22, 27, 56, 53, 34, 47, 100, 105, 126, 115, 80, 93, 74, 71, 220, 209, 198, 203, 232, 229, 242, 255, 180, 185, 174, 163, 128, 141, 154, 151],
        Xg = [0, 14, 28, 18, 56, 54, 36, 42, 112, 126, 108, 98, 72, 70, 84, 90, 224, 238, 252, 242, 216, 214, 196, 202, 144, 158, 140, 130, 168, 166, 180, 186, 219, 213, 199, 201, 227, 237, 255, 241, 171, 165, 183, 185, 147, 157, 143, 129, 59, 53, 39, 41, 3, 13, 31, 17, 75, 69, 87, 89, 115, 125, 111, 97, 173, 163, 177, 191, 149, 155, 137, 135, 221, 211, 193, 207, 229, 235, 249, 247, 77, 67, 81, 95, 117, 123, 105, 103, 61, 51, 33, 47, 5, 11, 25, 23, 118, 120, 106, 100, 78, 64, 82, 92, 6, 8, 26, 20, 62, 48, 34, 44, 150, 152, 138, 132, 174, 160, 178, 188, 230, 232, 250, 244, 222, 208, 194, 204, 65, 79, 93, 83, 121, 119, 101, 107, 49, 63, 45, 35, 9, 7, 21, 27, 161, 175, 189, 179, 153, 151, 133, 139, 209, 223, 205, 195, 233, 231, 245, 251, 154, 148, 134, 136, 162, 172, 190, 176, 234, 228, 246, 248, 210, 220, 206, 192, 122, 116, 102, 104, 66, 76, 94, 80, 10, 4, 22, 24, 50, 60, 46, 32, 236, 226, 240, 254, 212, 218, 200, 198, 156, 146, 128, 142, 164, 170, 184, 182, 12, 2, 16, 30, 52, 58, 40, 38, 124, 114, 96, 110, 68, 74, 88, 86, 55, 57, 43, 37, 15, 1, 19, 29, 71, 73, 91, 85, 127, 113, 99, 109, 215, 217, 203, 197, 239, 225, 243, 253, 167, 169, 187, 181, 159, 145, 131, 141];

    function Yg(a, b) {
      a = new Gg(Zg(a));
      b = Eg(b);

      for (var c = Ta(b, 0, 16), d = "", e; c.length;) {
        e = 16 - c.length;

        for (var f = 0; f < e; f++) {
          c.push(0);
        }

        e = a;
        Kg(e, c);
        Mg(e, 0);

        for (c = 1; c < e.j; ++c) {
          Ng(e, Qg);
          Og(e);
          f = e.h;

          for (var g = e.s[0], h = 0; 4 > h; h++) {
            g[0] = f[0][h], g[1] = f[1][h], g[2] = f[2][h], g[3] = f[3][h], f[0][h] = Sg[g[0]] ^ Tg[g[1]] ^ g[2] ^ g[3], f[1][h] = g[0] ^ Sg[g[1]] ^ Tg[g[2]] ^ g[3], f[2][h] = g[0] ^ g[1] ^ Sg[g[2]] ^ Tg[g[3]], f[3][h] = Tg[g[0]] ^ g[1] ^ g[2] ^ Sg[g[3]];
          }

          Mg(e, c);
        }

        Ng(e, Qg);
        Og(e);
        Mg(e, e.j);
        d += Fg(Lg(e));
        c = Ta(b, 0, 16);
      }

      return d;
    }

    function $g(a, b) {
      a = new Gg(Zg(a));

      for (var c = [], d = 0; d < b.length; d += 2) {
        c.push(parseInt(b.substring(d, d + 2), 16));
      }

      var e = Ta(c, 0, 16);

      for (b = ""; e.length;) {
        d = a;
        Kg(d, e);
        Mg(d, d.j);

        for (e = 1; e < d.j; ++e) {
          Pg(d);
          Ng(d, Rg);
          Mg(d, d.j - e);

          for (var f = d.h, g = d.s[0], h = 0; 4 > h; h++) {
            g[0] = f[0][h], g[1] = f[1][h], g[2] = f[2][h], g[3] = f[3][h], f[0][h] = Xg[g[0]] ^ Vg[g[1]] ^ Wg[g[2]] ^ Ug[g[3]], f[1][h] = Ug[g[0]] ^ Xg[g[1]] ^ Vg[g[2]] ^ Wg[g[3]], f[2][h] = Wg[g[0]] ^ Ug[g[1]] ^ Xg[g[2]] ^ Vg[g[3]], f[3][h] = Vg[g[0]] ^ Wg[g[1]] ^ Ug[g[2]] ^ Xg[g[3]];
          }
        }

        Pg(d);
        Ng(d, Rg);
        Mg(d, 0);
        d = Lg(d);
        if (8192 >= d.length) d = String.fromCharCode.apply(null, d);else {
          e = "";

          for (f = 0; f < d.length; f += 8192) {
            e += String.fromCharCode.apply(null, Ua(d, f, f + 8192));
          }

          d = e;
        }
        b += d;
        e = Ta(c, 0, 16);
      }

      return b.replace(/(\x00)+$/, "");
    }

    function Zg(a) {
      a = Eg(a.substring(0, 32));

      for (var b = 32 - a.length, c = 0; c < b; c++) {
        a.push(0);
      }

      return a;
    }

    function ah(a) {
      var b = [];
      bh(new ch(), a, b);
      return b.join("");
    }

    function ch() {}

    function bh(a, b, c) {
      if (null == b) c.push("null");else {
        if ("object" == typeof b) {
          if (qa(b)) {
            var d = b;
            b = d.length;
            c.push("[");

            for (var e = "", f = 0; f < b; f++) {
              c.push(e), bh(a, d[f], c), e = ",";
            }

            c.push("]");
            return;
          }

          if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
            c.push("{");
            e = "";

            for (d in b) {
              Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), dh(d, c), c.push(":"), bh(a, f, c), e = ","));
            }

            c.push("}");
            return;
          }
        }

        switch (typeof b) {
          case "string":
            dh(b, c);
            break;

          case "number":
            c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
            break;

          case "boolean":
            c.push(String(b));
            break;

          case "function":
            c.push("null");
            break;

          default:
            throw Error("Unknown type: " + typeof b);
        }
      }
    }

    var eh = {
      '"': '\\"',
      "\\": "\\\\",
      "/": "\\/",
      "\b": "\\b",
      "\f": "\\f",
      "\n": "\\n",
      "\r": "\\r",
      "\t": "\\t",
      "\x0B": "\\u000b"
    },
        fh = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;

    function dh(a, b) {
      b.push('"', a.replace(fh, function (c) {
        var d = eh[c];
        d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), eh[c] = d);
        return d;
      }), '"');
    }

    function gh(a) {
      this.a = a;
    }

    gh.prototype.set = function (a, b) {
      ka(b) ? this.a.set(a, ah(b)) : this.a.ra(a);
    };

    gh.prototype.get = function (a) {
      try {
        var b = this.a.get(a);
      } catch (c) {
        return;
      }

      if (null !== b) try {
        return JSON.parse(b);
      } catch (c$2) {
        throw "Storage: Invalid value was encountered";
      }
    };

    function hh() {}

    w(hh, yg);

    hh.prototype.clear = function () {
      var a = mb(this.ha(!0)),
          b = this;
      Ha(a, function (c) {
        b.ra(c);
      });
    };

    function ih(a) {
      this.a = a;
    }

    w(ih, hh);

    function jh(a) {
      if (!a.a) return !1;

      try {
        return a.a.setItem("__sak", "1"), a.a.removeItem("__sak"), !0;
      } catch (b) {
        return !1;
      }
    }

    l = ih.prototype;

    l.set = function (a, b) {
      try {
        this.a.setItem(a, b);
      } catch (c) {
        if (0 == this.a.length) throw "Storage mechanism: Storage disabled";
        throw "Storage mechanism: Quota exceeded";
      }
    };

    l.get = function (a) {
      a = this.a.getItem(a);
      if (!q(a) && null !== a) throw "Storage mechanism: Invalid value was encountered";
      return a;
    };

    l.ra = function (a) {
      this.a.removeItem(a);
    };

    l.ha = function (a) {
      var b = 0,
          c = this.a,
          d = new jb();

      d.next = function () {
        if (b >= c.length) throw ib;
        var e = c.key(b++);
        if (a) return e;
        e = c.getItem(e);
        if (!q(e)) throw "Storage mechanism: Invalid value was encountered";
        return e;
      };

      return d;
    };

    l.clear = function () {
      this.a.clear();
    };

    l.key = function (a) {
      return this.a.key(a);
    };

    function kh() {
      var a = null;

      try {
        a = window.localStorage || null;
      } catch (b) {}

      this.a = a;
    }

    w(kh, ih);

    function lh() {
      var a = null;

      try {
        a = window.sessionStorage || null;
      } catch (b) {}

      this.a = a;
    }

    w(lh, ih);

    function mh(a, b) {
      this.g = a;
      this.a = b + "::";
    }

    w(mh, hh);

    mh.prototype.set = function (a, b) {
      this.g.set(this.a + a, b);
    };

    mh.prototype.get = function (a) {
      return this.g.get(this.a + a);
    };

    mh.prototype.ra = function (a) {
      this.g.ra(this.a + a);
    };

    mh.prototype.ha = function (a) {
      var b = this.g.ha(!0),
          c = this,
          d = new jb();

      d.next = function () {
        for (var e = b.next(); e.substr(0, c.a.length) != c.a;) {
          e = b.next();
        }

        return a ? e.substr(c.a.length) : c.g.get(e);
      };

      return d;
    };

    jh(new kh());
    var nh,
        oh = new lh();
    nh = jh(oh) ? new mh(oh, "firebaseui") : null;
    var ph = new gh(nh),
        qh = {
      name: "pendingEmailCredential",
      storage: ph
    },
        rh = {
      name: "redirectStatus",
      storage: ph
    },
        sh = {
      name: "redirectUrl",
      storage: ph
    },
        th = {
      name: "emailForSignIn",
      storage: new gh(new zg(3600, "/"))
    },
        uh = {
      name: "pendingEncryptedCredential",
      storage: new gh(new zg(3600, "/"))
    };

    function vh(a, b) {
      return a.storage.get(b ? a.name + ":" + b : a.name);
    }

    function wh(a, b) {
      a.storage.a.ra(b ? a.name + ":" + b : a.name);
    }

    function xh(a, b, c) {
      a.storage.set(c ? a.name + ":" + c : a.name, b);
    }

    function yh(a) {
      return vh(sh, a) || null;
    }

    function zh(a) {
      a = vh(qh, a) || null;
      return Cg(a);
    }

    function Ah(a) {
      wh(qh, a);
    }

    function Bh(a, b) {
      xh(qh, Bg(a), b);
    }

    function Ch(a) {
      return (a = vh(rh, a) || null) && "undefined" !== typeof a.tenantId ? new Dg(a.tenantId) : null;
    }

    function Dh(a, b) {
      xh(rh, {
        tenantId: a.a
      }, b);
    }

    function Eh(a, b) {
      b = vh(th, b);
      var c = null;
      if (b) try {
        var d = $g(a, b),
            e = JSON.parse(d);
        c = e && e.email || null;
      } catch (f) {}
      return c;
    }

    function Fh(a, b) {
      b = vh(uh, b);
      var c = null;
      if (b) try {
        var d = $g(a, b);
        c = JSON.parse(d);
      } catch (e) {}
      return Cg(c || null);
    }

    function Gh(a, b, c) {
      xh(uh, Yg(a, JSON.stringify(Bg(b))), c);
    }

    function Hh() {
      this.W = {};
    }

    function I(a, b, c) {
      if (b.toLowerCase() in a.W) throw Error("Configuration " + b + " has already been defined.");
      a.W[b.toLowerCase()] = c;
    }

    function Ih(a, b, c) {
      if (!(b.toLowerCase() in a.W)) throw Error("Configuration " + b + " is not defined.");
      a.W[b.toLowerCase()] = c;
    }

    Hh.prototype.get = function (a) {
      if (!(a.toLowerCase() in this.W)) throw Error("Configuration " + a + " is not defined.");
      return this.W[a.toLowerCase()];
    };

    function Jh(a, b) {
      a = a.get(b);
      if (!a) throw Error("Configuration " + b + " is required.");
      return a;
    }

    function Kh() {
      this.g = void 0;
      this.a = {};
    }

    l = Kh.prototype;

    l.set = function (a, b) {
      Lh(this, a, b, !1);
    };

    l.add = function (a, b) {
      Lh(this, a, b, !0);
    };

    function Lh(a, b, c, d) {
      for (var e = 0; e < b.length; e++) {
        var f = b.charAt(e);
        a.a[f] || (a.a[f] = new Kh());
        a = a.a[f];
      }

      if (d && void 0 !== a.g) throw Error('The collection already contains the key "' + b + '"');
      a.g = c;
    }

    l.get = function (a) {
      a: {
        for (var b = this, c = 0; c < a.length; c++) {
          if (b = b.a[a.charAt(c)], !b) {
            a = void 0;
            break a;
          }
        }

        a = b;
      }

      return a ? a.g : void 0;
    };

    l.la = function () {
      var a = [];
      Mh(this, a);
      return a;
    };

    function Mh(a, b) {
      void 0 !== a.g && b.push(a.g);

      for (var c in a.a) {
        Mh(a.a[c], b);
      }
    }

    l.ja = function () {
      var a = [];
      Nh(this, "", a);
      return a;
    };

    function Nh(a, b, c) {
      void 0 !== a.g && c.push(b);

      for (var d in a.a) {
        Nh(a.a[d], b + d, c);
      }
    }

    l.clear = function () {
      this.a = {};
      this.g = void 0;
    };

    function Oh(a) {
      this.a = a;
      this.g = new Kh();

      for (a = 0; a < this.a.length; a++) {
        var b = this.g.get("+" + this.a[a].b);
        b ? b.push(this.a[a]) : this.g.add("+" + this.a[a].b, [this.a[a]]);
      }
    }

    function Ph(a, b) {
      a = a.g;
      var c = {},
          d = 0;
      void 0 !== a.g && (c[d] = a.g);

      for (; d < b.length; d++) {
        var e = b.charAt(d);
        if (!(e in a.a)) break;
        a = a.a[e];
        void 0 !== a.g && (c[d] = a.g);
      }

      for (var f in c) {
        if (c.hasOwnProperty(f)) return c[f];
      }

      return [];
    }

    function Qh(a) {
      for (var b = 0; b < Rh.length; b++) {
        if (Rh[b].c === a) return Rh[b];
      }

      return null;
    }

    function Sh(a) {
      a = a.toUpperCase();

      for (var b = [], c = 0; c < Rh.length; c++) {
        Rh[c].f === a && b.push(Rh[c]);
      }

      return b;
    }

    function Th(a) {
      if (0 < a.length && "+" == a.charAt(0)) {
        a = a.substring(1);

        for (var b = [], c = 0; c < Rh.length; c++) {
          Rh[c].b == a && b.push(Rh[c]);
        }

        a = b;
      } else a = Sh(a);

      return a;
    }

    function Uh(a) {
      a.sort(function (b, c) {
        return b.name.localeCompare(c.name, "en");
      });
    }

    var Rh = [{
      name: "Afghanistan",
      c: "93-AF-0",
      b: "93",
      f: "AF"
    }, {
      name: "\xC5land Islands",
      c: "358-AX-0",
      b: "358",
      f: "AX"
    }, {
      name: "Albania",
      c: "355-AL-0",
      b: "355",
      f: "AL"
    }, {
      name: "Algeria",
      c: "213-DZ-0",
      b: "213",
      f: "DZ"
    }, {
      name: "American Samoa",
      c: "1-AS-0",
      b: "1",
      f: "AS"
    }, {
      name: "Andorra",
      c: "376-AD-0",
      b: "376",
      f: "AD"
    }, {
      name: "Angola",
      c: "244-AO-0",
      b: "244",
      f: "AO"
    }, {
      name: "Anguilla",
      c: "1-AI-0",
      b: "1",
      f: "AI"
    }, {
      name: "Antigua and Barbuda",
      c: "1-AG-0",
      b: "1",
      f: "AG"
    }, {
      name: "Argentina",
      c: "54-AR-0",
      b: "54",
      f: "AR"
    }, {
      name: "Armenia",
      c: "374-AM-0",
      b: "374",
      f: "AM"
    }, {
      name: "Aruba",
      c: "297-AW-0",
      b: "297",
      f: "AW"
    }, {
      name: "Ascension Island",
      c: "247-AC-0",
      b: "247",
      f: "AC"
    }, {
      name: "Australia",
      c: "61-AU-0",
      b: "61",
      f: "AU"
    }, {
      name: "Austria",
      c: "43-AT-0",
      b: "43",
      f: "AT"
    }, {
      name: "Azerbaijan",
      c: "994-AZ-0",
      b: "994",
      f: "AZ"
    }, {
      name: "Bahamas",
      c: "1-BS-0",
      b: "1",
      f: "BS"
    }, {
      name: "Bahrain",
      c: "973-BH-0",
      b: "973",
      f: "BH"
    }, {
      name: "Bangladesh",
      c: "880-BD-0",
      b: "880",
      f: "BD"
    }, {
      name: "Barbados",
      c: "1-BB-0",
      b: "1",
      f: "BB"
    }, {
      name: "Belarus",
      c: "375-BY-0",
      b: "375",
      f: "BY"
    }, {
      name: "Belgium",
      c: "32-BE-0",
      b: "32",
      f: "BE"
    }, {
      name: "Belize",
      c: "501-BZ-0",
      b: "501",
      f: "BZ"
    }, {
      name: "Benin",
      c: "229-BJ-0",
      b: "229",
      f: "BJ"
    }, {
      name: "Bermuda",
      c: "1-BM-0",
      b: "1",
      f: "BM"
    }, {
      name: "Bhutan",
      c: "975-BT-0",
      b: "975",
      f: "BT"
    }, {
      name: "Bolivia",
      c: "591-BO-0",
      b: "591",
      f: "BO"
    }, {
      name: "Bosnia and Herzegovina",
      c: "387-BA-0",
      b: "387",
      f: "BA"
    }, {
      name: "Botswana",
      c: "267-BW-0",
      b: "267",
      f: "BW"
    }, {
      name: "Brazil",
      c: "55-BR-0",
      b: "55",
      f: "BR"
    }, {
      name: "British Indian Ocean Territory",
      c: "246-IO-0",
      b: "246",
      f: "IO"
    }, {
      name: "British Virgin Islands",
      c: "1-VG-0",
      b: "1",
      f: "VG"
    }, {
      name: "Brunei",
      c: "673-BN-0",
      b: "673",
      f: "BN"
    }, {
      name: "Bulgaria",
      c: "359-BG-0",
      b: "359",
      f: "BG"
    }, {
      name: "Burkina Faso",
      c: "226-BF-0",
      b: "226",
      f: "BF"
    }, {
      name: "Burundi",
      c: "257-BI-0",
      b: "257",
      f: "BI"
    }, {
      name: "Cambodia",
      c: "855-KH-0",
      b: "855",
      f: "KH"
    }, {
      name: "Cameroon",
      c: "237-CM-0",
      b: "237",
      f: "CM"
    }, {
      name: "Canada",
      c: "1-CA-0",
      b: "1",
      f: "CA"
    }, {
      name: "Cape Verde",
      c: "238-CV-0",
      b: "238",
      f: "CV"
    }, {
      name: "Caribbean Netherlands",
      c: "599-BQ-0",
      b: "599",
      f: "BQ"
    }, {
      name: "Cayman Islands",
      c: "1-KY-0",
      b: "1",
      f: "KY"
    }, {
      name: "Central African Republic",
      c: "236-CF-0",
      b: "236",
      f: "CF"
    }, {
      name: "Chad",
      c: "235-TD-0",
      b: "235",
      f: "TD"
    }, {
      name: "Chile",
      c: "56-CL-0",
      b: "56",
      f: "CL"
    }, {
      name: "China",
      c: "86-CN-0",
      b: "86",
      f: "CN"
    }, {
      name: "Christmas Island",
      c: "61-CX-0",
      b: "61",
      f: "CX"
    }, {
      name: "Cocos [Keeling] Islands",
      c: "61-CC-0",
      b: "61",
      f: "CC"
    }, {
      name: "Colombia",
      c: "57-CO-0",
      b: "57",
      f: "CO"
    }, {
      name: "Comoros",
      c: "269-KM-0",
      b: "269",
      f: "KM"
    }, {
      name: "Democratic Republic Congo",
      c: "243-CD-0",
      b: "243",
      f: "CD"
    }, {
      name: "Republic of Congo",
      c: "242-CG-0",
      b: "242",
      f: "CG"
    }, {
      name: "Cook Islands",
      c: "682-CK-0",
      b: "682",
      f: "CK"
    }, {
      name: "Costa Rica",
      c: "506-CR-0",
      b: "506",
      f: "CR"
    }, {
      name: "C\xF4te d'Ivoire",
      c: "225-CI-0",
      b: "225",
      f: "CI"
    }, {
      name: "Croatia",
      c: "385-HR-0",
      b: "385",
      f: "HR"
    }, {
      name: "Cuba",
      c: "53-CU-0",
      b: "53",
      f: "CU"
    }, {
      name: "Cura\xE7ao",
      c: "599-CW-0",
      b: "599",
      f: "CW"
    }, {
      name: "Cyprus",
      c: "357-CY-0",
      b: "357",
      f: "CY"
    }, {
      name: "Czech Republic",
      c: "420-CZ-0",
      b: "420",
      f: "CZ"
    }, {
      name: "Denmark",
      c: "45-DK-0",
      b: "45",
      f: "DK"
    }, {
      name: "Djibouti",
      c: "253-DJ-0",
      b: "253",
      f: "DJ"
    }, {
      name: "Dominica",
      c: "1-DM-0",
      b: "1",
      f: "DM"
    }, {
      name: "Dominican Republic",
      c: "1-DO-0",
      b: "1",
      f: "DO"
    }, {
      name: "East Timor",
      c: "670-TL-0",
      b: "670",
      f: "TL"
    }, {
      name: "Ecuador",
      c: "593-EC-0",
      b: "593",
      f: "EC"
    }, {
      name: "Egypt",
      c: "20-EG-0",
      b: "20",
      f: "EG"
    }, {
      name: "El Salvador",
      c: "503-SV-0",
      b: "503",
      f: "SV"
    }, {
      name: "Equatorial Guinea",
      c: "240-GQ-0",
      b: "240",
      f: "GQ"
    }, {
      name: "Eritrea",
      c: "291-ER-0",
      b: "291",
      f: "ER"
    }, {
      name: "Estonia",
      c: "372-EE-0",
      b: "372",
      f: "EE"
    }, {
      name: "Ethiopia",
      c: "251-ET-0",
      b: "251",
      f: "ET"
    }, {
      name: "Falkland Islands [Islas Malvinas]",
      c: "500-FK-0",
      b: "500",
      f: "FK"
    }, {
      name: "Faroe Islands",
      c: "298-FO-0",
      b: "298",
      f: "FO"
    }, {
      name: "Fiji",
      c: "679-FJ-0",
      b: "679",
      f: "FJ"
    }, {
      name: "Finland",
      c: "358-FI-0",
      b: "358",
      f: "FI"
    }, {
      name: "France",
      c: "33-FR-0",
      b: "33",
      f: "FR"
    }, {
      name: "French Guiana",
      c: "594-GF-0",
      b: "594",
      f: "GF"
    }, {
      name: "French Polynesia",
      c: "689-PF-0",
      b: "689",
      f: "PF"
    }, {
      name: "Gabon",
      c: "241-GA-0",
      b: "241",
      f: "GA"
    }, {
      name: "Gambia",
      c: "220-GM-0",
      b: "220",
      f: "GM"
    }, {
      name: "Georgia",
      c: "995-GE-0",
      b: "995",
      f: "GE"
    }, {
      name: "Germany",
      c: "49-DE-0",
      b: "49",
      f: "DE"
    }, {
      name: "Ghana",
      c: "233-GH-0",
      b: "233",
      f: "GH"
    }, {
      name: "Gibraltar",
      c: "350-GI-0",
      b: "350",
      f: "GI"
    }, {
      name: "Greece",
      c: "30-GR-0",
      b: "30",
      f: "GR"
    }, {
      name: "Greenland",
      c: "299-GL-0",
      b: "299",
      f: "GL"
    }, {
      name: "Grenada",
      c: "1-GD-0",
      b: "1",
      f: "GD"
    }, {
      name: "Guadeloupe",
      c: "590-GP-0",
      b: "590",
      f: "GP"
    }, {
      name: "Guam",
      c: "1-GU-0",
      b: "1",
      f: "GU"
    }, {
      name: "Guatemala",
      c: "502-GT-0",
      b: "502",
      f: "GT"
    }, {
      name: "Guernsey",
      c: "44-GG-0",
      b: "44",
      f: "GG"
    }, {
      name: "Guinea Conakry",
      c: "224-GN-0",
      b: "224",
      f: "GN"
    }, {
      name: "Guinea-Bissau",
      c: "245-GW-0",
      b: "245",
      f: "GW"
    }, {
      name: "Guyana",
      c: "592-GY-0",
      b: "592",
      f: "GY"
    }, {
      name: "Haiti",
      c: "509-HT-0",
      b: "509",
      f: "HT"
    }, {
      name: "Heard Island and McDonald Islands",
      c: "672-HM-0",
      b: "672",
      f: "HM"
    }, {
      name: "Honduras",
      c: "504-HN-0",
      b: "504",
      f: "HN"
    }, {
      name: "Hong Kong",
      c: "852-HK-0",
      b: "852",
      f: "HK"
    }, {
      name: "Hungary",
      c: "36-HU-0",
      b: "36",
      f: "HU"
    }, {
      name: "Iceland",
      c: "354-IS-0",
      b: "354",
      f: "IS"
    }, {
      name: "India",
      c: "91-IN-0",
      b: "91",
      f: "IN"
    }, {
      name: "Indonesia",
      c: "62-ID-0",
      b: "62",
      f: "ID"
    }, {
      name: "Iran",
      c: "98-IR-0",
      b: "98",
      f: "IR"
    }, {
      name: "Iraq",
      c: "964-IQ-0",
      b: "964",
      f: "IQ"
    }, {
      name: "Ireland",
      c: "353-IE-0",
      b: "353",
      f: "IE"
    }, {
      name: "Isle of Man",
      c: "44-IM-0",
      b: "44",
      f: "IM"
    }, {
      name: "Israel",
      c: "972-IL-0",
      b: "972",
      f: "IL"
    }, {
      name: "Italy",
      c: "39-IT-0",
      b: "39",
      f: "IT"
    }, {
      name: "Jamaica",
      c: "1-JM-0",
      b: "1",
      f: "JM"
    }, {
      name: "Japan",
      c: "81-JP-0",
      b: "81",
      f: "JP"
    }, {
      name: "Jersey",
      c: "44-JE-0",
      b: "44",
      f: "JE"
    }, {
      name: "Jordan",
      c: "962-JO-0",
      b: "962",
      f: "JO"
    }, {
      name: "Kazakhstan",
      c: "7-KZ-0",
      b: "7",
      f: "KZ"
    }, {
      name: "Kenya",
      c: "254-KE-0",
      b: "254",
      f: "KE"
    }, {
      name: "Kiribati",
      c: "686-KI-0",
      b: "686",
      f: "KI"
    }, {
      name: "Kosovo",
      c: "377-XK-0",
      b: "377",
      f: "XK"
    }, {
      name: "Kosovo",
      c: "381-XK-0",
      b: "381",
      f: "XK"
    }, {
      name: "Kosovo",
      c: "386-XK-0",
      b: "386",
      f: "XK"
    }, {
      name: "Kuwait",
      c: "965-KW-0",
      b: "965",
      f: "KW"
    }, {
      name: "Kyrgyzstan",
      c: "996-KG-0",
      b: "996",
      f: "KG"
    }, {
      name: "Laos",
      c: "856-LA-0",
      b: "856",
      f: "LA"
    }, {
      name: "Latvia",
      c: "371-LV-0",
      b: "371",
      f: "LV"
    }, {
      name: "Lebanon",
      c: "961-LB-0",
      b: "961",
      f: "LB"
    }, {
      name: "Lesotho",
      c: "266-LS-0",
      b: "266",
      f: "LS"
    }, {
      name: "Liberia",
      c: "231-LR-0",
      b: "231",
      f: "LR"
    }, {
      name: "Libya",
      c: "218-LY-0",
      b: "218",
      f: "LY"
    }, {
      name: "Liechtenstein",
      c: "423-LI-0",
      b: "423",
      f: "LI"
    }, {
      name: "Lithuania",
      c: "370-LT-0",
      b: "370",
      f: "LT"
    }, {
      name: "Luxembourg",
      c: "352-LU-0",
      b: "352",
      f: "LU"
    }, {
      name: "Macau",
      c: "853-MO-0",
      b: "853",
      f: "MO"
    }, {
      name: "Macedonia",
      c: "389-MK-0",
      b: "389",
      f: "MK"
    }, {
      name: "Madagascar",
      c: "261-MG-0",
      b: "261",
      f: "MG"
    }, {
      name: "Malawi",
      c: "265-MW-0",
      b: "265",
      f: "MW"
    }, {
      name: "Malaysia",
      c: "60-MY-0",
      b: "60",
      f: "MY"
    }, {
      name: "Maldives",
      c: "960-MV-0",
      b: "960",
      f: "MV"
    }, {
      name: "Mali",
      c: "223-ML-0",
      b: "223",
      f: "ML"
    }, {
      name: "Malta",
      c: "356-MT-0",
      b: "356",
      f: "MT"
    }, {
      name: "Marshall Islands",
      c: "692-MH-0",
      b: "692",
      f: "MH"
    }, {
      name: "Martinique",
      c: "596-MQ-0",
      b: "596",
      f: "MQ"
    }, {
      name: "Mauritania",
      c: "222-MR-0",
      b: "222",
      f: "MR"
    }, {
      name: "Mauritius",
      c: "230-MU-0",
      b: "230",
      f: "MU"
    }, {
      name: "Mayotte",
      c: "262-YT-0",
      b: "262",
      f: "YT"
    }, {
      name: "Mexico",
      c: "52-MX-0",
      b: "52",
      f: "MX"
    }, {
      name: "Micronesia",
      c: "691-FM-0",
      b: "691",
      f: "FM"
    }, {
      name: "Moldova",
      c: "373-MD-0",
      b: "373",
      f: "MD"
    }, {
      name: "Monaco",
      c: "377-MC-0",
      b: "377",
      f: "MC"
    }, {
      name: "Mongolia",
      c: "976-MN-0",
      b: "976",
      f: "MN"
    }, {
      name: "Montenegro",
      c: "382-ME-0",
      b: "382",
      f: "ME"
    }, {
      name: "Montserrat",
      c: "1-MS-0",
      b: "1",
      f: "MS"
    }, {
      name: "Morocco",
      c: "212-MA-0",
      b: "212",
      f: "MA"
    }, {
      name: "Mozambique",
      c: "258-MZ-0",
      b: "258",
      f: "MZ"
    }, {
      name: "Myanmar [Burma]",
      c: "95-MM-0",
      b: "95",
      f: "MM"
    }, {
      name: "Namibia",
      c: "264-NA-0",
      b: "264",
      f: "NA"
    }, {
      name: "Nauru",
      c: "674-NR-0",
      b: "674",
      f: "NR"
    }, {
      name: "Nepal",
      c: "977-NP-0",
      b: "977",
      f: "NP"
    }, {
      name: "Netherlands",
      c: "31-NL-0",
      b: "31",
      f: "NL"
    }, {
      name: "New Caledonia",
      c: "687-NC-0",
      b: "687",
      f: "NC"
    }, {
      name: "New Zealand",
      c: "64-NZ-0",
      b: "64",
      f: "NZ"
    }, {
      name: "Nicaragua",
      c: "505-NI-0",
      b: "505",
      f: "NI"
    }, {
      name: "Niger",
      c: "227-NE-0",
      b: "227",
      f: "NE"
    }, {
      name: "Nigeria",
      c: "234-NG-0",
      b: "234",
      f: "NG"
    }, {
      name: "Niue",
      c: "683-NU-0",
      b: "683",
      f: "NU"
    }, {
      name: "Norfolk Island",
      c: "672-NF-0",
      b: "672",
      f: "NF"
    }, {
      name: "North Korea",
      c: "850-KP-0",
      b: "850",
      f: "KP"
    }, {
      name: "Northern Mariana Islands",
      c: "1-MP-0",
      b: "1",
      f: "MP"
    }, {
      name: "Norway",
      c: "47-NO-0",
      b: "47",
      f: "NO"
    }, {
      name: "Oman",
      c: "968-OM-0",
      b: "968",
      f: "OM"
    }, {
      name: "Pakistan",
      c: "92-PK-0",
      b: "92",
      f: "PK"
    }, {
      name: "Palau",
      c: "680-PW-0",
      b: "680",
      f: "PW"
    }, {
      name: "Palestinian Territories",
      c: "970-PS-0",
      b: "970",
      f: "PS"
    }, {
      name: "Panama",
      c: "507-PA-0",
      b: "507",
      f: "PA"
    }, {
      name: "Papua New Guinea",
      c: "675-PG-0",
      b: "675",
      f: "PG"
    }, {
      name: "Paraguay",
      c: "595-PY-0",
      b: "595",
      f: "PY"
    }, {
      name: "Peru",
      c: "51-PE-0",
      b: "51",
      f: "PE"
    }, {
      name: "Philippines",
      c: "63-PH-0",
      b: "63",
      f: "PH"
    }, {
      name: "Poland",
      c: "48-PL-0",
      b: "48",
      f: "PL"
    }, {
      name: "Portugal",
      c: "351-PT-0",
      b: "351",
      f: "PT"
    }, {
      name: "Puerto Rico",
      c: "1-PR-0",
      b: "1",
      f: "PR"
    }, {
      name: "Qatar",
      c: "974-QA-0",
      b: "974",
      f: "QA"
    }, {
      name: "R\xE9union",
      c: "262-RE-0",
      b: "262",
      f: "RE"
    }, {
      name: "Romania",
      c: "40-RO-0",
      b: "40",
      f: "RO"
    }, {
      name: "Russia",
      c: "7-RU-0",
      b: "7",
      f: "RU"
    }, {
      name: "Rwanda",
      c: "250-RW-0",
      b: "250",
      f: "RW"
    }, {
      name: "Saint Barth\xE9lemy",
      c: "590-BL-0",
      b: "590",
      f: "BL"
    }, {
      name: "Saint Helena",
      c: "290-SH-0",
      b: "290",
      f: "SH"
    }, {
      name: "St. Kitts",
      c: "1-KN-0",
      b: "1",
      f: "KN"
    }, {
      name: "St. Lucia",
      c: "1-LC-0",
      b: "1",
      f: "LC"
    }, {
      name: "Saint Martin",
      c: "590-MF-0",
      b: "590",
      f: "MF"
    }, {
      name: "Saint Pierre and Miquelon",
      c: "508-PM-0",
      b: "508",
      f: "PM"
    }, {
      name: "St. Vincent",
      c: "1-VC-0",
      b: "1",
      f: "VC"
    }, {
      name: "Samoa",
      c: "685-WS-0",
      b: "685",
      f: "WS"
    }, {
      name: "San Marino",
      c: "378-SM-0",
      b: "378",
      f: "SM"
    }, {
      name: "S\xE3o Tom\xE9 and Pr\xEDncipe",
      c: "239-ST-0",
      b: "239",
      f: "ST"
    }, {
      name: "Saudi Arabia",
      c: "966-SA-0",
      b: "966",
      f: "SA"
    }, {
      name: "Senegal",
      c: "221-SN-0",
      b: "221",
      f: "SN"
    }, {
      name: "Serbia",
      c: "381-RS-0",
      b: "381",
      f: "RS"
    }, {
      name: "Seychelles",
      c: "248-SC-0",
      b: "248",
      f: "SC"
    }, {
      name: "Sierra Leone",
      c: "232-SL-0",
      b: "232",
      f: "SL"
    }, {
      name: "Singapore",
      c: "65-SG-0",
      b: "65",
      f: "SG"
    }, {
      name: "Sint Maarten",
      c: "1-SX-0",
      b: "1",
      f: "SX"
    }, {
      name: "Slovakia",
      c: "421-SK-0",
      b: "421",
      f: "SK"
    }, {
      name: "Slovenia",
      c: "386-SI-0",
      b: "386",
      f: "SI"
    }, {
      name: "Solomon Islands",
      c: "677-SB-0",
      b: "677",
      f: "SB"
    }, {
      name: "Somalia",
      c: "252-SO-0",
      b: "252",
      f: "SO"
    }, {
      name: "South Africa",
      c: "27-ZA-0",
      b: "27",
      f: "ZA"
    }, {
      name: "South Georgia and the South Sandwich Islands",
      c: "500-GS-0",
      b: "500",
      f: "GS"
    }, {
      name: "South Korea",
      c: "82-KR-0",
      b: "82",
      f: "KR"
    }, {
      name: "South Sudan",
      c: "211-SS-0",
      b: "211",
      f: "SS"
    }, {
      name: "Spain",
      c: "34-ES-0",
      b: "34",
      f: "ES"
    }, {
      name: "Sri Lanka",
      c: "94-LK-0",
      b: "94",
      f: "LK"
    }, {
      name: "Sudan",
      c: "249-SD-0",
      b: "249",
      f: "SD"
    }, {
      name: "Suriname",
      c: "597-SR-0",
      b: "597",
      f: "SR"
    }, {
      name: "Svalbard and Jan Mayen",
      c: "47-SJ-0",
      b: "47",
      f: "SJ"
    }, {
      name: "Swaziland",
      c: "268-SZ-0",
      b: "268",
      f: "SZ"
    }, {
      name: "Sweden",
      c: "46-SE-0",
      b: "46",
      f: "SE"
    }, {
      name: "Switzerland",
      c: "41-CH-0",
      b: "41",
      f: "CH"
    }, {
      name: "Syria",
      c: "963-SY-0",
      b: "963",
      f: "SY"
    }, {
      name: "Taiwan",
      c: "886-TW-0",
      b: "886",
      f: "TW"
    }, {
      name: "Tajikistan",
      c: "992-TJ-0",
      b: "992",
      f: "TJ"
    }, {
      name: "Tanzania",
      c: "255-TZ-0",
      b: "255",
      f: "TZ"
    }, {
      name: "Thailand",
      c: "66-TH-0",
      b: "66",
      f: "TH"
    }, {
      name: "Togo",
      c: "228-TG-0",
      b: "228",
      f: "TG"
    }, {
      name: "Tokelau",
      c: "690-TK-0",
      b: "690",
      f: "TK"
    }, {
      name: "Tonga",
      c: "676-TO-0",
      b: "676",
      f: "TO"
    }, {
      name: "Trinidad/Tobago",
      c: "1-TT-0",
      b: "1",
      f: "TT"
    }, {
      name: "Tunisia",
      c: "216-TN-0",
      b: "216",
      f: "TN"
    }, {
      name: "Turkey",
      c: "90-TR-0",
      b: "90",
      f: "TR"
    }, {
      name: "Turkmenistan",
      c: "993-TM-0",
      b: "993",
      f: "TM"
    }, {
      name: "Turks and Caicos Islands",
      c: "1-TC-0",
      b: "1",
      f: "TC"
    }, {
      name: "Tuvalu",
      c: "688-TV-0",
      b: "688",
      f: "TV"
    }, {
      name: "U.S. Virgin Islands",
      c: "1-VI-0",
      b: "1",
      f: "VI"
    }, {
      name: "Uganda",
      c: "256-UG-0",
      b: "256",
      f: "UG"
    }, {
      name: "Ukraine",
      c: "380-UA-0",
      b: "380",
      f: "UA"
    }, {
      name: "United Arab Emirates",
      c: "971-AE-0",
      b: "971",
      f: "AE"
    }, {
      name: "United Kingdom",
      c: "44-GB-0",
      b: "44",
      f: "GB"
    }, {
      name: "United States",
      c: "1-US-0",
      b: "1",
      f: "US"
    }, {
      name: "Uruguay",
      c: "598-UY-0",
      b: "598",
      f: "UY"
    }, {
      name: "Uzbekistan",
      c: "998-UZ-0",
      b: "998",
      f: "UZ"
    }, {
      name: "Vanuatu",
      c: "678-VU-0",
      b: "678",
      f: "VU"
    }, {
      name: "Vatican City",
      c: "379-VA-0",
      b: "379",
      f: "VA"
    }, {
      name: "Venezuela",
      c: "58-VE-0",
      b: "58",
      f: "VE"
    }, {
      name: "Vietnam",
      c: "84-VN-0",
      b: "84",
      f: "VN"
    }, {
      name: "Wallis and Futuna",
      c: "681-WF-0",
      b: "681",
      f: "WF"
    }, {
      name: "Western Sahara",
      c: "212-EH-0",
      b: "212",
      f: "EH"
    }, {
      name: "Yemen",
      c: "967-YE-0",
      b: "967",
      f: "YE"
    }, {
      name: "Zambia",
      c: "260-ZM-0",
      b: "260",
      f: "ZM"
    }, {
      name: "Zimbabwe",
      c: "263-ZW-0",
      b: "263",
      f: "ZW"
    }];
    Uh(Rh);
    var Vh = new Oh(Rh);

    function Wh(a, b) {
      this.a = a;
      this.Aa = b;
    }

    function Xh(a) {
      a = Va(a);
      var b = Ph(Vh, a);
      return 0 < b.length ? new Wh("1" == b[0].b ? "1-US-0" : b[0].c, Va(a.substr(b[0].b.length + 1))) : null;
    }

    function Yh(a) {
      var b = Qh(a.a);
      if (!b) throw Error("Country ID " + a.a + " not found.");
      return "+" + b.b + a.Aa;
    }

    function Zh(a, b) {
      for (var c = 0; c < a.length; c++) {
        if (!Ma($h, a[c]) && (null !== ai && a[c] in ai || Ma(b, a[c]))) return a[c];
      }

      return null;
    }

    var $h = ["emailLink", "password", "phone"],
        ai = {
      "facebook.com": "FacebookAuthProvider",
      "github.com": "GithubAuthProvider",
      "google.com": "GoogleAuthProvider",
      password: "EmailAuthProvider",
      "twitter.com": "TwitterAuthProvider",
      phone: "PhoneAuthProvider"
    };

    function bi() {
      this.a = new Hh();
      I(this.a, "acUiConfig");
      I(this.a, "autoUpgradeAnonymousUsers");
      I(this.a, "callbacks");
      I(this.a, "credentialHelper", ci);
      I(this.a, "immediateFederatedRedirect", !1);
      I(this.a, "popupMode", !1);
      I(this.a, "privacyPolicyUrl");
      I(this.a, "queryParameterForSignInSuccessUrl", "signInSuccessUrl");
      I(this.a, "queryParameterForWidgetMode", "mode");
      I(this.a, "signInFlow");
      I(this.a, "signInOptions");
      I(this.a, "signInSuccessUrl");
      I(this.a, "siteName");
      I(this.a, "tosUrl");
      I(this.a, "widgetUrl");
    }

    function di(a) {
      var b = !!a.a.get("autoUpgradeAnonymousUsers");
      b && !ei(a) && og('Missing "signInFailure" callback: "signInFailure" callback needs to be provided when "autoUpgradeAnonymousUsers" is set to true.', void 0);
      return b;
    }

    function fi(a) {
      a = a.a.get("signInOptions") || [];

      for (var b = [], c = 0; c < a.length; c++) {
        var d = a[c];
        d = ta(d) ? d : {
          provider: d
        };
        d.provider && b.push(d);
      }

      return b;
    }

    function gi(a, b) {
      a = fi(a);

      for (var c = 0; c < a.length; c++) {
        if (a[c].provider === b) return a[c];
      }

      return null;
    }

    function hi(a) {
      return Ka(fi(a), function (b) {
        return b.provider;
      });
    }

    function ii(a, b) {
      a = ji(a);

      for (var c = 0; c < a.length; c++) {
        if (a[c].providerId === b) return a[c];
      }

      return null;
    }

    function ji(a) {
      return Ka(fi(a), function (b) {
        if (ai[b.provider] || Ma(ki, b.provider)) {
          b = {
            providerId: b.provider,
            S: b.providerName || null,
            V: b.fullLabel || null,
            ta: b.buttonColor || null,
            za: b.iconUrl ? Ac(Cc(b.iconUrl)).toString() : null
          };

          for (var c in b) {
            null === b[c] && delete b[c];
          }

          return b;
        }

        return {
          providerId: b.provider,
          S: b.providerName || null,
          V: b.fullLabel || null,
          ta: b.buttonColor || null,
          za: b.iconUrl ? Ac(Cc(b.iconUrl)).toString() : null,
          Mb: b.loginHintKey || null
        };
      });
    }

    function li(a) {
      var b = gi(a, firebase.auth.GoogleAuthProvider.PROVIDER_ID);
      return b && b.clientId && mi(a) === ni ? b.clientId || null : null;
    }

    function oi(a) {
      var b = null;
      Ha(fi(a), function (d) {
        d.provider == firebase.auth.PhoneAuthProvider.PROVIDER_ID && ta(d.recaptchaParameters) && !Array.isArray(d.recaptchaParameters) && (b = fb(d.recaptchaParameters));
      });

      if (b) {
        var c = [];
        Ha(pi, function (d) {
          "undefined" !== typeof b[d] && (c.push(d), delete b[d]);
        });
        c.length && tg('The following provided "recaptchaParameters" keys are not allowed: ' + c.join(", "));
      }

      return b;
    }

    function qi(a, b) {
      a = (a = gi(a, b)) && a.scopes;
      return Array.isArray(a) ? a : [];
    }

    function ri(a, b) {
      a = (a = gi(a, b)) && a.customParameters;
      return ta(a) ? (a = fb(a), b === firebase.auth.GoogleAuthProvider.PROVIDER_ID && delete a.login_hint, b === firebase.auth.GithubAuthProvider.PROVIDER_ID && delete a.login, a) : null;
    }

    function si(a) {
      a = gi(a, firebase.auth.PhoneAuthProvider.PROVIDER_ID);
      var b = null;
      a && "string" === typeof a.loginHint && (b = Xh(a.loginHint));
      return a && a.defaultNationalNumber || b && b.Aa || null;
    }

    function ti(a) {
      var b = (a = gi(a, firebase.auth.PhoneAuthProvider.PROVIDER_ID)) && a.defaultCountry || null;
      b = b && Sh(b);
      var c = null;
      a && "string" === typeof a.loginHint && (c = Xh(a.loginHint));
      return b && b[0] || c && Qh(c.a) || null;
    }

    function ui(a) {
      a = gi(a, firebase.auth.PhoneAuthProvider.PROVIDER_ID);
      if (!a) return null;
      var b = a.whitelistedCountries,
          c = a.blacklistedCountries;
      if ("undefined" !== typeof b && (!Array.isArray(b) || 0 == b.length)) throw Error("WhitelistedCountries must be a non-empty array.");
      if ("undefined" !== typeof c && !Array.isArray(c)) throw Error("BlacklistedCountries must be an array.");
      if (b && c) throw Error("Both whitelistedCountries and blacklistedCountries are provided.");
      if (!b && !c) return Rh;
      a = [];

      if (b) {
        c = {};

        for (var d = 0; d < b.length; d++) {
          var e = Th(b[d]);

          for (var f = 0; f < e.length; f++) {
            c[e[f].c] = e[f];
          }
        }

        for (var g in c) {
          c.hasOwnProperty(g) && a.push(c[g]);
        }
      } else {
        g = {};

        for (b = 0; b < c.length; b++) {
          for (e = Th(c[b]), d = 0; d < e.length; d++) {
            g[e[d].c] = e[d];
          }
        }

        for (e = 0; e < Rh.length; e++) {
          null !== g && Rh[e].c in g || a.push(Rh[e]);
        }
      }

      return a;
    }

    function vi(a) {
      return Jh(a.a, "queryParameterForWidgetMode");
    }

    function J(a) {
      var b = a.a.get("tosUrl") || null;
      a = a.a.get("privacyPolicyUrl") || null;
      b && !a && tg("Privacy Policy URL is missing, the link will not be displayed.");

      if (b && a) {
        if ("function" === typeof b) return b;
        if ("string" === typeof b) return function () {
          rf(b);
        };
      }

      return null;
    }

    function wi(a) {
      var b = a.a.get("tosUrl") || null,
          c = a.a.get("privacyPolicyUrl") || null;
      c && !b && tg("Term of Service URL is missing, the link will not be displayed.");

      if (b && c) {
        if ("function" === typeof c) return c;
        if ("string" === typeof c) return function () {
          rf(c);
        };
      }

      return null;
    }

    function xi(a) {
      return (a = gi(a, firebase.auth.EmailAuthProvider.PROVIDER_ID)) && "undefined" !== typeof a.requireDisplayName ? !!a.requireDisplayName : !0;
    }

    function yi(a) {
      a = gi(a, firebase.auth.EmailAuthProvider.PROVIDER_ID);
      return !(!a || a.signInMethod !== firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD);
    }

    function zi(a) {
      a = gi(a, firebase.auth.EmailAuthProvider.PROVIDER_ID);
      return !(!a || !a.forceSameDevice);
    }

    function Ai(a) {
      if (yi(a)) {
        var b = {
          url: tf(),
          handleCodeInApp: !0
        };
        (a = gi(a, firebase.auth.EmailAuthProvider.PROVIDER_ID)) && "function" === typeof a.emailLinkSignIn && hb(b, a.emailLinkSignIn());
        a = b.url;
        var c = tf();
        c instanceof wb || (c = Kb(c));
        a instanceof wb || (a = Kb(a));
        var d = c;
        c = new wb(d);
        var e = !!a.j;
        e ? xb(c, a.j) : e = !!a.A;
        e ? c.A = a.A : e = !!a.h;
        e ? c.h = a.h : e = null != a.C;
        var f = a.g;
        if (e) yb(c, a.C);else if (e = !!a.g) if ("/" != f.charAt(0) && (d.h && !d.g ? f = "/" + f : (d = c.g.lastIndexOf("/"), -1 != d && (f = c.g.substr(0, d + 1) + f))), ".." == f || "." == f) f = "";else if (-1 != f.indexOf("./") || -1 != f.indexOf("/.")) {
          d = 0 == f.lastIndexOf("/", 0);
          f = f.split("/");

          for (var g = [], h = 0; h < f.length;) {
            var k = f[h++];
            "." == k ? d && h == f.length && g.push("") : ".." == k ? ((1 < g.length || 1 == g.length && "" != g[0]) && g.pop(), d && h == f.length && g.push("")) : (g.push(k), d = !0);
          }

          f = g.join("/");
        }
        e ? c.g = f : e = "" !== a.a.toString();
        e ? zb(c, Ab(a.a)) : e = !!a.s;
        e && (c.s = a.s);
        b.url = c.toString();
        return b;
      }

      return null;
    }

    function Bi(a) {
      var b = !!a.a.get("immediateFederatedRedirect"),
          c = hi(a);
      a = Ci(a);
      return b && 1 == c.length && !Ma($h, c[0]) && a == Di;
    }

    function Ci(a) {
      a = a.a.get("signInFlow");

      for (var b in Ei) {
        if (Ei[b] == a) return Ei[b];
      }

      return Di;
    }

    function Fi(a) {
      return Gi(a).signInSuccess || null;
    }

    function Hi(a) {
      return Gi(a).signInSuccessWithAuthResult || null;
    }

    function ei(a) {
      return Gi(a).signInFailure || null;
    }

    function Gi(a) {
      return a.a.get("callbacks") || {};
    }

    function mi(a) {
      if ("http:" !== (window.location && window.location.protocol) && "https:" !== (window.location && window.location.protocol)) return ci;
      a = a.a.get("credentialHelper");
      if (a === Ii) return ci;

      for (var b in Ji) {
        if (Ji[b] === a) return Ji[b];
      }

      return ci;
    }

    var Ii = "accountchooser.com",
        ni = "googleyolo",
        ci = "none",
        Ji = {
      ic: Ii,
      lc: ni,
      NONE: ci
    },
        Di = "redirect",
        Ei = {
      oc: "popup",
      pc: Di
    },
        Ki = {
      kc: "callback",
      RECOVER_EMAIL: "recoverEmail",
      qc: "resetPassword",
      REVERT_SECOND_FACTOR_ADDITION: "revertSecondFactorAddition",
      rc: "select",
      sc: "signIn",
      VERIFY_AND_CHANGE_EMAIL: "verifyAndChangeEmail",
      VERIFY_EMAIL: "verifyEmail"
    },
        ki = ["anonymous"],
        pi = ["sitekey", "tabindex", "callback", "expired-callback"];
    var Li,
        Mi,
        Ni,
        Oi,
        K = {};

    function L(a, b, c, d) {
      K[a].apply(null, Array.prototype.slice.call(arguments, 1));
    }

    function Pi(a) {
      if (a.classList) return a.classList;
      a = a.className;
      return q(a) && a.match(/\S+/g) || [];
    }

    function Qi(a, b) {
      return a.classList ? a.classList.contains(b) : Ma(Pi(a), b);
    }

    function Ri(a, b) {
      a.classList ? a.classList.add(b) : Qi(a, b) || (a.className += 0 < a.className.length ? " " + b : b);
    }

    function Si(a, b) {
      a.classList ? a.classList.remove(b) : Qi(a, b) && (a.className = Ja(Pi(a), function (c) {
        return c != b;
      }).join(" "));
    }

    function Ti(a) {
      var b = a.type;

      switch (q(b) && b.toLowerCase()) {
        case "checkbox":
        case "radio":
          return a.checked ? a.value : null;

        case "select-one":
          return b = a.selectedIndex, 0 <= b ? a.options[b].value : null;

        case "select-multiple":
          b = [];

          for (var c, d = 0; c = a.options[d]; d++) {
            c.selected && b.push(c.value);
          }

          return b.length ? b : null;

        default:
          return null != a.value ? a.value : null;
      }
    }

    function Ui(a, b) {
      var c = a.type;

      switch (q(c) && c.toLowerCase()) {
        case "checkbox":
        case "radio":
          a.checked = b;
          break;

        case "select-one":
          a.selectedIndex = -1;
          if (q(b)) for (var d = 0; c = a.options[d]; d++) {
            if (c.value == b) {
              c.selected = !0;
              break;
            }
          }
          break;

        case "select-multiple":
          q(b) && (b = [b]);

          for (d = 0; c = a.options[d]; d++) {
            if (c.selected = !1, b) for (var e, f = 0; e = b[f]; f++) {
              c.value == e && (c.selected = !0);
            }
          }

          break;

        default:
          a.value = null != b ? b : "";
      }
    }

    function Vi(a) {
      if (a.altKey && !a.ctrlKey || a.metaKey || 112 <= a.keyCode && 123 >= a.keyCode) return !1;
      if (Wi(a.keyCode)) return !0;

      switch (a.keyCode) {
        case 18:
        case 20:
        case 93:
        case 17:
        case 40:
        case 35:
        case 27:
        case 36:
        case 45:
        case 37:
        case 224:
        case 91:
        case 144:
        case 12:
        case 34:
        case 33:
        case 19:
        case 255:
        case 44:
        case 39:
        case 145:
        case 16:
        case 38:
        case 252:
        case 224:
        case 92:
          return !1;

        case 0:
          return !ec;

        default:
          return 166 > a.keyCode || 183 < a.keyCode;
      }
    }

    function Xi(a, b, c, d, e, f) {
      if (fc && !nc("525")) return !0;
      if (hc && e) return Wi(a);
      if (e && !d) return !1;

      if (!ec) {
        "number" == typeof b && (b = Yi(b));
        var g = 17 == b || 18 == b || hc && 91 == b;
        if ((!c || hc) && g || hc && 16 == b && (d || f)) return !1;
      }

      if ((fc || cc) && d && c) switch (a) {
        case 220:
        case 219:
        case 221:
        case 192:
        case 186:
        case 189:
        case 187:
        case 188:
        case 190:
        case 191:
        case 192:
        case 222:
          return !1;
      }
      if (z && d && b == a) return !1;

      switch (a) {
        case 13:
          return ec ? f || e ? !1 : !(c && d) : !0;

        case 27:
          return !(fc || cc || ec);
      }

      return ec && (d || e || f) ? !1 : Wi(a);
    }

    function Wi(a) {
      if (48 <= a && 57 >= a || 96 <= a && 106 >= a || 65 <= a && 90 >= a || (fc || cc) && 0 == a) return !0;

      switch (a) {
        case 32:
        case 43:
        case 63:
        case 64:
        case 107:
        case 109:
        case 110:
        case 111:
        case 186:
        case 59:
        case 189:
        case 187:
        case 61:
        case 188:
        case 190:
        case 191:
        case 192:
        case 222:
        case 219:
        case 220:
        case 221:
        case 163:
          return !0;

        case 173:
          return ec;

        default:
          return !1;
      }
    }

    function Yi(a) {
      if (ec) a = Zi(a);else if (hc && fc) switch (a) {
        case 93:
          a = 91;
      }
      return a;
    }

    function Zi(a) {
      switch (a) {
        case 61:
          return 187;

        case 59:
          return 186;

        case 173:
          return 189;

        case 224:
          return 91;

        case 0:
          return 224;

        default:
          return a;
      }
    }

    function $i(a) {
      E.call(this);
      this.a = a;
      le(a, "keydown", this.g, !1, this);
      le(a, "click", this.h, !1, this);
    }

    w($i, E);

    $i.prototype.g = function (a) {
      (13 == a.keyCode || fc && 3 == a.keyCode) && aj(this, a);
    };

    $i.prototype.h = function (a) {
      aj(this, a);
    };

    function aj(a, b) {
      var c = new bj(b);

      if (ye(a, c)) {
        c = new cj(b);

        try {
          ye(a, c);
        } finally {
          b.stopPropagation();
        }
      }
    }

    $i.prototype.m = function () {
      $i.K.m.call(this);
      te(this.a, "keydown", this.g, !1, this);
      te(this.a, "click", this.h, !1, this);
      delete this.a;
    };

    function cj(a) {
      $d.call(this, a.a);
      this.type = "action";
    }

    w(cj, $d);

    function bj(a) {
      $d.call(this, a.a);
      this.type = "beforeaction";
    }

    w(bj, $d);

    function dj(a) {
      E.call(this);
      this.a = a;
      a = z ? "focusout" : "blur";
      this.g = le(this.a, z ? "focusin" : "focus", this, !z);
      this.h = le(this.a, a, this, !z);
    }

    w(dj, E);

    dj.prototype.handleEvent = function (a) {
      var b = new $d(a.a);
      b.type = "focusin" == a.type || "focus" == a.type ? "focusin" : "focusout";
      ye(this, b);
    };

    dj.prototype.m = function () {
      dj.K.m.call(this);
      ue(this.g);
      ue(this.h);
      delete this.a;
    };

    function ej(a, b) {
      E.call(this);
      this.g = a || 1;
      this.a = b || n;
      this.h = t(this.ec, this);
      this.j = Aa();
    }

    w(ej, E);
    l = ej.prototype;
    l.Ka = !1;
    l.aa = null;

    l.ec = function () {
      if (this.Ka) {
        var a = Aa() - this.j;
        0 < a && a < .8 * this.g ? this.aa = this.a.setTimeout(this.h, this.g - a) : (this.aa && (this.a.clearTimeout(this.aa), this.aa = null), ye(this, "tick"), this.Ka && (fj(this), this.start()));
      }
    };

    l.start = function () {
      this.Ka = !0;
      this.aa || (this.aa = this.a.setTimeout(this.h, this.g), this.j = Aa());
    };

    function fj(a) {
      a.Ka = !1;
      a.aa && (a.a.clearTimeout(a.aa), a.aa = null);
    }

    l.m = function () {
      ej.K.m.call(this);
      fj(this);
      delete this.a;
    };

    function gj(a, b) {
      if (sa(a)) b && (a = t(a, b));else if (a && "function" == typeof a.handleEvent) a = t(a.handleEvent, a);else throw Error("Invalid listener argument");
      return 2147483647 < Number(0) ? -1 : n.setTimeout(a, 0);
    }

    function hj(a) {
      Qd.call(this);
      this.g = a;
      this.a = {};
    }

    w(hj, Qd);
    var ij = [];

    function jj(a, b, c, d) {
      qa(c) || (c && (ij[0] = c.toString()), c = ij);

      for (var e = 0; e < c.length; e++) {
        var f = le(b, c[e], d || a.handleEvent, !1, a.g || a);
        if (!f) break;
        a.a[f.key] = f;
      }
    }

    function kj(a) {
      eb(a.a, function (b, c) {
        this.a.hasOwnProperty(c) && ue(b);
      }, a);
      a.a = {};
    }

    hj.prototype.m = function () {
      hj.K.m.call(this);
      kj(this);
    };

    hj.prototype.handleEvent = function () {
      throw Error("EventHandler.handleEvent not implemented");
    };

    function lj(a) {
      E.call(this);
      this.a = null;
      this.g = a;
      a = z || cc || fc && !nc("531") && "TEXTAREA" == a.tagName;
      this.h = new hj(this);
      jj(this.h, this.g, a ? ["keydown", "paste", "cut", "drop", "input"] : "input", this);
    }

    w(lj, E);

    lj.prototype.handleEvent = function (a) {
      if ("input" == a.type) z && nc(10) && 0 == a.keyCode && 0 == a.j || (mj(this), ye(this, nj(a)));else if ("keydown" != a.type || Vi(a)) {
        var b = "keydown" == a.type ? this.g.value : null;
        z && 229 == a.keyCode && (b = null);
        var c = nj(a);
        mj(this);
        this.a = gj(function () {
          this.a = null;
          this.g.value != b && ye(this, c);
        }, this);
      }
    };

    function mj(a) {
      null != a.a && (n.clearTimeout(a.a), a.a = null);
    }

    function nj(a) {
      a = new $d(a.a);
      a.type = "input";
      return a;
    }

    lj.prototype.m = function () {
      lj.K.m.call(this);
      this.h.o();
      mj(this);
      delete this.g;
    };

    function oj(a, b) {
      E.call(this);
      a && (this.Oa && pj(this), this.qa = a, this.Na = le(this.qa, "keypress", this, b), this.Ya = le(this.qa, "keydown", this.Hb, b, this), this.Oa = le(this.qa, "keyup", this.Ib, b, this));
    }

    w(oj, E);
    l = oj.prototype;
    l.qa = null;
    l.Na = null;
    l.Ya = null;
    l.Oa = null;
    l.R = -1;
    l.X = -1;
    l.Ua = !1;
    var qj = {
      3: 13,
      12: 144,
      63232: 38,
      63233: 40,
      63234: 37,
      63235: 39,
      63236: 112,
      63237: 113,
      63238: 114,
      63239: 115,
      63240: 116,
      63241: 117,
      63242: 118,
      63243: 119,
      63244: 120,
      63245: 121,
      63246: 122,
      63247: 123,
      63248: 44,
      63272: 46,
      63273: 36,
      63275: 35,
      63276: 33,
      63277: 34,
      63289: 144,
      63302: 45
    },
        rj = {
      Up: 38,
      Down: 40,
      Left: 37,
      Right: 39,
      Enter: 13,
      F1: 112,
      F2: 113,
      F3: 114,
      F4: 115,
      F5: 116,
      F6: 117,
      F7: 118,
      F8: 119,
      F9: 120,
      F10: 121,
      F11: 122,
      F12: 123,
      "U+007F": 46,
      Home: 36,
      End: 35,
      PageUp: 33,
      PageDown: 34,
      Insert: 45
    },
        sj = !fc || nc("525"),
        tj = hc && ec;
    l = oj.prototype;

    l.Hb = function (a) {
      if (fc || cc) if (17 == this.R && !a.ctrlKey || 18 == this.R && !a.altKey || hc && 91 == this.R && !a.metaKey) this.X = this.R = -1;
      -1 == this.R && (a.ctrlKey && 17 != a.keyCode ? this.R = 17 : a.altKey && 18 != a.keyCode ? this.R = 18 : a.metaKey && 91 != a.keyCode && (this.R = 91));
      sj && !Xi(a.keyCode, this.R, a.shiftKey, a.ctrlKey, a.altKey, a.metaKey) ? this.handleEvent(a) : (this.X = Yi(a.keyCode), tj && (this.Ua = a.altKey));
    };

    l.Ib = function (a) {
      this.X = this.R = -1;
      this.Ua = a.altKey;
    };

    l.handleEvent = function (a) {
      var b = a.a,
          c = b.altKey;

      if (z && "keypress" == a.type) {
        var d = this.X;
        var e = 13 != d && 27 != d ? b.keyCode : 0;
      } else (fc || cc) && "keypress" == a.type ? (d = this.X, e = 0 <= b.charCode && 63232 > b.charCode && Wi(d) ? b.charCode : 0) : bc && !fc ? (d = this.X, e = Wi(d) ? b.keyCode : 0) : ("keypress" == a.type ? (tj && (c = this.Ua), b.keyCode == b.charCode ? 32 > b.keyCode ? (d = b.keyCode, e = 0) : (d = this.X, e = b.charCode) : (d = b.keyCode || this.X, e = b.charCode || 0)) : (d = b.keyCode || this.X, e = b.charCode || 0), hc && 63 == e && 224 == d && (d = 191));

      var f = d = Yi(d);
      d ? 63232 <= d && d in qj ? f = qj[d] : 25 == d && a.shiftKey && (f = 9) : b.keyIdentifier && b.keyIdentifier in rj && (f = rj[b.keyIdentifier]);
      ec && sj && "keypress" == a.type && !Xi(f, this.R, a.shiftKey, a.ctrlKey, c, a.metaKey) || (a = f == this.R, this.R = f, b = new uj(f, e, a, b), b.altKey = c, ye(this, b));
    };

    l.N = function () {
      return this.qa;
    };

    function pj(a) {
      a.Na && (ue(a.Na), ue(a.Ya), ue(a.Oa), a.Na = null, a.Ya = null, a.Oa = null);
      a.qa = null;
      a.R = -1;
      a.X = -1;
    }

    l.m = function () {
      oj.K.m.call(this);
      pj(this);
    };

    function uj(a, b, c, d) {
      $d.call(this, d);
      this.type = "key";
      this.keyCode = a;
      this.j = b;
      this.repeat = c;
    }

    w(uj, $d);

    function vj(a, b, c, d) {
      this.top = a;
      this.right = b;
      this.bottom = c;
      this.left = d;
    }

    vj.prototype.toString = function () {
      return "(" + this.top + "t, " + this.right + "r, " + this.bottom + "b, " + this.left + "l)";
    };

    vj.prototype.ceil = function () {
      this.top = Math.ceil(this.top);
      this.right = Math.ceil(this.right);
      this.bottom = Math.ceil(this.bottom);
      this.left = Math.ceil(this.left);
      return this;
    };

    vj.prototype.floor = function () {
      this.top = Math.floor(this.top);
      this.right = Math.floor(this.right);
      this.bottom = Math.floor(this.bottom);
      this.left = Math.floor(this.left);
      return this;
    };

    vj.prototype.round = function () {
      this.top = Math.round(this.top);
      this.right = Math.round(this.right);
      this.bottom = Math.round(this.bottom);
      this.left = Math.round(this.left);
      return this;
    };

    function wj(a, b) {
      var c = Tc(a);
      return c.defaultView && c.defaultView.getComputedStyle && (a = c.defaultView.getComputedStyle(a, null)) ? a[b] || a.getPropertyValue(b) || "" : "";
    }

    function xj(a) {
      try {
        var b = a.getBoundingClientRect();
      } catch (c) {
        return {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
      }

      z && a.ownerDocument.body && (a = a.ownerDocument, b.left -= a.documentElement.clientLeft + a.body.clientLeft, b.top -= a.documentElement.clientTop + a.body.clientTop);
      return b;
    }

    function yj(a, b) {
      b = b || Zc(document);
      var c = b || Zc(document);
      var d = zj(a),
          e = zj(c);

      if (!z || 9 <= Number(oc)) {
        g = wj(c, "borderLeftWidth");
        var f = wj(c, "borderRightWidth");
        h = wj(c, "borderTopWidth");
        k = wj(c, "borderBottomWidth");
        f = new vj(parseFloat(h), parseFloat(f), parseFloat(k), parseFloat(g));
      } else {
        var g = Aj(c, "borderLeft");
        f = Aj(c, "borderRight");
        var h = Aj(c, "borderTop"),
            k = Aj(c, "borderBottom");
        f = new vj(h, f, k, g);
      }

      c == Zc(document) ? (g = d.a - c.scrollLeft, d = d.g - c.scrollTop, !z || 10 <= Number(oc) || (g += f.left, d += f.top)) : (g = d.a - e.a - f.left, d = d.g - e.g - f.top);
      e = a.offsetWidth;
      f = a.offsetHeight;
      h = fc && !e && !f;
      ka(e) && !h || !a.getBoundingClientRect ? a = new Qc(e, f) : (a = xj(a), a = new Qc(a.right - a.left, a.bottom - a.top));
      e = c.clientHeight - a.height;
      f = c.scrollLeft;
      h = c.scrollTop;
      f += Math.min(g, Math.max(g - (c.clientWidth - a.width), 0));
      h += Math.min(d, Math.max(d - e, 0));
      c = new Pc(f, h);
      b.scrollLeft = c.a;
      b.scrollTop = c.g;
    }

    function zj(a) {
      var b = Tc(a),
          c = new Pc(0, 0);
      var d = b ? Tc(b) : document;
      d = !z || 9 <= Number(oc) || "CSS1Compat" == Rc(d).a.compatMode ? d.documentElement : d.body;
      if (a == d) return c;
      a = xj(a);
      d = Rc(b).a;
      b = Zc(d);
      d = d.parentWindow || d.defaultView;
      b = z && nc("10") && d.pageYOffset != b.scrollTop ? new Pc(b.scrollLeft, b.scrollTop) : new Pc(d.pageXOffset || b.scrollLeft, d.pageYOffset || b.scrollTop);
      c.a = a.left + b.a;
      c.g = a.top + b.g;
      return c;
    }

    var Bj = {
      thin: 2,
      medium: 4,
      thick: 6
    };

    function Aj(a, b) {
      if ("none" == (a.currentStyle ? a.currentStyle[b + "Style"] : null)) return 0;
      var c = a.currentStyle ? a.currentStyle[b + "Width"] : null;
      if (c in Bj) a = Bj[c];else if (/^\d+px?$/.test(c)) a = parseInt(c, 10);else {
        b = a.style.left;
        var d = a.runtimeStyle.left;
        a.runtimeStyle.left = a.currentStyle.left;
        a.style.left = c;
        c = a.style.pixelLeft;
        a.style.left = b;
        a.runtimeStyle.left = d;
        a = +c;
      }
      return a;
    }

    function Cj() {}

    oa(Cj);
    Cj.prototype.a = 0;

    function Dj(a) {
      E.call(this);
      this.s = a || Rc();
      this.cb = null;
      this.na = !1;
      this.g = null;
      this.L = void 0;
      this.oa = this.Ea = this.Y = null;
    }

    w(Dj, E);
    l = Dj.prototype;
    l.Jb = Cj.Xa();

    l.N = function () {
      return this.g;
    };

    function M(a, b) {
      return a.g ? Wc(b, a.g || a.s.a) : null;
    }

    function Ej(a) {
      a.L || (a.L = new hj(a));
      return a.L;
    }

    l.Za = function (a) {
      if (this.Y && this.Y != a) throw Error("Method not supported");
      Dj.K.Za.call(this, a);
    };

    l.kb = function () {
      this.g = this.s.a.createElement("DIV");
    };

    l.render = function (a) {
      if (this.na) throw Error("Component already rendered");
      this.g || this.kb();
      a ? a.insertBefore(this.g, null) : this.s.a.body.appendChild(this.g);
      this.Y && !this.Y.na || this.v();
    };

    l.v = function () {
      this.na = !0;
      Fj(this, function (a) {
        !a.na && a.N() && a.v();
      });
    };

    l.ya = function () {
      Fj(this, function (a) {
        a.na && a.ya();
      });
      this.L && kj(this.L);
      this.na = !1;
    };

    l.m = function () {
      this.na && this.ya();
      this.L && (this.L.o(), delete this.L);
      Fj(this, function (a) {
        a.o();
      });
      this.g && $c(this.g);
      this.Y = this.g = this.oa = this.Ea = null;
      Dj.K.m.call(this);
    };

    function Fj(a, b) {
      a.Ea && Ha(a.Ea, b, void 0);
    }

    l.removeChild = function (a, b) {
      if (a) {
        var c = q(a) ? a : a.cb || (a.cb = ":" + (a.Jb.a++).toString(36));
        this.oa && c ? (a = this.oa, a = (null !== a && c in a ? a[c] : void 0) || null) : a = null;

        if (c && a) {
          var d = this.oa;
          c in d && delete d[c];
          Na(this.Ea, a);
          b && (a.ya(), a.g && $c(a.g));
          b = a;
          if (null == b) throw Error("Unable to set parent component");
          b.Y = null;
          Dj.K.Za.call(b, null);
        }
      }

      if (!a) throw Error("Child is not in parent component");
      return a;
    };

    function N(a, b) {
      var c = bd(a, "firebaseui-textfield");
      b ? (Si(a, "firebaseui-input-invalid"), Ri(a, "firebaseui-input"), c && Si(c, "firebaseui-textfield-invalid")) : (Si(a, "firebaseui-input"), Ri(a, "firebaseui-input-invalid"), c && Ri(c, "firebaseui-textfield-invalid"));
    }

    function Gj(a, b, c) {
      b = new lj(b);
      Td(a, za(Ud, b));
      jj(Ej(a), b, "input", c);
    }

    function Hj(a, b, c) {
      b = new oj(b);
      Td(a, za(Ud, b));
      jj(Ej(a), b, "key", function (d) {
        13 == d.keyCode && (d.stopPropagation(), d.preventDefault(), c(d));
      });
    }

    function Ij(a, b, c) {
      b = new dj(b);
      Td(a, za(Ud, b));
      jj(Ej(a), b, "focusin", c);
    }

    function Jj(a, b, c) {
      b = new dj(b);
      Td(a, za(Ud, b));
      jj(Ej(a), b, "focusout", c);
    }

    function O(a, b, c) {
      b = new $i(b);
      Td(a, za(Ud, b));
      jj(Ej(a), b, "action", function (d) {
        d.stopPropagation();
        d.preventDefault();
        c(d);
      });
    }

    function Kj(a) {
      Ri(a, "firebaseui-hidden");
    }

    function Lj(a, b) {
      b && ad(a, b);
      Si(a, "firebaseui-hidden");
    }

    function Mj(a) {
      return !Qi(a, "firebaseui-hidden") && "none" != a.style.display;
    }

    function Nj(a) {
      a = a || {};
      var b = a.email,
          c = a.disabled,
          d = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-email-input">';
      d = a.uc ? d + "Enter new email address" : d + "Email";
      d += '</label><input type="email" name="email" id="ui-sign-in-email-input" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="' + vd(null != b ? b : "") + '"' + (c ? "disabled" : "") + '></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>';
      return B(d);
    }

    function Oj(a) {
      a = a || {};
      a = a.label;
      var b = '<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">';
      b = a ? b + A(a) : b + "Next";
      return B(b + "</button>");
    }

    function Pj() {
      var a = "" + Oj({
        label: D("Sign In")
      });
      return B(a);
    }

    function Qj() {
      var a = "" + Oj({
        label: D("Save")
      });
      return B(a);
    }

    function Rj() {
      var a = "" + Oj({
        label: D("Continue")
      });
      return B(a);
    }

    function Sj(a) {
      a = a || {};
      a = a.label;
      var b = '<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-new-password-input">';
      b = a ? b + A(a) : b + "Choose password";
      return B(b + '</label><input type="password" name="newPassword" id="ui-sign-in-new-password-input" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>');
    }

    function Tj() {
      var a = {};
      var b = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-password-input">';
      b = a.current ? b + "Current password" : b + "Password";
      return B(b + '</label><input type="password" name="password" id="ui-sign-in-password-input" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>');
    }

    function Uj() {
      return B('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>');
    }

    function Vj(a) {
      a = a || {};
      a = a.label;
      var b = '<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">';
      b = a ? b + A(a) : b + "Cancel";
      return B(b + "</button>");
    }

    function Wj(a) {
      var b = "";
      a.F && a.D && (b += '<ul class="firebaseui-tos-list firebaseui-tos"><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a></li><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a></li></ul>');
      return B(b);
    }

    function Xj(a) {
      var b = "";
      a.F && a.D && (b += '<p class="firebaseui-tos firebaseui-tospp-full-message">By continuing, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>.</p>');
      return B(b);
    }

    function Yj(a) {
      a = '<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">' + A(a.message) + '&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>';
      return B(a);
    }

    Yj.a = "firebaseui.auth.soy2.element.infoBar";

    function Zj(a) {
      var b = a.content;
      a = a.zb;
      return B('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog' + (a ? " " + vd(a) : "") + '">' + A(b) + "</dialog>");
    }

    function ak(a) {
      var b = a.message;
      return B(Zj({
        content: ud('<div class="firebaseui-dialog-icon-wrapper"><div class="' + vd(a.Ma) + ' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">' + A(b) + "</div>")
      }));
    }

    ak.a = "firebaseui.auth.soy2.element.progressDialog";

    function bk(a) {
      var b = '<div class="firebaseui-list-box-actions">';
      a = a.items;

      for (var c = a.length, d = 0; d < c; d++) {
        var e = a[d];
        b += '<button type="button" data-listboxid="' + vd(e.id) + '" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">' + (e.Ma ? '<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon ' + vd(e.Ma) + '"></div></div>' : "") + '<div class="firebaseui-list-box-label-wrapper">' + A(e.label) + "</div></button>";
      }

      b = "" + Zj({
        zb: D("firebaseui-list-box-dialog"),
        content: ud(b + "</div>")
      });
      return B(b);
    }

    bk.a = "firebaseui.auth.soy2.element.listBoxDialog";

    function ck(a) {
      a = a || {};
      return B(a.tb ? '<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>' : '<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>');
    }

    ck.a = "firebaseui.auth.soy2.element.busyIndicator";

    function dk(a, b) {
      a = a || {};
      a = a.ga;
      return C(a.S ? a.S : b.hb[a.providerId] ? "" + b.hb[a.providerId] : a.providerId && 0 == a.providerId.indexOf("saml.") ? a.providerId.substring(5) : a.providerId && 0 == a.providerId.indexOf("oidc.") ? a.providerId.substring(5) : "" + a.providerId);
    }

    function ek(a) {
      fk(a, "upgradeElement");
    }

    function gk(a) {
      fk(a, "downgradeElements");
    }

    var hk = ["mdl-js-textfield", "mdl-js-progress", "mdl-js-spinner", "mdl-js-button"];

    function fk(a, b) {
      a && window.componentHandler && window.componentHandler[b] && Ha(hk, function (c) {
        if (Qi(a, c)) window.componentHandler[b](a);
        Ha(Uc(c, a), function (d) {
          window.componentHandler[b](d);
        });
      });
    }

    function ik(a, b, c) {
      jk.call(this);
      document.body.appendChild(a);
      a.showModal || window.dialogPolyfill.registerDialog(a);
      a.showModal();
      ek(a);
      b && O(this, a, function (f) {
        var g = a.getBoundingClientRect();
        (f.clientX < g.left || g.left + g.width < f.clientX || f.clientY < g.top || g.top + g.height < f.clientY) && jk.call(this);
      });

      if (!c) {
        var d = this.N().parentElement || this.N().parentNode;

        if (d) {
          var e = this;

          this.da = function () {
            if (a.open) {
              var f = a.getBoundingClientRect().height,
                  g = d.getBoundingClientRect().height,
                  h = d.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
                  k = d.getBoundingClientRect().left - document.body.getBoundingClientRect().left,
                  p = a.getBoundingClientRect().width,
                  r = d.getBoundingClientRect().width;
              a.style.top = (h + (g - f) / 2).toString() + "px";
              f = k + (r - p) / 2;
              a.style.left = f.toString() + "px";
              a.style.right = (document.body.getBoundingClientRect().width - f - p).toString() + "px";
            } else window.removeEventListener("resize", e.da);
          };

          this.da();
          window.addEventListener("resize", this.da, !1);
        }
      }
    }

    function jk() {
      var a = kk.call(this);
      a && (gk(a), a.open && a.close(), $c(a), this.da && window.removeEventListener("resize", this.da));
    }

    function kk() {
      return Wc("firebaseui-id-dialog");
    }

    function lk() {
      $c(mk.call(this));
    }

    function mk() {
      return M(this, "firebaseui-id-info-bar");
    }

    function nk() {
      return M(this, "firebaseui-id-dismiss-info-bar");
    }

    var ok = {
      xa: {
        "google.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
        "github.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",
        "facebook.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg",
        "twitter.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg",
        password: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",
        phone: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg",
        anonymous: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/anonymous.png",
        "microsoft.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg",
        "yahoo.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/yahoo.svg",
        "apple.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/apple.png",
        saml: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/saml.svg",
        oidc: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/oidc.svg"
      },
      wa: {
        "google.com": "#ffffff",
        "github.com": "#333333",
        "facebook.com": "#3b5998",
        "twitter.com": "#55acee",
        password: "#db4437",
        phone: "#02bd7e",
        anonymous: "#f4b400",
        "microsoft.com": "#2F2F2F",
        "yahoo.com": "#720E9E",
        "apple.com": "#000000",
        saml: "#007bff",
        oidc: "#007bff"
      },
      hb: {
        "google.com": "Google",
        "github.com": "GitHub",
        "facebook.com": "Facebook",
        "twitter.com": "Twitter",
        password: "Password",
        phone: "Phone",
        anonymous: "Guest",
        "microsoft.com": "Microsoft",
        "yahoo.com": "Yahoo",
        "apple.com": "Apple"
      }
    };

    function pk(a, b, c) {
      Zd.call(this, a, b);

      for (var d in c) {
        this[d] = c[d];
      }
    }

    w(pk, Zd);

    function P(a, b, c, d, e) {
      Dj.call(this, c);
      this.fb = a;
      this.eb = b;
      this.Fa = !1;
      this.Ga = d || null;
      this.A = this.ca = null;
      this.Z = fb(ok);
      hb(this.Z, e || {});
    }

    w(P, Dj);
    l = P.prototype;

    l.kb = function () {
      var a = id(this.fb, this.eb, this.Z, this.s);
      ek(a);
      this.g = a;
    };

    l.v = function () {
      P.K.v.call(this);
      Ce(Q(this), new pk("pageEnter", Q(this), {
        pageId: this.Ga
      }));

      if (this.bb() && this.Z.F) {
        var a = this.Z.F;
        O(this, this.bb(), function () {
          a();
        });
      }

      if (this.ab() && this.Z.D) {
        var b = this.Z.D;
        O(this, this.ab(), function () {
          b();
        });
      }
    };

    l.ya = function () {
      Ce(Q(this), new pk("pageExit", Q(this), {
        pageId: this.Ga
      }));
      P.K.ya.call(this);
    };

    l.m = function () {
      window.clearTimeout(this.ca);
      this.eb = this.fb = this.ca = null;
      this.Fa = !1;
      this.A = null;
      gk(this.N());
      P.K.m.call(this);
    };

    function qk(a) {
      a.Fa = !0;
      var b = Qi(a.N(), "firebaseui-use-spinner");
      a.ca = window.setTimeout(function () {
        a.N() && null === a.A && (a.A = id(ck, {
          tb: b
        }, null, a.s), a.N().appendChild(a.A), ek(a.A));
      }, 500);
    }

    l.I = function (a, b, c, d) {
      function e() {
        if (f.T) return null;
        f.Fa = !1;
        window.clearTimeout(f.ca);
        f.ca = null;
        f.A && (gk(f.A), $c(f.A), f.A = null);
      }

      var f = this;
      if (f.Fa) return null;
      qk(f);
      return a.apply(null, b).then(c, d).then(e, e);
    };

    function Q(a) {
      return a.N().parentElement || a.N().parentNode;
    }

    function rk(a, b, c) {
      Hj(a, b, function () {
        c.focus();
      });
    }

    function sk(a, b, c) {
      Hj(a, b, function () {
        c();
      });
    }

    u(P.prototype, {
      a: function a(_a) {
        lk.call(this);
        var b = id(Yj, {
          message: _a
        }, null, this.s);
        this.N().appendChild(b);
        O(this, nk.call(this), function () {
          $c(b);
        });
      },
      wc: lk,
      yc: mk,
      xc: nk,
      $: function $(a, b) {
        a = id(ak, {
          Ma: a,
          message: b
        }, null, this.s);
        ik.call(this, a);
      },
      h: jk,
      Bb: kk,
      Ac: function Ac() {
        return M(this, "firebaseui-tos");
      },
      bb: function bb() {
        return M(this, "firebaseui-tos-link");
      },
      ab: function ab() {
        return M(this, "firebaseui-pp-link");
      },
      Bc: function Bc() {
        return M(this, "firebaseui-tos-list");
      }
    });

    function tk(a, b, c) {
      a = a || {};
      b = a.Va;
      var d = a.ia;
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + Nj(a) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? Vj(null) : "") + Oj(null) + '</div></div><div class="firebaseui-card-footer">' + (d ? Xj(c) : Wj(c)) + "</div></form></div>";
      return B(a);
    }

    tk.a = "firebaseui.auth.soy2.page.signIn";

    function uk(a, b, c) {
      a = a || {};
      b = a.ia;
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">' + Nj(a) + Tj() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + Uj() + '</div><div class="firebaseui-form-actions">' + Pj() + '</div></div><div class="firebaseui-card-footer">' + (b ? Xj(c) : Wj(c)) + "</div></form></div>";
      return B(a);
    }

    uk.a = "firebaseui.auth.soy2.page.passwordSignIn";

    function vk(a, b, c) {
      a = a || {};
      var d = a.Rb;
      b = a.Ta;
      var e = a.ia,
          f = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">' + Nj(a);
      d ? (a = a || {}, a = a.name, a = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-name-input">First &amp; last name</label><input type="text" name="name" id="ui-sign-in-name-input" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="' + vd(null != a ? a : "") + '"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>', a = B(a)) : a = "";
      c = f + a + Sj(null) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? Vj(null) : "") + Qj() + '</div></div><div class="firebaseui-card-footer">' + (e ? Xj(c) : Wj(c)) + "</div></form></div>";
      return B(c);
    }

    vk.a = "firebaseui.auth.soy2.page.passwordSignUp";

    function wk(a, b, c) {
      a = a || {};
      b = a.Ta;
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>' + Nj(a) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? Vj(null) : "") + Oj({
        label: D("Send")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(a);
    }

    wk.a = "firebaseui.auth.soy2.page.passwordRecovery";

    function xk(a, b, c) {
      b = a.G;
      var d = "";
      a = "Follow the instructions sent to <strong>" + (A(a.email) + "</strong> to recover your password");
      d += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions">';
      b && (d += '<div class="firebaseui-form-actions">' + Oj({
        label: D("Done")
      }) + "</div>");
      d += '</div><div class="firebaseui-card-footer">' + Wj(c) + "</div></div>";
      return B(d);
    }

    xk.a = "firebaseui.auth.soy2.page.passwordRecoveryEmailSent";

    function yk(a, b, c) {
      return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">' + ck(null, null, c) + "</div></div>");
    }

    yk.a = "firebaseui.auth.soy2.page.callback";

    function zk(a, b, c) {
      return B('<div class="firebaseui-container firebaseui-id-page-spinner">' + ck({
        tb: !0
      }, null, c) + "</div>");
    }

    zk.a = "firebaseui.auth.soy2.page.spinner";

    function Ak() {
      return B('<div class="firebaseui-container firebaseui-id-page-blank firebaseui-use-spinner"></div>');
    }

    Ak.a = "firebaseui.auth.soy2.page.blank";

    function Bk(a, b, c) {
      b = "";
      a = "A sign-in email with additional instructions was sent to <strong>" + (A(a.email) + "</strong>. Check your email to complete sign-in.");
      var d = B('<a class="firebaseui-link firebaseui-id-trouble-getting-email-link" href="javascript:void(0)">Trouble getting email?</a>');
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-sent"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign-in email sent</h1></div><div class="firebaseui-card-content"><div class="firebaseui-email-sent"></div><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + d + '</div><div class="firebaseui-form-actions">' + Vj({
        label: D("Back")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Bk.a = "firebaseui.auth.soy2.page.emailLinkSignInSent";

    function Ck(a, b, c) {
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-not-received"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Trouble getting email?</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try these common fixes:<ul><li>Check if the email was marked as spam or filtered.</li><li>Check your internet connection.</li><li>Check that you did not misspell your email.</li><li>Check that your inbox space is not running out or other inbox settings related issues.</li></ul></p><p class="firebaseui-text">If the steps above didn\'t work, you can resend the email. Note that this will deactivate the link in the older email.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + B('<a class="firebaseui-link firebaseui-id-resend-email-link" href="javascript:void(0)">Resend</a>') + '</div><div class="firebaseui-form-actions">' + Vj({
        label: D("Back")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(a);
    }

    Ck.a = "firebaseui.auth.soy2.page.emailNotReceived";

    function Dk(a, b, c) {
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-confirmation"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Confirm email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Confirm your email to complete sign in</p><div class="firebaseui-relative-wrapper">' + Nj(a) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj(null) + Oj(null) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(a);
    }

    Dk.a = "firebaseui.auth.soy2.page.emailLinkSignInConfirmation";

    function Ek() {
      var a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-different-device-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">New device or browser detected</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try opening the link using the same device or browser where you started the sign-in process.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj({
        label: D("Dismiss")
      }) + "</div></div></div>";
      return B(a);
    }

    Ek.a = "firebaseui.auth.soy2.page.differentDeviceError";

    function Fk() {
      var a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-anonymous-user-mismatch"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Session ended</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">The session associated with this sign-in request has either expired or was cleared.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj({
        label: D("Dismiss")
      }) + "</div></div></div>";
      return B(a);
    }

    Fk.a = "firebaseui.auth.soy2.page.anonymousUserMismatch";

    function Gk(a, b, c) {
      b = "";
      a = "You\u2019ve already used <strong>" + (A(a.email) + "</strong> to sign in. Enter your password for that account.");
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + a + "</p>" + Tj() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + Uj() + '</div><div class="firebaseui-form-actions">' + Pj() + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Gk.a = "firebaseui.auth.soy2.page.passwordLinking";

    function Hk(a, b, c) {
      var d = a.email;
      b = "";
      a = "" + dk(a, c);
      a = D(a);
      d = "You\u2019ve already used <strong>" + (A(d) + ("</strong>. You can connect your <strong>" + (A(a) + ("</strong> account with <strong>" + (A(d) + "</strong> by signing in with email link below.")))));
      a = "For this flow to successfully connect your " + (A(a) + " account with this email, you have to open the link on the same device or browser.");
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text firebaseui-text-justify">' + d + '<p class="firebaseui-text firebaseui-text-justify">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Pj() + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Hk.a = "firebaseui.auth.soy2.page.emailLinkSignInLinking";

    function Ik(a, b, c) {
      b = "";
      var d = "" + dk(a, c);
      d = D(d);
      a = "You originally intended to connect <strong>" + (A(d) + "</strong> to your email account but have opened the link on a different device where you are not signed in.");
      d = "If you still want to connect your <strong>" + (A(d) + "</strong> account, open the link on the same device where you started sign-in. Otherwise, tap Continue to sign-in on this device.");
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking-different-device"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text firebaseui-text-justify">' + a + '</p><p class="firebaseui-text firebaseui-text-justify">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Rj() + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Ik.a = "firebaseui.auth.soy2.page.emailLinkSignInLinkingDifferentDevice";

    function Jk(a, b, c) {
      var d = a.email;
      b = "";
      a = "" + dk(a, c);
      a = D(a);
      d = "You\u2019ve already used <strong>" + (A(d) + ("</strong>. Sign in with " + (A(a) + " to continue.")));
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Oj({
        label: D("Sign in with " + a)
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Jk.a = "firebaseui.auth.soy2.page.federatedLinking";

    function Kk(a, b, c) {
      b = "";
      a = "To continue sign in with <strong>" + (A(a.email) + "</strong> on this device, you have to recover the password.");
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unsupported-provider"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj(null) + Oj({
        label: D("Recover password")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Kk.a = "firebaseui.auth.soy2.page.unsupportedProvider";

    function Lk(a) {
      var b = "",
          c = '<p class="firebaseui-text">for <strong>' + (A(a.email) + "</strong></p>");
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">' + c + Sj(td(a)) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Qj() + "</div></div></form></div>";
      return B(b);
    }

    Lk.a = "firebaseui.auth.soy2.page.passwordReset";

    function Mk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Mk.a = "firebaseui.auth.soy2.page.passwordResetSuccess";

    function Nk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Nk.a = "firebaseui.auth.soy2.page.passwordResetFailure";

    function Ok(a) {
      var b = a.G,
          c = "";
      a = "Your sign-in email address has been changed back to <strong>" + (A(a.email) + "</strong>.");
      c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + "</p><p class=\"firebaseui-text\">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class=\"firebaseui-link firebaseui-id-reset-password-link\" href=\"javascript:void(0)\">change your password right away</a>.</p></div><div class=\"firebaseui-card-actions\">" + (b ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></form></div>";
      return B(c);
    }

    Ok.a = "firebaseui.auth.soy2.page.emailChangeRevokeSuccess";

    function Pk(a) {
      a = a || {};
      a = "<div class=\"mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure\"><div class=\"firebaseui-card-header\"><h1 class=\"firebaseui-title\">Unable to update your email address</h1></div><div class=\"firebaseui-card-content\"><p class=\"firebaseui-text\">There was a problem changing your sign-in email back.</p><p class=\"firebaseui-text\">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class=\"firebaseui-card-actions\">" + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Pk.a = "firebaseui.auth.soy2.page.emailChangeRevokeFailure";

    function Qk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Qk.a = "firebaseui.auth.soy2.page.emailVerificationSuccess";

    function Rk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Rk.a = "firebaseui.auth.soy2.page.emailVerificationFailure";

    function Sk(a) {
      var b = a.G,
          c = "";
      a = "You can now sign in with your new email <strong>" + (A(a.email) + "</strong>.");
      c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified and changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions">' + (b ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(c);
    }

    Sk.a = "firebaseui.auth.soy2.page.verifyAndChangeEmailSuccess";

    function Tk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try updating your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify and update your email has expired or the link has already been used.</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Tk.a = "firebaseui.auth.soy2.page.verifyAndChangeEmailFailure";

    function Uk(a) {
      var b = a.factorId,
          c = a.phoneNumber;
      a = a.G;
      var d = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Removed second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">';

      switch (b) {
        case "phone":
          b = "The <strong>" + (A(b) + (" " + (A(c) + "</strong> was removed as a second authentication step.")));
          d += b;
          break;

        default:
          d += "The device or app was removed as a second authentication step.";
      }

      d += '</p><p class="firebaseui-text">If you don\'t recognize this device, someone might be trying to access your account. Consider <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">changing your password right away</a>.</p></div><div class="firebaseui-card-actions">' + (a ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></form></div>";
      return B(d);
    }

    Uk.a = "firebaseui.auth.soy2.page.revertSecondFactorAdditionSuccess";

    function Wk(a) {
      a = a || {};
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Couldn\'t remove your second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Something went wrong removing your second factor.</p><p class="firebaseui-text">Try removing it again. If that doesn\'t work, contact support for assistance.</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Rj() + "</div>" : "") + "</div></div>";
      return B(a);
    }

    Wk.a = "firebaseui.auth.soy2.page.revertSecondFactorAdditionFailure";

    function Xk(a) {
      var b = a.yb;
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-recoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + A(a.errorMessage) + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">';
      b && (a += Oj({
        label: D("Retry")
      }));
      return B(a + "</div></div></div>");
    }

    Xk.a = "firebaseui.auth.soy2.page.recoverableError";

    function Yk(a) {
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + A(a.errorMessage) + "</p></div></div>";
      return B(a);
    }

    Yk.a = "firebaseui.auth.soy2.page.unrecoverableError";

    function Zk(a, b, c) {
      var d = a.Ob;
      b = "";
      a = "Continue with " + (A(a.hc) + "?");
      d = "You originally wanted to sign in with " + A(d);
      b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">' + a + '</h2><p class="firebaseui-text">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj(null) + Oj({
        label: D("Continue")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form></div>";
      return B(b);
    }

    Zk.a = "firebaseui.auth.soy2.page.emailMismatch";

    function $k(a, b, c) {
      var d = '<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';
      a = a.Qb;
      b = a.length;

      for (var e = 0; e < b; e++) {
        var f = {
          ga: a[e]
        },
            g = c;
        f = f || {};
        var h = f.ga;
        var k = f;
        k = k || {};
        var p = "";

        switch (k.ga.providerId) {
          case "google.com":
            p += "firebaseui-idp-google";
            break;

          case "github.com":
            p += "firebaseui-idp-github";
            break;

          case "facebook.com":
            p += "firebaseui-idp-facebook";
            break;

          case "twitter.com":
            p += "firebaseui-idp-twitter";
            break;

          case "phone":
            p += "firebaseui-idp-phone";
            break;

          case "anonymous":
            p += "firebaseui-idp-anonymous";
            break;

          case "password":
            p += "firebaseui-idp-password";
            break;

          default:
            p += "firebaseui-idp-generic";
        }

        k = '<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised ' + vd(C(p)) + ' firebaseui-id-idp-button" data-provider-id="' + vd(h.providerId) + '" style="background-color:';
        p = (p = f) || {};
        p = p.ga;
        k = k + vd(Ed(C(p.ta ? p.ta : g.wa[p.providerId] ? "" + g.wa[p.providerId] : 0 == p.providerId.indexOf("saml.") ? "" + g.wa.saml : 0 == p.providerId.indexOf("oidc.") ? "" + g.wa.oidc : "" + g.wa.password))) + '"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="';
        var r = f;
        p = g;
        r = r || {};
        r = r.ga;
        p = sd(r.za ? Ad(r.za) : p.xa[r.providerId] ? Ad(p.xa[r.providerId]) : 0 == r.providerId.indexOf("saml.") ? Ad(p.xa.saml) : 0 == r.providerId.indexOf("oidc.") ? Ad(p.xa.oidc) : Ad(p.xa.password));
        k = k + vd(Ad(p)) + '"></span>';
        "password" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(dk(f, g)), k += f) : k += "Sign in with email", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Email", k += "</span>") : "phone" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(dk(f, g)), k += f) : k += "Sign in with phone", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Phone", k += "</span>") : "anonymous" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(dk(f, g)), k += f) : k += "Continue as guest", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Guest", k += "</span>") : (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : (p = "Sign in with " + A(dk(f, g)), k += p), k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">' + (h.S ? A(h.S) : A(dk(f, g))) + "</span>");
        h = B(k + "</button>");
        d += '<li class="firebaseui-list-item">' + h + "</li>";
      }

      d += '</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">' + Xj(c) + "</div></div>";
      return B(d);
    }

    $k.a = "firebaseui.auth.soy2.page.providerSignIn";

    function al(a, b, c) {
      a = a || {};
      var d = a.Eb,
          e = a.Va;
      b = a.ia;
      a = a || {};
      a = a.Aa;
      a = '<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-number-input">Phone number</label><input type="tel" name="phoneNumber" id="ui-sign-in-phone-number-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="' + vd(null != a ? a : "") + '"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>';
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + B(a);
      var f;
      d ? f = B('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>') : f = "";
      f = a + f + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (e ? Vj(null) : "") + Oj({
        label: D("Verify")
      }) + '</div></div><div class="firebaseui-card-footer">';
      b ? (b = '<p class="firebaseui-tos firebaseui-phone-tos">', b = c.F && c.D ? b + 'By tapping Verify, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>. An SMS may be sent. Message &amp; data rates may apply.' : b + "By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.", c = B(b + "</p>")) : c = B('<p class="firebaseui-tos firebaseui-phone-sms-notice">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>') + Wj(c);
      return B(f + c + "</div></form></div>");
    }

    al.a = "firebaseui.auth.soy2.page.phoneSignInStart";

    function bl(a, b, c) {
      a = a || {};
      b = a.phoneNumber;
      var d = "";
      a = 'Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;' + (A(b) + "</a>");
      A(b);
      b = d;
      d = B('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-confirmation-code-input">6-digit code</label><input type="number" name="phoneConfirmationCode" id="ui-sign-in-phone-confirmation-code-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>');
      c = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + "</p>" + d + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj(null) + Oj({
        label: D("Continue")
      }) + '</div></div><div class="firebaseui-card-footer">' + Wj(c) + "</div></form>";
      a = B('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>');
      return B(b + (c + a + "</div>"));
    }

    bl.a = "firebaseui.auth.soy2.page.phoneSignInFinish";

    function cl() {
      return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-out"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign Out</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You are now successfully signed out.</p></div></div>');
    }

    cl.a = "firebaseui.auth.soy2.page.signOut";

    function dl(a, b, c) {
      var d = '<div class="firebaseui-container firebaseui-page-select-tenant firebaseui-id-page-select-tenant"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-tenant-list">';
      a = a.cc;
      b = a.length;

      for (var e = 0; e < b; e++) {
        var f = a[e];
        var g = "";
        var h = A(f.displayName),
            k = f.tenantId ? f.tenantId : "top-level-project";
        k = D(k);
        g += '<button class="firebaseui-tenant-button mdl-button mdl-js-button mdl-button--raised firebaseui-tenant-selection-' + vd(k) + ' firebaseui-id-tenant-selection-button"' + (f.tenantId ? 'data-tenant-id="' + vd(f.tenantId) + '"' : "") + 'style="background-color:' + vd(Ed(f.ta)) + '"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="' + vd(Ad(f.za)) + '"></span><span class="firebaseui-idp-text firebaseui-idp-text-long">';
        f.V ? g += A(f.V) : (f = "Sign in to " + A(f.displayName), g += f);
        g = B(g + ('</span><span class="firebaseui-idp-text firebaseui-idp-text-short">' + h + "</span></button>"));
        d += '<li class="firebaseui-list-item">' + g + "</li>";
      }

      d += '</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">' + Xj(c) + "</div></div>";
      return B(d);
    }

    dl.a = "firebaseui.auth.soy2.page.selectTenant";

    function el(a, b, c) {
      a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-provider-match-by-email"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + Nj(null) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Oj(null) + '</div></div><div class="firebaseui-card-footer">' + Xj(c) + "</div></form></div>";
      return B(a);
    }

    el.a = "firebaseui.auth.soy2.page.providerMatchByEmail";

    function fl() {
      return M(this, "firebaseui-id-submit");
    }

    function gl() {
      return M(this, "firebaseui-id-secondary-link");
    }

    function hl(a, b) {
      O(this, fl.call(this), function (d) {
        a(d);
      });
      var c = gl.call(this);
      c && b && O(this, c, function (d) {
        b(d);
      });
    }

    function il() {
      return M(this, "firebaseui-id-password");
    }

    function jl() {
      return M(this, "firebaseui-id-password-error");
    }

    function kl() {
      var a = il.call(this),
          b = jl.call(this);
      Gj(this, a, function () {
        Mj(b) && (N(a, !0), Kj(b));
      });
    }

    function ll() {
      var a = il.call(this);
      var b = jl.call(this);
      Ti(a) ? (N(a, !0), Kj(b), b = !0) : (N(a, !1), Lj(b, C("Enter your password").toString()), b = !1);
      return b ? Ti(a) : null;
    }

    function ml(a, b, c, d, e, f) {
      P.call(this, Gk, {
        email: a
      }, f, "passwordLinking", {
        F: d,
        D: e
      });
      this.w = b;
      this.H = c;
    }

    m(ml, P);

    ml.prototype.v = function () {
      this.P();
      this.M(this.w, this.H);
      sk(this, this.i(), this.w);
      this.i().focus();
      P.prototype.v.call(this);
    };

    ml.prototype.m = function () {
      this.w = null;
      P.prototype.m.call(this);
    };

    ml.prototype.j = function () {
      return Ti(M(this, "firebaseui-id-email"));
    };

    u(ml.prototype, {
      i: il,
      B: jl,
      P: kl,
      u: ll,
      ea: fl,
      ba: gl,
      M: hl
    });
    var nl = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;

    function ol() {
      return M(this, "firebaseui-id-email");
    }

    function pl() {
      return M(this, "firebaseui-id-email-error");
    }

    function ql(a) {
      var b = ol.call(this),
          c = pl.call(this);
      Gj(this, b, function () {
        Mj(c) && (N(b, !0), Kj(c));
      });
      a && Hj(this, b, function () {
        a();
      });
    }

    function rl() {
      return Va(Ti(ol.call(this)) || "");
    }

    function sl() {
      var a = ol.call(this);
      var b = pl.call(this);
      var c = Ti(a) || "";
      c ? nl.test(c) ? (N(a, !0), Kj(b), b = !0) : (N(a, !1), Lj(b, C("That email address isn't correct").toString()), b = !1) : (N(a, !1), Lj(b, C("Enter your email address to continue").toString()), b = !1);
      return b ? Va(Ti(a)) : null;
    }

    function tl(a, b, c, d, e, f, g) {
      P.call(this, uk, {
        email: c,
        ia: !!f
      }, g, "passwordSignIn", {
        F: d,
        D: e
      });
      this.w = a;
      this.H = b;
    }

    m(tl, P);

    tl.prototype.v = function () {
      this.P();
      this.ea();
      this.ba(this.w, this.H);
      rk(this, this.l(), this.i());
      sk(this, this.i(), this.w);
      Ti(this.l()) ? this.i().focus() : this.l().focus();
      P.prototype.v.call(this);
    };

    tl.prototype.m = function () {
      this.H = this.w = null;
      P.prototype.m.call(this);
    };

    u(tl.prototype, {
      l: ol,
      U: pl,
      P: ql,
      M: rl,
      j: sl,
      i: il,
      B: jl,
      ea: kl,
      u: ll,
      ua: fl,
      pa: gl,
      ba: hl
    });

    function R(a, b, c, d, e, f) {
      P.call(this, a, b, d, e || "notice", f);
      this.i = c || null;
    }

    w(R, P);

    R.prototype.v = function () {
      this.i && (this.u(this.i), this.l().focus());
      R.K.v.call(this);
    };

    R.prototype.m = function () {
      this.i = null;
      R.K.m.call(this);
    };

    u(R.prototype, {
      l: fl,
      w: gl,
      u: hl
    });

    function ul(a, b, c, d, e) {
      R.call(this, xk, {
        email: a,
        G: !!b
      }, b, e, "passwordRecoveryEmailSent", {
        F: c,
        D: d
      });
    }

    w(ul, R);

    function vl(a, b) {
      R.call(this, Qk, {
        G: !!a
      }, a, b, "emailVerificationSuccess");
    }

    w(vl, R);

    function wl(a, b) {
      R.call(this, Rk, {
        G: !!a
      }, a, b, "emailVerificationFailure");
    }

    w(wl, R);

    function xl(a, b, c) {
      R.call(this, Sk, {
        email: a,
        G: !!b
      }, b, c, "verifyAndChangeEmailSuccess");
    }

    w(xl, R);

    function yl(a, b) {
      R.call(this, Tk, {
        G: !!a
      }, a, b, "verifyAndChangeEmailFailure");
    }

    w(yl, R);

    function zl(a, b) {
      R.call(this, Wk, {
        G: !!a
      }, a, b, "revertSecondFactorAdditionFailure");
    }

    w(zl, R);

    function Al(a) {
      R.call(this, cl, void 0, void 0, a, "signOut");
    }

    w(Al, R);

    function Bl(a, b) {
      R.call(this, Mk, {
        G: !!a
      }, a, b, "passwordResetSuccess");
    }

    w(Bl, R);

    function Cl(a, b) {
      R.call(this, Nk, {
        G: !!a
      }, a, b, "passwordResetFailure");
    }

    w(Cl, R);

    function Dl(a, b) {
      R.call(this, Pk, {
        G: !!a
      }, a, b, "emailChangeRevokeFailure");
    }

    w(Dl, R);

    function El(a, b, c) {
      R.call(this, Xk, {
        errorMessage: a,
        yb: !!b
      }, b, c, "recoverableError");
    }

    w(El, R);

    function Fl(a, b) {
      R.call(this, Yk, {
        errorMessage: a
      }, void 0, b, "unrecoverableError");
    }

    w(Fl, R);

    function Gl(a, b, c, d) {
      function e(g) {
        if (!g.name || "cancel" != g.name) {
          a: {
            var h = g.message;

            try {
              var k = ((JSON.parse(h).error || {}).message || "").toLowerCase().match(/invalid.+(access|id)_token/);

              if (k && k.length) {
                var p = !0;
                break a;
              }
            } catch (r) {}

            p = !1;
          }

          if (p) g = Q(b), b.o(), S(a, g, void 0, C("Your sign-in session has expired. Please try again.").toString());else {
            p = g && g.message || "";

            if (g.code) {
              if ("auth/email-already-in-use" == g.code || "auth/credential-already-in-use" == g.code) return;
              p = T(g);
            }

            b.a(p);
          }
        }
      }

      Hl(a);
      if (d) return Il(a, c), G();
      if (!c.credential) throw Error("No credential found!");
      if (!U(a).currentUser && !c.user) throw Error("User not logged in.");

      try {
        var f = Jl(a, c);
      } catch (g) {
        return og(g.code || g.message, g), b.a(g.code || g.message), G();
      }

      c = f.then(function (g) {
        Il(a, g);
      }, e).then(void 0, e);
      V(a, f);
      return G(c);
    }

    function Il(a, b) {
      if (!b.user) throw Error("No user found");
      var c = Hi(W(a));
      Fi(W(a)) && c && tg("Both signInSuccess and signInSuccessWithAuthResult callbacks are provided. Only signInSuccessWithAuthResult callback will be invoked.");

      if (c) {
        c = Hi(W(a));
        var d = yh(X(a)) || void 0;
        wh(sh, X(a));
        var e = !1;

        if (qf()) {
          if (!c || c(b, d)) e = !0, Oc(window.opener.location, Kl(a, d));
          c || window.close();
        } else if (!c || c(b, d)) e = !0, Oc(window.location, Kl(a, d));

        e || a.reset();
      } else {
        c = b.user;
        b = b.credential;
        d = Fi(W(a));
        e = yh(X(a)) || void 0;
        wh(sh, X(a));
        var f = !1;

        if (qf()) {
          if (!d || d(c, b, e)) f = !0, Oc(window.opener.location, Kl(a, e));
          d || window.close();
        } else if (!d || d(c, b, e)) f = !0, Oc(window.location, Kl(a, e));

        f || a.reset();
      }
    }

    function Kl(a, b) {
      a = b || W(a).a.get("signInSuccessUrl");
      if (!a) throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");
      return a;
    }

    function T(a) {
      var b = {
        code: a.code
      };
      b = b || {};
      var c = "";

      switch (b.code) {
        case "auth/email-already-in-use":
          c += "The email address is already used by another account";
          break;

        case "auth/requires-recent-login":
          c += Nd();
          break;

        case "auth/too-many-requests":
          c += "You have entered an incorrect password too many times. Please try again in a few minutes.";
          break;

        case "auth/user-cancelled":
          c += "Please authorize the required permissions to sign in to the application";
          break;

        case "auth/user-not-found":
          c += "That email address doesn't match an existing account";
          break;

        case "auth/user-token-expired":
          c += Nd();
          break;

        case "auth/weak-password":
          c += "Strong passwords have at least 6 characters and a mix of letters and numbers";
          break;

        case "auth/wrong-password":
          c += "The email and password you entered don't match";
          break;

        case "auth/network-request-failed":
          c += "A network error has occurred";
          break;

        case "auth/invalid-phone-number":
          c += Id();
          break;

        case "auth/invalid-verification-code":
          c += C("Wrong code. Try again.");
          break;

        case "auth/code-expired":
          c += "This code is no longer valid";
          break;

        case "auth/expired-action-code":
          c += "This code has expired.";
          break;

        case "auth/invalid-action-code":
          c += "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.";
      }

      if (b = C(c).toString()) return b;

      try {
        return JSON.parse(a.message), og("Internal error: " + a.message, void 0), Kd().toString();
      } catch (d) {
        return a.message;
      }
    }

    function Ll(a, b, c) {
      var d = ai[b] && firebase.auth[ai[b]] ? new firebase.auth[ai[b]]() : 0 == b.indexOf("saml.") ? new firebase.auth.SAMLAuthProvider(b) : new firebase.auth.OAuthProvider(b);
      if (!d) throw Error("Invalid Firebase Auth provider!");
      var e = qi(W(a), b);
      if (d.addScope) for (var f = 0; f < e.length; f++) {
        d.addScope(e[f]);
      }
      e = ri(W(a), b) || {};
      c && (b == firebase.auth.GoogleAuthProvider.PROVIDER_ID ? a = "login_hint" : b == firebase.auth.GithubAuthProvider.PROVIDER_ID ? a = "login" : a = (a = ii(W(a), b)) && a.Mb, a && (e[a] = c));
      d.setCustomParameters && d.setCustomParameters(e);
      return d;
    }

    function Ml(a, b, c, d) {
      function e() {
        Dh(new Dg(a.h.tenantId || null), X(a));
        V(a, b.I(t(a.bc, a), [k], function () {
          if ("file:" === (window.location && window.location.protocol)) return V(a, Nl(a).then(function (p) {
            b.o();
            wh(rh, X(a));
            L("callback", a, h, G(p));
          }, f));
        }, g));
      }

      function f(p) {
        wh(rh, X(a));
        if (!p.name || "cancel" != p.name) switch (p.code) {
          case "auth/popup-blocked":
            e();
            break;

          case "auth/popup-closed-by-user":
          case "auth/cancelled-popup-request":
            break;

          case "auth/credential-already-in-use":
            break;

          case "auth/network-request-failed":
          case "auth/too-many-requests":
          case "auth/user-cancelled":
            b.a(T(p));
            break;

          default:
            b.o(), L("callback", a, h, df(p));
        }
      }

      function g(p) {
        wh(rh, X(a));
        p.name && "cancel" == p.name || (og("signInWithRedirect: " + p.code, void 0), p = T(p), "blank" == b.Ga && Bi(W(a)) ? (b.o(), L("providerSignIn", a, h, p)) : b.a(p));
      }

      var h = Q(b),
          k = Ll(a, c, d);
      Ci(W(a)) == Di ? e() : V(a, Ol(a, k).then(function (p) {
        b.o();
        L("callback", a, h, G(p));
      }, f));
    }

    function Pl(a, b) {
      V(a, b.I(t(a.Yb, a), [], function (c) {
        b.o();
        return Gl(a, b, c, !0);
      }, function (c) {
        c.name && "cancel" == c.name || (og("ContinueAsGuest: " + c.code, void 0), c = T(c), b.a(c));
      }));
    }

    function Ql(a, b, c) {
      function d(f) {
        var g = !1;
        f = b.I(t(a.Zb, a), [f], function (h) {
          var k = Q(b);
          b.o();
          L("callback", a, k, G(h));
          g = !0;
        }, function (h) {
          if (!h.name || "cancel" != h.name) if (!h || "auth/credential-already-in-use" != h.code) if (h && "auth/email-already-in-use" == h.code && h.email && h.credential) {
            var k = Q(b);
            b.o();
            L("callback", a, k, df(h));
          } else h = T(h), b.a(h);
        });
        V(a, f);
        return f.then(function () {
          return g;
        }, function () {
          return !1;
        });
      }

      if (c && c.credential && c.clientId === li(W(a))) {
        if (qi(W(a), firebase.auth.GoogleAuthProvider.PROVIDER_ID).length) {
          try {
            var e = JSON.parse(atob(c.credential.split(".")[1])).email;
          } catch (f) {}

          Ml(a, b, firebase.auth.GoogleAuthProvider.PROVIDER_ID, e);
          return G(!0);
        }

        return d(firebase.auth.GoogleAuthProvider.credential(c.credential));
      }

      c && b.a(C("The selected credential for the authentication provider is not supported!").toString());
      return G(!1);
    }

    function Rl(a, b) {
      var c = b.j(),
          d = b.u();
      if (c) {
        if (d) {
          var e = firebase.auth.EmailAuthProvider.credential(c, d);
          V(a, b.I(t(a.$b, a), [c, d], function (f) {
            return Gl(a, b, {
              user: f.user,
              credential: e,
              operationType: f.operationType,
              additionalUserInfo: f.additionalUserInfo
            });
          }, function (f) {
            if (!f.name || "cancel" != f.name) switch (f.code) {
              case "auth/email-already-in-use":
                break;

              case "auth/email-exists":
                N(b.l(), !1);
                Lj(b.U(), T(f));
                break;

              case "auth/too-many-requests":
              case "auth/wrong-password":
                N(b.i(), !1);
                Lj(b.B(), T(f));
                break;

              default:
                og("verifyPassword: " + f.message, void 0), b.a(T(f));
            }
          }));
        } else b.i().focus();
      } else b.l().focus();
    }

    function Sl(a) {
      a = hi(W(a));
      return 1 == a.length && a[0] == firebase.auth.EmailAuthProvider.PROVIDER_ID;
    }

    function Tl(a) {
      a = hi(W(a));
      return 1 == a.length && a[0] == firebase.auth.PhoneAuthProvider.PROVIDER_ID;
    }

    function S(a, b, c, d) {
      Sl(a) ? d ? L("signIn", a, b, c, d) : Ul(a, b, c) : a && Tl(a) && !d ? L("phoneSignInStart", a, b) : a && Bi(W(a)) && !d ? L("federatedRedirect", a, b, c) : L("providerSignIn", a, b, d, c);
    }

    function Vl(a, b, c, d) {
      var e = Q(b);
      V(a, b.I(t(U(a).fetchSignInMethodsForEmail, U(a)), [c], function (f) {
        b.o();
        Wl(a, e, f, c, d);
      }, function (f) {
        f = T(f);
        b.a(f);
      }));
    }

    function Wl(a, b, c, d, e, f) {
      c.length || yi(W(a)) ? !c.length && yi(W(a)) ? L("sendEmailLinkForSignIn", a, b, d, function () {
        L("signIn", a, b);
      }) : Ma(c, firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) ? L("passwordSignIn", a, b, d, f) : 1 == c.length && c[0] === firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD ? yi(W(a)) ? L("sendEmailLinkForSignIn", a, b, d, function () {
        L("signIn", a, b);
      }) : L("unsupportedProvider", a, b, d) : (c = Zh(c, hi(W(a)))) ? (Bh(new Ag(d), X(a)), L("federatedSignIn", a, b, d, c, e)) : L("unsupportedProvider", a, b, d) : L("passwordSignUp", a, b, d, void 0, void 0, f);
    }

    function Xl(a, b, c, d, e, f) {
      var g = Q(b);
      V(a, b.I(t(a.Gb, a), [c, f], function () {
        b.o();
        L("emailLinkSignInSent", a, g, c, d, f);
      }, e));
    }

    function Ul(a, b, c) {
      c ? L("prefilledEmailSignIn", a, b, c) : L("signIn", a, b);
    }

    function Yl() {
      return ub(tf(), "oobCode");
    }

    function Zl() {
      var a = ub(tf(), "continueUrl");
      return a ? function () {
        Oc(window.location, a);
      } : null;
    }

    function $l(a, b) {
      P.call(this, Fk, void 0, b, "anonymousUserMismatch");
      this.i = a;
    }

    m($l, P);

    $l.prototype.v = function () {
      var a = this;
      O(this, this.l(), function () {
        a.i();
      });
      this.l().focus();
      P.prototype.v.call(this);
    };

    $l.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u($l.prototype, {
      l: gl
    });

    K.anonymousUserMismatch = function (a, b) {
      var c = new $l(function () {
        c.o();
        S(a, b);
      });
      c.render(b);
      Y(a, c);
    };

    function am(a) {
      P.call(this, yk, void 0, a, "callback");
    }

    m(am, P);

    am.prototype.I = function (a, b, c, d) {
      return a.apply(null, b).then(c, d);
    };

    function bm(a, b, c) {
      if (c.user) {
        var d = {
          user: c.user,
          credential: c.credential,
          operationType: c.operationType,
          additionalUserInfo: c.additionalUserInfo
        },
            e = zh(X(a)),
            f = e && e.g;
        if (f && !cm(c.user, f)) dm(a, b, d);else {
          var g = e && e.a;
          g ? V(a, c.user.linkWithCredential(g).then(function (h) {
            d = {
              user: h.user,
              credential: g,
              operationType: h.operationType,
              additionalUserInfo: h.additionalUserInfo
            };
            em(a, b, d);
          }, function (h) {
            fm(a, b, h);
          })) : em(a, b, d);
        }
      } else c = Q(b), b.o(), Ah(X(a)), S(a, c);
    }

    function em(a, b, c) {
      Ah(X(a));
      Gl(a, b, c);
    }

    function fm(a, b, c) {
      var d = Q(b);
      Ah(X(a));
      c = T(c);
      b.o();
      S(a, d, void 0, c);
    }

    function gm(a, b, c, d) {
      var e = Q(b);
      V(a, U(a).fetchSignInMethodsForEmail(c).then(function (f) {
        b.o();
        f.length ? Ma(f, firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) ? L("passwordLinking", a, e, c) : 1 == f.length && f[0] === firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD ? L("emailLinkSignInLinking", a, e, c) : (f = Zh(f, hi(W(a)))) ? L("federatedLinking", a, e, c, f, d) : (Ah(X(a)), L("unsupportedProvider", a, e, c)) : (Ah(X(a)), L("passwordRecovery", a, e, c, !1, Ld().toString()));
      }, function (f) {
        fm(a, b, f);
      }));
    }

    function dm(a, b, c) {
      var d = Q(b);
      V(a, hm(a).then(function () {
        b.o();
        L("emailMismatch", a, d, c);
      }, function (e) {
        e.name && "cancel" == e.name || (e = T(e.code), b.a(e));
      }));
    }

    function cm(a, b) {
      if (b == a.email) return !0;
      if (a.providerData) for (var c = 0; c < a.providerData.length; c++) {
        if (b == a.providerData[c].email) return !0;
      }
      return !1;
    }

    K.callback = function (a, b, c) {
      var d = new am();
      d.render(b);
      Y(a, d);
      b = c || Nl(a);
      V(a, b.then(function (e) {
        bm(a, d, e);
      }, function (e) {
        if (e && ("auth/account-exists-with-different-credential" == e.code || "auth/email-already-in-use" == e.code) && e.email && e.credential) Bh(new Ag(e.email, e.credential), X(a)), gm(a, d, e.email);else if (e && "auth/user-cancelled" == e.code) {
          var f = zh(X(a)),
              g = T(e);
          f && f.a ? gm(a, d, f.g, g) : f ? Vl(a, d, f.g, g) : fm(a, d, e);
        } else e && "auth/credential-already-in-use" == e.code || (e && "auth/operation-not-supported-in-this-environment" == e.code && Sl(a) ? bm(a, d, {
          user: null,
          credential: null
        }) : fm(a, d, e));
      }));
    };

    function im(a, b) {
      P.call(this, Ek, void 0, b, "differentDeviceError");
      this.i = a;
    }

    m(im, P);

    im.prototype.v = function () {
      var a = this;
      O(this, this.l(), function () {
        a.i();
      });
      this.l().focus();
      P.prototype.v.call(this);
    };

    im.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(im.prototype, {
      l: gl
    });

    K.differentDeviceError = function (a, b) {
      var c = new im(function () {
        c.o();
        S(a, b);
      });
      c.render(b);
      Y(a, c);
    };

    function jm(a, b, c, d) {
      P.call(this, Ok, {
        email: a,
        G: !!c
      }, d, "emailChangeRevoke");
      this.l = b;
      this.i = c || null;
    }

    m(jm, P);

    jm.prototype.v = function () {
      var a = this;
      O(this, M(this, "firebaseui-id-reset-password-link"), function () {
        a.l();
      });
      this.i && (this.w(this.i), this.u().focus());
      P.prototype.v.call(this);
    };

    jm.prototype.m = function () {
      this.l = this.i = null;
      P.prototype.m.call(this);
    };

    u(jm.prototype, {
      u: fl,
      B: gl,
      w: hl
    });

    function km() {
      return M(this, "firebaseui-id-new-password");
    }

    function lm() {
      return M(this, "firebaseui-id-password-toggle");
    }

    function mm() {
      this.Ra = !this.Ra;
      var a = lm.call(this),
          b = km.call(this);
      this.Ra ? (b.type = "text", Ri(a, "firebaseui-input-toggle-off"), Si(a, "firebaseui-input-toggle-on")) : (b.type = "password", Ri(a, "firebaseui-input-toggle-on"), Si(a, "firebaseui-input-toggle-off"));
      b.focus();
    }

    function nm() {
      return M(this, "firebaseui-id-new-password-error");
    }

    function om() {
      this.Ra = !1;
      var a = km.call(this);
      a.type = "password";
      var b = nm.call(this);
      Gj(this, a, function () {
        Mj(b) && (N(a, !0), Kj(b));
      });
      var c = lm.call(this);
      Ri(c, "firebaseui-input-toggle-on");
      Si(c, "firebaseui-input-toggle-off");
      Ij(this, a, function () {
        Ri(c, "firebaseui-input-toggle-focus");
        Si(c, "firebaseui-input-toggle-blur");
      });
      Jj(this, a, function () {
        Ri(c, "firebaseui-input-toggle-blur");
        Si(c, "firebaseui-input-toggle-focus");
      });
      O(this, c, t(mm, this));
    }

    function pm() {
      var a = km.call(this);
      var b = nm.call(this);
      Ti(a) ? (N(a, !0), Kj(b), b = !0) : (N(a, !1), Lj(b, C("Enter your password").toString()), b = !1);
      return b ? Ti(a) : null;
    }

    function qm(a, b, c) {
      P.call(this, Lk, {
        email: a
      }, c, "passwordReset");
      this.l = b;
    }

    m(qm, P);

    qm.prototype.v = function () {
      this.H();
      this.B(this.l);
      sk(this, this.i(), this.l);
      this.i().focus();
      P.prototype.v.call(this);
    };

    qm.prototype.m = function () {
      this.l = null;
      P.prototype.m.call(this);
    };

    u(qm.prototype, {
      i: km,
      w: nm,
      M: lm,
      H: om,
      u: pm,
      U: fl,
      P: gl,
      B: hl
    });

    function rm(a, b, c, d, e) {
      P.call(this, Uk, {
        factorId: a,
        phoneNumber: c || null,
        G: !!d
      }, e, "revertSecondFactorAdditionSuccess");
      this.l = b;
      this.i = d || null;
    }

    m(rm, P);

    rm.prototype.v = function () {
      var a = this;
      O(this, M(this, "firebaseui-id-reset-password-link"), function () {
        a.l();
      });
      this.i && (this.w(this.i), this.u().focus());
      P.prototype.v.call(this);
    };

    rm.prototype.m = function () {
      this.l = this.i = null;
      P.prototype.m.call(this);
    };

    u(rm.prototype, {
      u: fl,
      B: gl,
      w: hl
    });

    function sm(a, b, c, d, e) {
      var f = c.u();
      f && V(a, c.I(t(U(a).confirmPasswordReset, U(a)), [d, f], function () {
        c.o();
        var g = new Bl(e);
        g.render(b);
        Y(a, g);
      }, function (g) {
        tm(a, b, c, g);
      }));
    }

    function tm(a, b, c, d) {
      "auth/weak-password" == (d && d.code) ? (a = T(d), N(c.i(), !1), Lj(c.w(), a), c.i().focus()) : (c && c.o(), c = new Cl(), c.render(b), Y(a, c));
    }

    function um(a, b, c) {
      var d = new jm(c, function () {
        V(a, d.I(t(U(a).sendPasswordResetEmail, U(a)), [c], function () {
          d.o();
          d = new ul(c, void 0, J(W(a)), wi(W(a)));
          d.render(b);
          Y(a, d);
        }, function () {
          d.a(Jd().toString());
        }));
      });
      d.render(b);
      Y(a, d);
    }

    function vm(a, b, c, d) {
      var e = new rm(d.factorId, function () {
        e.I(t(U(a).sendPasswordResetEmail, U(a)), [c], function () {
          e.o();
          e = new ul(c, void 0, J(W(a)), wi(W(a)));
          e.render(b);
          Y(a, e);
        }, function () {
          e.a(Jd().toString());
        });
      }, d.phoneNumber);
      e.render(b);
      Y(a, e);
    }

    K.passwordReset = function (a, b, c, d) {
      V(a, U(a).verifyPasswordResetCode(c).then(function (e) {
        var f = new qm(e, function () {
          sm(a, b, f, c, d);
        });
        f.render(b);
        Y(a, f);
      }, function () {
        tm(a, b);
      }));
    };

    K.emailChangeRevocation = function (a, b, c) {
      var d = null;
      V(a, U(a).checkActionCode(c).then(function (e) {
        d = e.data.email;
        return U(a).applyActionCode(c);
      }).then(function () {
        um(a, b, d);
      }, function () {
        var e = new Dl();
        e.render(b);
        Y(a, e);
      }));
    };

    K.emailVerification = function (a, b, c, d) {
      V(a, U(a).applyActionCode(c).then(function () {
        var e = new vl(d);
        e.render(b);
        Y(a, e);
      }, function () {
        var e = new wl();
        e.render(b);
        Y(a, e);
      }));
    };

    K.revertSecondFactorAddition = function (a, b, c) {
      var d = null,
          e = null;
      V(a, U(a).checkActionCode(c).then(function (f) {
        d = f.data.email;
        e = f.data.multiFactorInfo;
        return U(a).applyActionCode(c);
      }).then(function () {
        vm(a, b, d, e);
      }, function () {
        var f = new zl();
        f.render(b);
        Y(a, f);
      }));
    };

    K.verifyAndChangeEmail = function (a, b, c, d) {
      var e = null;
      V(a, U(a).checkActionCode(c).then(function (f) {
        e = f.data.email;
        return U(a).applyActionCode(c);
      }).then(function () {
        var f = new xl(e, d);
        f.render(b);
        Y(a, f);
      }, function () {
        var f = new yl();
        f.render(b);
        Y(a, f);
      }));
    };

    function wm(a, b) {
      try {
        var c = "number" == typeof a.selectionStart;
      } catch (d) {
        c = !1;
      }

      c ? (a.selectionStart = b, a.selectionEnd = b) : z && !nc("9") && ("textarea" == a.type && (b = a.value.substring(0, b).replace(/(\r\n|\r|\n)/g, "\n").length), a = a.createTextRange(), a.collapse(!0), a.move("character", b), a.select());
    }

    function xm(a, b, c, d, e, f) {
      P.call(this, Dk, {
        email: c
      }, f, "emailLinkSignInConfirmation", {
        F: d,
        D: e
      });
      this.l = a;
      this.u = b;
    }

    m(xm, P);

    xm.prototype.v = function () {
      this.w(this.l);
      this.B(this.l, this.u);
      this.i().focus();
      wm(this.i(), (this.i().value || "").length);
      P.prototype.v.call(this);
    };

    xm.prototype.m = function () {
      this.u = this.l = null;
      P.prototype.m.call(this);
    };

    u(xm.prototype, {
      i: ol,
      M: pl,
      w: ql,
      H: rl,
      j: sl,
      U: fl,
      P: gl,
      B: hl
    });

    K.emailLinkConfirmation = function (a, b, c, d, e, f) {
      var g = new xm(function () {
        var h = g.j();
        h ? (g.o(), d(a, b, h, c)) : g.i().focus();
      }, function () {
        g.o();
        S(a, b, e || void 0);
      }, e || void 0, J(W(a)), wi(W(a)));
      g.render(b);
      Y(a, g);
      f && g.a(f);
    };

    function ym(a, b, c, d, e) {
      P.call(this, Ik, {
        ga: a
      }, e, "emailLinkSignInLinkingDifferentDevice", {
        F: c,
        D: d
      });
      this.i = b;
    }

    m(ym, P);

    ym.prototype.v = function () {
      this.u(this.i);
      this.l().focus();
      P.prototype.v.call(this);
    };

    ym.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(ym.prototype, {
      l: fl,
      u: hl
    });

    K.emailLinkNewDeviceLinking = function (a, b, c, d) {
      var e = new Qb(c);
      c = e.a.a.get(x.PROVIDER_ID) || null;
      Ub(e, null);

      if (c) {
        var f = new ym(ii(W(a), c), function () {
          f.o();
          d(a, b, e.toString());
        }, J(W(a)), wi(W(a)));
        f.render(b);
        Y(a, f);
      } else S(a, b);
    };

    function zm(a) {
      P.call(this, Ak, void 0, a, "blank");
    }

    m(zm, P);

    function Am(a, b, c, d, e) {
      var f = new zm(),
          g = new Qb(c),
          h = g.a.a.get(x.$a) || "",
          k = g.a.a.get(x.Sa) || "",
          p = "1" === g.a.a.get(x.Qa),
          r = Tb(g),
          H = g.a.a.get(x.PROVIDER_ID) || null;
      g = g.a.a.get(x.vb) || null;
      Bm(a, g);
      var Ba = !vh(th, X(a)),
          Vk = d || Eh(k, X(a)),
          jd = (d = Fh(k, X(a))) && d.a;
      H && jd && jd.providerId !== H && (jd = null);
      f.render(b);
      Y(a, f);
      V(a, f.I(function () {
        var xa = G(null);
        xa = r && Ba || Ba && p ? df(Error("anonymous-user-not-found")) : Cm(a, c).then(function (ug) {
          if (H && !jd) throw Error("pending-credential-not-found");
          return ug;
        });
        var kd = null;
        return xa.then(function (ug) {
          kd = ug;
          return e ? null : U(a).checkActionCode(h);
        }).then(function () {
          return kd;
        });
      }, [], function (xa) {
        Vk ? Dm(a, f, Vk, c, jd, xa) : p ? (f.o(), L("differentDeviceError", a, b)) : (f.o(), L("emailLinkConfirmation", a, b, c, Em));
      }, function (xa) {
        var kd = void 0;
        if (!xa || !xa.name || "cancel" != xa.name) switch (f.o(), xa && xa.message) {
          case "anonymous-user-not-found":
            L("differentDeviceError", a, b);
            break;

          case "anonymous-user-mismatch":
            L("anonymousUserMismatch", a, b);
            break;

          case "pending-credential-not-found":
            L("emailLinkNewDeviceLinking", a, b, c, Fm);
            break;

          default:
            xa && (kd = T(xa)), S(a, b, void 0, kd);
        }
      }));
    }

    function Em(a, b, c, d) {
      Am(a, b, d, c, !0);
    }

    function Fm(a, b, c) {
      Am(a, b, c);
    }

    function Dm(a, b, c, d, e, f) {
      var g = Q(b);
      b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Signing in...").toString());
      var h = null;
      e = (f ? Gm(a, f, c, d, e) : Hm(a, c, d, e)).then(function (k) {
        wh(uh, X(a));
        wh(th, X(a));
        b.h();
        b.$("firebaseui-icon-done", C("Signed in!").toString());
        h = setTimeout(function () {
          b.h();
          Gl(a, b, k, !0);
        }, 1E3);
        V(a, function () {
          b && (b.h(), b.o());
          clearTimeout(h);
        });
      }, function (k) {
        b.h();
        b.o();

        if (!k.name || "cancel" != k.name) {
          var p = T(k);
          "auth/email-already-in-use" == k.code || "auth/credential-already-in-use" == k.code ? (wh(uh, X(a)), wh(th, X(a))) : "auth/invalid-email" == k.code ? (p = C("The email provided does not match the current sign-in session.").toString(), L("emailLinkConfirmation", a, g, d, Em, null, p)) : S(a, g, c, p);
        }
      });
      V(a, e);
    }

    K.emailLinkSignInCallback = Am;

    function Im(a, b, c, d, e, f) {
      P.call(this, Hk, {
        email: a,
        ga: b
      }, f, "emailLinkSignInLinking", {
        F: d,
        D: e
      });
      this.i = c;
    }

    m(Im, P);

    Im.prototype.v = function () {
      this.u(this.i);
      this.l().focus();
      P.prototype.v.call(this);
    };

    Im.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(Im.prototype, {
      l: fl,
      u: hl
    });

    function Jm(a, b, c, d) {
      var e = Q(b);
      Xl(a, b, c, function () {
        S(a, e, c);
      }, function (f) {
        if (!f.name || "cancel" != f.name) {
          var g = T(f);
          f && "auth/network-request-failed" == f.code ? b.a(g) : (b.o(), S(a, e, c, g));
        }
      }, d);
    }

    K.emailLinkSignInLinking = function (a, b, c) {
      var d = zh(X(a));
      Ah(X(a));

      if (d) {
        var e = d.a.providerId,
            f = new Im(c, ii(W(a), e), function () {
          Jm(a, f, c, d);
        }, J(W(a)), wi(W(a)));
        f.render(b);
        Y(a, f);
      } else S(a, b);
    };

    function Km(a, b, c, d, e, f) {
      P.call(this, Bk, {
        email: a
      }, f, "emailLinkSignInSent", {
        F: d,
        D: e
      });
      this.u = b;
      this.i = c;
    }

    m(Km, P);

    Km.prototype.v = function () {
      var a = this;
      O(this, this.l(), function () {
        a.i();
      });
      O(this, M(this, "firebaseui-id-trouble-getting-email-link"), function () {
        a.u();
      });
      this.l().focus();
      P.prototype.v.call(this);
    };

    Km.prototype.m = function () {
      this.i = this.u = null;
      P.prototype.m.call(this);
    };

    u(Km.prototype, {
      l: gl
    });

    K.emailLinkSignInSent = function (a, b, c, d, e) {
      var f = new Km(c, function () {
        f.o();
        L("emailNotReceived", a, b, c, d, e);
      }, function () {
        f.o();
        d();
      }, J(W(a)), wi(W(a)));
      f.render(b);
      Y(a, f);
    };

    function Lm(a, b, c, d, e, f, g) {
      P.call(this, Zk, {
        hc: a,
        Ob: b
      }, g, "emailMismatch", {
        F: e,
        D: f
      });
      this.l = c;
      this.i = d;
    }

    m(Lm, P);

    Lm.prototype.v = function () {
      this.w(this.l, this.i);
      this.u().focus();
      P.prototype.v.call(this);
    };

    Lm.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(Lm.prototype, {
      u: fl,
      B: gl,
      w: hl
    });

    K.emailMismatch = function (a, b, c) {
      var d = zh(X(a));

      if (d) {
        var e = new Lm(c.user.email, d.g, function () {
          var f = e;
          Ah(X(a));
          Gl(a, f, c);
        }, function () {
          var f = c.credential.providerId,
              g = Q(e);
          e.o();
          d.a ? L("federatedLinking", a, g, d.g, f) : L("federatedSignIn", a, g, d.g, f);
        }, J(W(a)), wi(W(a)));
        e.render(b);
        Y(a, e);
      } else S(a, b);
    };

    function Mm(a, b, c, d, e) {
      P.call(this, Ck, void 0, e, "emailNotReceived", {
        F: c,
        D: d
      });
      this.l = a;
      this.i = b;
    }

    m(Mm, P);

    Mm.prototype.v = function () {
      var a = this;
      O(this, this.u(), function () {
        a.i();
      });
      O(this, this.Da(), function () {
        a.l();
      });
      this.u().focus();
      P.prototype.v.call(this);
    };

    Mm.prototype.Da = function () {
      return M(this, "firebaseui-id-resend-email-link");
    };

    Mm.prototype.m = function () {
      this.i = this.l = null;
      P.prototype.m.call(this);
    };

    u(Mm.prototype, {
      u: gl
    });

    K.emailNotReceived = function (a, b, c, d, e) {
      var f = new Mm(function () {
        Xl(a, f, c, d, function (g) {
          g = T(g);
          f.a(g);
        }, e);
      }, function () {
        f.o();
        S(a, b, c);
      }, J(W(a)), wi(W(a)));
      f.render(b);
      Y(a, f);
    };

    function Nm(a, b, c, d, e, f) {
      P.call(this, Jk, {
        email: a,
        ga: b
      }, f, "federatedLinking", {
        F: d,
        D: e
      });
      this.i = c;
    }

    m(Nm, P);

    Nm.prototype.v = function () {
      this.u(this.i);
      this.l().focus();
      P.prototype.v.call(this);
    };

    Nm.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(Nm.prototype, {
      l: fl,
      u: hl
    });

    K.federatedLinking = function (a, b, c, d, e) {
      var f = zh(X(a));

      if (f && f.a) {
        var g = new Nm(c, ii(W(a), d), function () {
          Ml(a, g, d, c);
        }, J(W(a)), wi(W(a)));
        g.render(b);
        Y(a, g);
        e && g.a(e);
      } else S(a, b);
    };

    K.federatedRedirect = function (a, b, c) {
      var d = new zm();
      d.render(b);
      Y(a, d);
      b = hi(W(a))[0];
      Ml(a, d, b, c);
    };

    K.federatedSignIn = function (a, b, c, d, e) {
      var f = new Nm(c, ii(W(a), d), function () {
        Ml(a, f, d, c);
      }, J(W(a)), wi(W(a)));
      f.render(b);
      Y(a, f);
      e && f.a(e);
    };

    function Om(a, b, c, d) {
      var e = b.u();
      e ? V(a, b.I(t(a.Vb, a), [c, e], function (f) {
        f = f.user.linkWithCredential(d).then(function (g) {
          return Gl(a, b, {
            user: g.user,
            credential: d,
            operationType: g.operationType,
            additionalUserInfo: g.additionalUserInfo
          });
        });
        V(a, f);
        return f;
      }, function (f) {
        if (!f.name || "cancel" != f.name) switch (f.code) {
          case "auth/wrong-password":
            N(b.i(), !1);
            Lj(b.B(), T(f));
            break;

          case "auth/too-many-requests":
            b.a(T(f));
            break;

          default:
            og("signInWithEmailAndPassword: " + f.message, void 0), b.a(T(f));
        }
      })) : b.i().focus();
    }

    K.passwordLinking = function (a, b, c) {
      var d = zh(X(a));
      Ah(X(a));
      var e = d && d.a;

      if (e) {
        var f = new ml(c, function () {
          Om(a, f, c, e);
        }, function () {
          f.o();
          L("passwordRecovery", a, b, c);
        }, J(W(a)), wi(W(a)));
        f.render(b);
        Y(a, f);
      } else S(a, b);
    };

    function Pm(a, b, c, d, e, f) {
      P.call(this, wk, {
        email: c,
        Ta: !!b
      }, f, "passwordRecovery", {
        F: d,
        D: e
      });
      this.l = a;
      this.u = b;
    }

    m(Pm, P);

    Pm.prototype.v = function () {
      this.B();
      this.H(this.l, this.u);
      Ti(this.i()) || this.i().focus();
      sk(this, this.i(), this.l);
      P.prototype.v.call(this);
    };

    Pm.prototype.m = function () {
      this.u = this.l = null;
      P.prototype.m.call(this);
    };

    u(Pm.prototype, {
      i: ol,
      w: pl,
      B: ql,
      M: rl,
      j: sl,
      U: fl,
      P: gl,
      H: hl
    });

    function Qm(a, b) {
      var c = b.j();

      if (c) {
        var d = Q(b);
        V(a, b.I(t(U(a).sendPasswordResetEmail, U(a)), [c], function () {
          b.o();
          var e = new ul(c, function () {
            e.o();
            S(a, d);
          }, J(W(a)), wi(W(a)));
          e.render(d);
          Y(a, e);
        }, function (e) {
          N(b.i(), !1);
          Lj(b.w(), T(e));
        }));
      } else b.i().focus();
    }

    K.passwordRecovery = function (a, b, c, d, e) {
      var f = new Pm(function () {
        Qm(a, f);
      }, d ? void 0 : function () {
        f.o();
        S(a, b);
      }, c, J(W(a)), wi(W(a)));
      f.render(b);
      Y(a, f);
      e && f.a(e);
    };

    K.passwordSignIn = function (a, b, c, d) {
      var e = new tl(function () {
        Rl(a, e);
      }, function () {
        var f = e.M();
        e.o();
        L("passwordRecovery", a, b, f);
      }, c, J(W(a)), wi(W(a)), d);
      e.render(b);
      Y(a, e);
    };

    function Rm() {
      return M(this, "firebaseui-id-name");
    }

    function Sm() {
      return M(this, "firebaseui-id-name-error");
    }

    function Tm(a, b, c, d, e, f, g, h, k) {
      P.call(this, vk, {
        email: d,
        Rb: a,
        name: e,
        Ta: !!c,
        ia: !!h
      }, k, "passwordSignUp", {
        F: f,
        D: g
      });
      this.w = b;
      this.H = c;
      this.B = a;
    }

    m(Tm, P);

    Tm.prototype.v = function () {
      this.ea();
      this.B && this.Ja();
      this.ua();
      this.pa(this.w, this.H);
      this.B ? (rk(this, this.i(), this.u()), rk(this, this.u(), this.l())) : rk(this, this.i(), this.l());
      this.w && sk(this, this.l(), this.w);
      Ti(this.i()) ? this.B && !Ti(this.u()) ? this.u().focus() : this.l().focus() : this.i().focus();
      P.prototype.v.call(this);
    };

    Tm.prototype.m = function () {
      this.H = this.w = null;
      P.prototype.m.call(this);
    };

    u(Tm.prototype, {
      i: ol,
      U: pl,
      ea: ql,
      jb: rl,
      j: sl,
      u: Rm,
      zc: Sm,
      Ja: function Ja() {
        var a = Rm.call(this),
            b = Sm.call(this);
        Gj(this, a, function () {
          Mj(b) && (N(a, !0), Kj(b));
        });
      },
      M: function M() {
        var a = Rm.call(this);
        var b = Sm.call(this);
        var c = Ti(a);
        c = !/^[\s\xa0]*$/.test(null == c ? "" : String(c));
        N(a, c);
        c ? (Kj(b), b = !0) : (Lj(b, C("Enter your account name").toString()), b = !1);
        return b ? Va(Ti(a)) : null;
      },
      l: km,
      ba: nm,
      lb: lm,
      ua: om,
      P: pm,
      Lb: fl,
      Kb: gl,
      pa: hl
    });

    function Um(a, b) {
      var c = xi(W(a)),
          d = b.j(),
          e = null;
      c && (e = b.M());
      var f = b.P();

      if (d) {
        if (c) if (e) e = db(e);else {
          b.u().focus();
          return;
        }

        if (f) {
          var g = firebase.auth.EmailAuthProvider.credential(d, f);
          V(a, b.I(t(a.Wb, a), [d, f], function (h) {
            var k = {
              user: h.user,
              credential: g,
              operationType: h.operationType,
              additionalUserInfo: h.additionalUserInfo
            };
            return c ? (h = h.user.updateProfile({
              displayName: e
            }).then(function () {
              return Gl(a, b, k);
            }), V(a, h), h) : Gl(a, b, k);
          }, function (h) {
            if (!h.name || "cancel" != h.name) {
              var k = T(h);

              switch (h.code) {
                case "auth/email-already-in-use":
                  return Vm(a, b, d, h);

                case "auth/too-many-requests":
                  k = C("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();

                case "auth/operation-not-allowed":
                case "auth/weak-password":
                  N(b.l(), !1);
                  Lj(b.ba(), k);
                  break;

                default:
                  h = "setAccountInfo: " + ah(h), og(h, void 0), b.a(k);
              }
            }
          }));
        } else b.l().focus();
      } else b.i().focus();
    }

    function Vm(a, b, c, d) {
      function e() {
        var g = T(d);
        N(b.i(), !1);
        Lj(b.U(), g);
        b.i().focus();
      }

      var f = U(a).fetchSignInMethodsForEmail(c).then(function (g) {
        g.length ? e() : (g = Q(b), b.o(), L("passwordRecovery", a, g, c, !1, Ld().toString()));
      }, function () {
        e();
      });
      V(a, f);
      return f;
    }

    K.passwordSignUp = function (a, b, c, d, e, f) {
      function g() {
        h.o();
        S(a, b);
      }

      var h = new Tm(xi(W(a)), function () {
        Um(a, h);
      }, e ? void 0 : g, c, d, J(W(a)), wi(W(a)), f);
      h.render(b);
      Y(a, h);
    };

    function Wm() {
      return M(this, "firebaseui-id-phone-confirmation-code");
    }

    function Xm() {
      return M(this, "firebaseui-id-phone-confirmation-code-error");
    }

    function Ym() {
      return M(this, "firebaseui-id-resend-countdown");
    }

    function Zm(a, b, c, d, e, f, g, h, k) {
      P.call(this, bl, {
        phoneNumber: e
      }, k, "phoneSignInFinish", {
        F: g,
        D: h
      });
      this.jb = f;
      this.i = new ej(1E3);
      this.B = f;
      this.P = a;
      this.l = b;
      this.H = c;
      this.M = d;
    }

    m(Zm, P);

    Zm.prototype.v = function () {
      var a = this;
      this.U(this.jb);
      le(this.i, "tick", this.w, !1, this);
      this.i.start();
      O(this, M(this, "firebaseui-id-change-phone-number-link"), function () {
        a.P();
      });
      O(this, this.Da(), function () {
        a.M();
      });
      this.Ja(this.l);
      this.ea(this.l, this.H);
      this.u().focus();
      P.prototype.v.call(this);
    };

    Zm.prototype.m = function () {
      this.M = this.H = this.l = this.P = null;
      fj(this.i);
      te(this.i, "tick", this.w);
      this.i = null;
      P.prototype.m.call(this);
    };

    Zm.prototype.w = function () {
      --this.B;
      0 < this.B ? this.U(this.B) : (fj(this.i), te(this.i, "tick", this.w), this.ua(), this.lb());
    };

    u(Zm.prototype, {
      u: Wm,
      pa: Xm,
      Ja: function Ja(a) {
        var b = Wm.call(this),
            c = Xm.call(this);
        Gj(this, b, function () {
          Mj(c) && (N(b, !0), Kj(c));
        });
        a && Hj(this, b, function () {
          a();
        });
      },
      ba: function ba() {
        var a = Va(Ti(Wm.call(this)) || "");
        return /^\d{6}$/.test(a) ? a : null;
      },
      Db: Ym,
      U: function U(a) {
        ad(Ym.call(this), C("Resend code in " + ((9 < a ? "0:" : "0:0") + a)).toString());
      },
      ua: function ua() {
        Kj(this.Db());
      },
      Da: function Da() {
        return M(this, "firebaseui-id-resend-link");
      },
      lb: function lb() {
        Lj(this.Da());
      },
      Lb: fl,
      Kb: gl,
      ea: hl
    });

    function $m(a, b, c, d) {
      function e(g) {
        b.u().focus();
        N(b.u(), !1);
        Lj(b.pa(), g);
      }

      var f = b.ba();
      f ? (b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Verifying...").toString()), V(a, b.I(t(d.confirm, d), [f], function (g) {
        b.h();
        b.$("firebaseui-icon-done", C("Verified!").toString());
        var h = setTimeout(function () {
          b.h();
          b.o();
          var k = {
            user: an(a).currentUser,
            credential: null,
            operationType: g.operationType,
            additionalUserInfo: g.additionalUserInfo
          };
          Gl(a, b, k, !0);
        }, 1E3);
        V(a, function () {
          b && b.h();
          clearTimeout(h);
        });
      }, function (g) {
        if (g.name && "cancel" == g.name) b.h();else {
          var h = T(g);

          switch (g.code) {
            case "auth/credential-already-in-use":
              b.h();
              break;

            case "auth/code-expired":
              g = Q(b);
              b.h();
              b.o();
              L("phoneSignInStart", a, g, c, h);
              break;

            case "auth/missing-verification-code":
            case "auth/invalid-verification-code":
              b.h();
              e(h);
              break;

            default:
              b.h(), b.a(h);
          }
        }
      }))) : e(C("Wrong code. Try again.").toString());
    }

    K.phoneSignInFinish = function (a, b, c, d, e, f) {
      var g = new Zm(function () {
        g.o();
        L("phoneSignInStart", a, b, c);
      }, function () {
        $m(a, g, c, e);
      }, function () {
        g.o();
        S(a, b);
      }, function () {
        g.o();
        L("phoneSignInStart", a, b, c);
      }, Yh(c), d, J(W(a)), wi(W(a)));
      g.render(b);
      Y(a, g);
      f && g.a(f);
    };

    var bn = !z && !(y("Safari") && !(Yb() || y("Coast") || y("Opera") || y("Edge") || y("Firefox") || y("FxiOS") || y("Silk") || y("Android")));

    function cn(a, b) {
      if (/-[a-z]/.test(b)) return null;

      if (bn && a.dataset) {
        if (!(!y("Android") || Yb() || y("Firefox") || y("FxiOS") || y("Opera") || y("Silk") || b in a.dataset)) return null;
        a = a.dataset[b];
        return void 0 === a ? null : a;
      }

      return a.getAttribute("data-" + String(b).replace(/([A-Z])/g, "-$1").toLowerCase());
    }

    function dn(a, b, c) {
      var d = this;
      a = id(bk, {
        items: a
      }, null, this.s);
      ik.call(this, a, !0, !0);
      c && (c = en(a, c)) && (c.focus(), yj(c, a));
      O(this, a, function (e) {
        if (e = (e = bd(e.target, "firebaseui-id-list-box-dialog-button")) && cn(e, "listboxid")) jk.call(d), b(e);
      });
    }

    function en(a, b) {
      a = (a || document).getElementsByTagName("BUTTON");

      for (var c = 0; c < a.length; c++) {
        if (cn(a[c], "listboxid") === b) return a[c];
      }

      return null;
    }

    function fn() {
      return M(this, "firebaseui-id-phone-number");
    }

    function gn() {
      return M(this, "firebaseui-id-country-selector");
    }

    function hn() {
      return M(this, "firebaseui-id-phone-number-error");
    }

    function jn(a, b) {
      var c = a.a,
          d = kn("1-US-0", c),
          e = null;
      b && kn(b, c) ? e = b : d ? e = "1-US-0" : e = 0 < c.length ? c[0].c : null;
      if (!e) throw Error("No available default country");
      ln.call(this, e, a);
    }

    function kn(a, b) {
      a = Qh(a);
      return !(!a || !Ma(b, a));
    }

    function mn(a) {
      return Ka(a, function (b) {
        return {
          id: b.c,
          Ma: "firebaseui-flag " + nn(b),
          label: b.name + " " + ("\u200E+" + b.b)
        };
      });
    }

    function nn(a) {
      return "firebaseui-flag-" + a.f;
    }

    function on(a) {
      var b = this;
      dn.call(this, mn(a.a), function (c) {
        ln.call(b, c, a, !0);
        b.O().focus();
      }, this.Ba);
    }

    function ln(a, b, c) {
      var d = Qh(a);
      d && (c && (c = Va(Ti(fn.call(this)) || ""), b = Ph(b, c), b.length && b[0].b != d.b && (c = "+" + d.b + c.substr(b[0].b.length + 1), Ui(fn.call(this), c))), b = Qh(this.Ba), this.Ba = a, a = M(this, "firebaseui-id-country-selector-flag"), b && Si(a, nn(b)), Ri(a, nn(d)), ad(M(this, "firebaseui-id-country-selector-code"), "\u200E+" + d.b));
    }

    function pn(a, b, c, d, e, f, g, h, k, p) {
      P.call(this, al, {
        Eb: b,
        Aa: k || null,
        Va: !!c,
        ia: !!f
      }, p, "phoneSignInStart", {
        F: d,
        D: e
      });
      this.H = h || null;
      this.M = b;
      this.l = a;
      this.w = c || null;
      this.pa = g || null;
    }

    m(pn, P);

    pn.prototype.v = function () {
      this.ea(this.pa, this.H);
      this.P(this.l, this.w || void 0);
      this.M || rk(this, this.O(), this.i());
      sk(this, this.i(), this.l);
      this.O().focus();
      wm(this.O(), (this.O().value || "").length);
      P.prototype.v.call(this);
    };

    pn.prototype.m = function () {
      this.w = this.l = null;
      P.prototype.m.call(this);
    };

    u(pn.prototype, {
      Bb: kk,
      O: fn,
      B: hn,
      ea: function ea(a, b, c) {
        var d = this,
            e = fn.call(this),
            f = gn.call(this),
            g = hn.call(this),
            h = a || Vh,
            k = h.a;
        if (0 == k.length) throw Error("No available countries provided.");
        jn.call(d, h, b);
        O(this, f, function () {
          on.call(d, h);
        });
        Gj(this, e, function () {
          Mj(g) && (N(e, !0), Kj(g));
          var p = Va(Ti(e) || ""),
              r = Qh(this.Ba),
              H = Ph(h, p);
          p = kn("1-US-0", k);
          H.length && H[0].b != r.b && (r = H[0], ln.call(d, "1" == r.b && p ? "1-US-0" : r.c, h));
        });
        c && Hj(this, e, function () {
          c();
        });
      },
      U: function U(a) {
        var b = Va(Ti(fn.call(this)) || "");
        a = a || Vh;
        var c = a.a,
            d = Ph(Vh, b);
        if (d.length && !Ma(c, d[0])) throw Ui(fn.call(this)), fn.call(this).focus(), Lj(hn.call(this), C("The country code provided is not supported.").toString()), Error("The country code provided is not supported.");
        c = Qh(this.Ba);
        d.length && d[0].b != c.b && ln.call(this, d[0].c, a);
        d.length && (b = b.substr(d[0].b.length + 1));
        return b ? new Wh(this.Ba, b) : null;
      },
      Ja: gn,
      ba: function ba() {
        return M(this, "firebaseui-recaptcha-container");
      },
      u: function u() {
        return M(this, "firebaseui-id-recaptcha-error");
      },
      i: fl,
      ua: gl,
      P: hl
    });

    function qn(a, b, c, d) {
      try {
        var e = b.U(Ni);
      } catch (f) {
        return;
      }

      e ? Li ? (b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Verifying...").toString()), V(a, b.I(t(a.ac, a), [Yh(e), c], function (f) {
        var g = Q(b);
        b.$("firebaseui-icon-done", C("Code sent!").toString());
        var h = setTimeout(function () {
          b.h();
          b.o();
          L("phoneSignInFinish", a, g, e, 15, f);
        }, 1E3);
        V(a, function () {
          b && b.h();
          clearTimeout(h);
        });
      }, function (f) {
        b.h();

        if (!f.name || "cancel" != f.name) {
          grecaptcha.reset(Oi);
          Li = null;
          var g = f && f.message || "";
          if (f.code) switch (f.code) {
            case "auth/too-many-requests":
              g = C("This phone number has been used too many times").toString();
              break;

            case "auth/invalid-phone-number":
            case "auth/missing-phone-number":
              b.O().focus();
              Lj(b.B(), Id().toString());
              return;

            default:
              g = T(f);
          }
          b.a(g);
        }
      }))) : Mi ? Lj(b.u(), C("Solve the reCAPTCHA").toString()) : !Mi && d && b.i().click() : (b.O().focus(), Lj(b.B(), Id().toString()));
    }

    K.phoneSignInStart = function (a, b, c, d) {
      var e = oi(W(a)) || {};
      Li = null;
      Mi = !(e && "invisible" === e.size);
      var f = Tl(a),
          g = ti(W(a)),
          h = f ? si(W(a)) : null;
      g = c && c.a || g && g.c || null;
      c = c && c.Aa || h;
      (h = ui(W(a))) && Uh(h);
      Ni = h ? new Oh(ui(W(a))) : Vh;
      var k = new pn(function (r) {
        qn(a, k, p, !(!r || !r.keyCode));
      }, Mi, f ? null : function () {
        p.clear();
        k.o();
        S(a, b);
      }, J(W(a)), wi(W(a)), f, Ni, g, c);
      k.render(b);
      Y(a, k);
      d && k.a(d);

      e.callback = function (r) {
        k.u() && Kj(k.u());
        Li = r;
        Mi || qn(a, k, p);
      };

      e["expired-callback"] = function () {
        Li = null;
      };

      var p = new firebase.auth.RecaptchaVerifier(Mi ? k.ba() : k.i(), e, an(a).app);
      V(a, k.I(t(p.render, p), [], function (r) {
        Oi = r;
      }, function (r) {
        r.name && "cancel" == r.name || (r = T(r), k.o(), S(a, b, void 0, r));
      }));
    };

    K.prefilledEmailSignIn = function (a, b, c) {
      var d = new zm();
      d.render(b);
      Y(a, d);
      V(a, d.I(t(U(a).fetchSignInMethodsForEmail, U(a)), [c], function (e) {
        d.o();
        var f = !(!Sl(a) || !rn(a));
        Wl(a, b, e, c, void 0, f);
      }, function (e) {
        e = T(e);
        d.o();
        L("signIn", a, b, c, e);
      }));
    };

    function sn(a, b, c, d, e) {
      P.call(this, $k, {
        Qb: b
      }, e, "providerSignIn", {
        F: c,
        D: d
      });
      this.i = a;
    }

    m(sn, P);

    sn.prototype.v = function () {
      this.l(this.i);
      P.prototype.v.call(this);
    };

    sn.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(sn.prototype, {
      l: function l(a) {
        function b(g) {
          a(g);
        }

        for (var c = this.g ? Uc("firebaseui-id-idp-button", this.g || this.s.a) : [], d = 0; d < c.length; d++) {
          var e = c[d],
              f = cn(e, "providerId");
          O(this, e, za(b, f));
        }
      }
    });

    K.providerSignIn = function (a, b, c, d) {
      var e = new sn(function (f) {
        f == firebase.auth.EmailAuthProvider.PROVIDER_ID ? (e.o(), Ul(a, b, d)) : f == firebase.auth.PhoneAuthProvider.PROVIDER_ID ? (e.o(), L("phoneSignInStart", a, b)) : "anonymous" == f ? Pl(a, e) : Ml(a, e, f, d);
        Z(a);
        a.l.cancel();
      }, ji(W(a)), J(W(a)), wi(W(a)));
      e.render(b);
      Y(a, e);
      c && e.a(c);
      tn(a);
    };

    K.sendEmailLinkForSignIn = function (a, b, c, d) {
      var e = new am();
      e.render(b);
      Y(a, e);
      Xl(a, e, c, d, function (f) {
        e.o();
        f = T(f);
        L("signIn", a, b, c, f);
      });
    };

    function un(a, b, c, d, e, f, g) {
      P.call(this, tk, {
        email: c,
        Va: !!b,
        ia: !!f
      }, g, "signIn", {
        F: d,
        D: e
      });
      this.i = a;
      this.u = b;
    }

    m(un, P);

    un.prototype.v = function () {
      this.w(this.i);
      this.B(this.i, this.u || void 0);
      this.l().focus();
      wm(this.l(), (this.l().value || "").length);
      P.prototype.v.call(this);
    };

    un.prototype.m = function () {
      this.u = this.i = null;
      P.prototype.m.call(this);
    };

    u(un.prototype, {
      l: ol,
      M: pl,
      w: ql,
      H: rl,
      j: sl,
      U: fl,
      P: gl,
      B: hl
    });

    K.signIn = function (a, b, c, d) {
      var e = Sl(a),
          f = new un(function () {
        var g = f,
            h = g.j() || "";
        h && Vl(a, g, h);
      }, e ? null : function () {
        f.o();
        S(a, b, c);
      }, c, J(W(a)), wi(W(a)), e);
      f.render(b);
      Y(a, f);
      d && f.a(d);
    };

    function vn(a, b, c, d, e, f) {
      P.call(this, Kk, {
        email: a
      }, f, "unsupportedProvider", {
        F: d,
        D: e
      });
      this.l = b;
      this.i = c;
    }

    m(vn, P);

    vn.prototype.v = function () {
      this.w(this.l, this.i);
      this.u().focus();
      P.prototype.v.call(this);
    };

    vn.prototype.m = function () {
      this.i = this.l = null;
      P.prototype.m.call(this);
    };

    u(vn.prototype, {
      u: fl,
      B: gl,
      w: hl
    });

    K.unsupportedProvider = function (a, b, c) {
      var d = new vn(c, function () {
        d.o();
        L("passwordRecovery", a, b, c);
      }, function () {
        d.o();
        S(a, b, c);
      }, J(W(a)), wi(W(a)));
      d.render(b);
      Y(a, d);
    };

    function wn(a, b) {
      this.$ = !1;
      var c = xn(b);
      if (yn[c]) throw Error('An AuthUI instance already exists for the key "' + c + '"');
      yn[c] = this;
      this.a = a;
      this.u = null;
      this.Y = !1;
      zn(this.a);
      this.h = firebase.initializeApp({
        apiKey: a.app.options.apiKey,
        authDomain: a.app.options.authDomain
      }, a.app.name + "-firebaseui-temp").auth();
      zn(this.h);
      this.h.setPersistence && this.h.setPersistence(firebase.auth.Auth.Persistence.SESSION);
      this.oa = b;
      this.ca = new bi();
      this.g = this.T = this.i = this.J = this.O = null;
      this.s = [];
      this.Z = !1;
      this.l = Pf.Xa();
      this.j = this.C = null;
      this.da = this.A = !1;
    }

    function zn(a) {
      a && a.INTERNAL && a.INTERNAL.logFramework && a.INTERNAL.logFramework("FirebaseUI-web");
    }

    var yn = {};

    function xn(a) {
      return a || "[DEFAULT]";
    }

    function Nl(a) {
      Z(a);
      a.i || (a.i = An(a, function (b) {
        return b && !zh(X(a)) ? G(an(a).getRedirectResult().then(function (c) {
          return c;
        }, function (c) {
          if (c && "auth/email-already-in-use" == c.code && c.email && c.credential) throw c;
          return Bn(a, c);
        })) : G(U(a).getRedirectResult().then(function (c) {
          return di(W(a)) && !c.user && a.j && !a.j.isAnonymous ? an(a).getRedirectResult() : c;
        }));
      }));
      return a.i;
    }

    function Y(a, b) {
      Z(a);
      a.g = b;
    }

    var Cn = null;

    function U(a) {
      Z(a);
      return a.h;
    }

    function an(a) {
      Z(a);
      return a.a;
    }

    function X(a) {
      Z(a);
      return a.oa;
    }

    function rn(a) {
      Z(a);
      return a.O ? a.O.emailHint : void 0;
    }

    l = wn.prototype;

    l.nb = function () {
      Z(this);
      return !!Ch(X(this)) || Dn(tf());
    };

    function Dn(a) {
      a = new Qb(a);
      return "signIn" === (a.a.a.get(x.ub) || null) && !!a.a.a.get(x.$a);
    }

    l.start = function (a, b) {
      En(this, a, b);
    };

    function En(a, b, c, d) {
      Z(a);
      "undefined" !== typeof a.a.languageCode && (a.u = a.a.languageCode);
      var e = "en".replace(/_/g, "-");
      a.a.languageCode = e;
      a.h.languageCode = e;
      a.Y = !0;
      "undefined" !== typeof a.a.tenantId && (a.h.tenantId = a.a.tenantId);
      a.ib(c);
      a.O = d || null;
      var f = n.document;
      a.C ? a.C.then(function () {
        "complete" == f.readyState ? Fn(a, b) : me(window, "load", function () {
          Fn(a, b);
        });
      }) : "complete" == f.readyState ? Fn(a, b) : me(window, "load", function () {
        Fn(a, b);
      });
    }

    function Fn(a, b) {
      var c = sf(b, "Could not find the FirebaseUI widget element on the page.");
      c.setAttribute("lang", "en".replace(/_/g, "-"));

      if (Cn) {
        var d = Cn;
        Z(d);
        zh(X(d)) && tg("UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.");
        Cn.reset();
      }

      Cn = a;
      a.T = c;
      Gn(a, c);

      if (jh(new kh()) && jh(new lh())) {
        b = sf(b, "Could not find the FirebaseUI widget element on the page.");
        c = tf();
        d = Jh(W(a).a, "queryParameterForSignInSuccessUrl");
        c = (c = ub(c, d)) ? Ac(Cc(c)).toString() : null;

        a: {
          d = tf();
          var e = vi(W(a));
          d = ub(d, e) || "";

          for (f in Ki) {
            if (Ki[f].toLowerCase() == d.toLowerCase()) {
              var f = Ki[f];
              break a;
            }
          }

          f = "callback";
        }

        switch (f) {
          case "callback":
            c && (f = X(a), xh(sh, c, f));
            a.nb() ? L("callback", a, b) : S(a, b, rn(a));
            break;

          case "resetPassword":
            L("passwordReset", a, b, Yl(), Zl());
            break;

          case "recoverEmail":
            L("emailChangeRevocation", a, b, Yl());
            break;

          case "revertSecondFactorAddition":
            L("revertSecondFactorAddition", a, b, Yl());
            break;

          case "verifyEmail":
            L("emailVerification", a, b, Yl(), Zl());
            break;

          case "verifyAndChangeEmail":
            L("verifyAndChangeEmail", a, b, Yl(), Zl());
            break;

          case "signIn":
            L("emailLinkSignInCallback", a, b, tf());
            Hn();
            break;

          case "select":
            c && (f = X(a), xh(sh, c, f));
            S(a, b);
            break;

          default:
            throw Error("Unhandled widget operation.");
        }

        b = W(a);
        (b = Gi(b).uiShown || null) && b();
      } else b = sf(b, "Could not find the FirebaseUI widget element on the page."), f = new Fl(C("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()), f.render(b), Y(a, f);

      b = a.g && "blank" == a.g.Ga && Bi(W(a));
      Ch(X(a)) && !b && (b = Ch(X(a)), Bm(a, b.a), wh(rh, X(a)));
    }

    function An(a, b) {
      if (a.A) return b(In(a));
      V(a, function () {
        a.A = !1;
      });

      if (di(W(a))) {
        var c = new F(function (d) {
          V(a, a.a.onAuthStateChanged(function (e) {
            a.j = e;
            a.A || (a.A = !0, d(b(In(a))));
          }));
        });
        V(a, c);
        return c;
      }

      a.A = !0;
      return b(null);
    }

    function In(a) {
      Z(a);
      return di(W(a)) && a.j && a.j.isAnonymous ? a.j : null;
    }

    function V(a, b) {
      Z(a);

      if (b) {
        a.s.push(b);

        var c = function c() {
          Qa(a.s, function (d) {
            return d == b;
          });
        };

        "function" != typeof b && b.then(c, c);
      }
    }

    l.Cb = function () {
      Z(this);
      this.Z = !0;
    };

    function Jn(a) {
      Z(a);
      var b;
      (b = a.Z) || (a = W(a), a = ri(a, firebase.auth.GoogleAuthProvider.PROVIDER_ID), b = !(!a || "select_account" !== a.prompt));
      return b;
    }

    function Hl(a) {
      "undefined" !== typeof a.a.languageCode && a.Y && (a.Y = !1, a.a.languageCode = a.u);
    }

    function Bm(a, b) {
      a.a.tenantId = b;
      a.h.tenantId = b;
    }

    l.reset = function () {
      Z(this);
      var a = this;
      this.T && this.T.removeAttribute("lang");
      this.J && Ee(this.J);
      Hl(this);
      this.O = null;
      Hn();
      wh(rh, X(this));
      Z(this);
      this.l.cancel();
      this.i = G({
        user: null,
        credential: null
      });
      Cn == this && (Cn = null);
      this.T = null;

      for (var b = 0; b < this.s.length; b++) {
        if ("function" == typeof this.s[b]) this.s[b]();else this.s[b].cancel && this.s[b].cancel();
      }

      this.s = [];
      Ah(X(this));
      this.g && (this.g.o(), this.g = null);
      this.L = null;
      this.h && (this.C = hm(this).then(function () {
        a.C = null;
      }, function () {
        a.C = null;
      }));
    };

    function Gn(a, b) {
      a.L = null;
      a.J = new Fe(b);
      a.J.register();
      le(a.J, "pageEnter", function (c) {
        c = c && c.pageId;

        if (a.L != c) {
          var d = W(a);
          (d = Gi(d).uiChanged || null) && d(a.L, c);
          a.L = c;
        }
      });
    }

    l.ib = function (a) {
      Z(this);
      var b = this.ca,
          c;

      for (c in a) {
        try {
          Ih(b.a, c, a[c]);
        } catch (d) {
          og('Invalid config: "' + c + '"', void 0);
        }
      }

      gc && Ih(b.a, "popupMode", !1);
      ui(b);
      !this.da && Fi(W(this)) && (tg("signInSuccess callback is deprecated. Please use signInSuccessWithAuthResult callback instead."), this.da = !0);
    };

    function W(a) {
      Z(a);
      return a.ca;
    }

    l.Ub = function () {
      Z(this);
      var a = W(this),
          b = Jh(a.a, "widgetUrl");
      a = vi(a);
      var c = b.search(tb);

      for (var d = 0, e, f = []; 0 <= (e = sb(b, d, a, c));) {
        f.push(b.substring(d, e)), d = Math.min(b.indexOf("&", e) + 1 || c, c);
      }

      f.push(b.substr(d));
      b = f.join("").replace(vb, "$1");
      c = "=" + encodeURIComponent("select");
      (a += c) ? (c = b.indexOf("#"), 0 > c && (c = b.length), d = b.indexOf("?"), 0 > d || d > c ? (d = c, e = "") : e = b.substring(d + 1, c), b = [b.substr(0, d), e, b.substr(c)], c = b[1], b[1] = a ? c ? c + "&" + a : a : c, c = b[0] + (b[1] ? "?" + b[1] : "") + b[2]) : c = b;
      W(this).a.get("popupMode") ? (a = (window.screen.availHeight - 600) / 2, b = (window.screen.availWidth - 500) / 2, c = c || "about:blank", a = {
        width: 500,
        height: 600,
        top: 0 < a ? a : 0,
        left: 0 < b ? b : 0,
        location: !0,
        resizable: !0,
        statusbar: !0,
        toolbar: !1
      }, a.target = a.target || c.target || "google_popup", a.width = a.width || 690, a.height = a.height || 500, (a = pf(c, a)) && a.focus()) : Oc(window.location, c);
    };

    function Z(a) {
      if (a.$) throw Error("AuthUI instance is deleted!");
    }

    l.Wa = function () {
      var a = this;
      Z(this);
      return this.h.app.delete().then(function () {
        var b = xn(X(a));
        delete yn[b];
        a.reset();
        a.$ = !0;
      });
    };

    function tn(a) {
      Z(a);

      try {
        Qf(a.l, li(W(a)), Jn(a)).then(function (b) {
          return a.g ? Ql(a, a.g, b) : !1;
        });
      } catch (b) {}
    }

    l.Gb = function (a, b) {
      Z(this);
      var c = this,
          d = vf();
      if (!yi(W(this))) return df(Error("Email link sign-in should be enabled to trigger email sending."));
      var e = Ai(W(this)),
          f = new Qb(e.url);
      Rb(f, d);
      b && b.a && (Gh(d, b, X(this)), Ub(f, b.a.providerId));
      Sb(f, zi(W(this)));
      return An(this, function (g) {
        g && ((g = g.uid) ? f.a.a.set(x.Pa, g) : Ob(f.a.a, x.Pa));
        e.url = f.toString();
        return U(c).sendSignInLinkToEmail(a, e);
      }).then(function () {
        var g = X(c),
            h = {};
        h.email = a;
        xh(th, Yg(d, JSON.stringify(h)), g);
      }, function (g) {
        wh(uh, X(c));
        wh(th, X(c));
        throw g;
      });
    };

    function Cm(a, b) {
      var c = Tb(new Qb(b));
      if (!c) return G(null);
      b = new F(function (d, e) {
        var f = an(a).onAuthStateChanged(function (g) {
          f();
          g && g.isAnonymous && g.uid === c ? d(g) : g && g.isAnonymous && g.uid !== c ? e(Error("anonymous-user-mismatch")) : e(Error("anonymous-user-not-found"));
        });
        V(a, f);
      });
      V(a, b);
      return b;
    }

    function Gm(a, b, c, d, e) {
      Z(a);
      var f = e || null,
          g = firebase.auth.EmailAuthProvider.credentialWithLink(c, d);
      c = f ? U(a).signInWithEmailLink(c, d).then(function (h) {
        return h.user.linkWithCredential(f);
      }).then(function () {
        return hm(a);
      }).then(function () {
        return Bn(a, {
          code: "auth/email-already-in-use"
        }, f);
      }) : U(a).fetchSignInMethodsForEmail(c).then(function (h) {
        return h.length ? Bn(a, {
          code: "auth/email-already-in-use"
        }, g) : b.linkWithCredential(g);
      });
      V(a, c);
      return c;
    }

    function Hm(a, b, c, d) {
      Z(a);
      var e = d || null,
          f;
      b = U(a).signInWithEmailLink(b, c).then(function (g) {
        f = {
          user: g.user,
          credential: null,
          operationType: g.operationType,
          additionalUserInfo: g.additionalUserInfo
        };
        if (e) return g.user.linkWithCredential(e).then(function (h) {
          f = {
            user: h.user,
            credential: e,
            operationType: f.operationType,
            additionalUserInfo: h.additionalUserInfo
          };
        });
      }).then(function () {
        hm(a);
      }).then(function () {
        return an(a).updateCurrentUser(f.user);
      }).then(function () {
        f.user = an(a).currentUser;
        return f;
      });
      V(a, b);
      return b;
    }

    function Hn() {
      var a = tf();

      if (Dn(a)) {
        a = new Qb(a);

        for (var b in x) {
          x.hasOwnProperty(b) && Ob(a.a.a, x[b]);
        }

        b = {
          state: "signIn",
          mode: "emailLink",
          operation: "clear"
        };
        var c = n.document.title;
        n.history && n.history.replaceState && n.history.replaceState(b, c, a.toString());
      }
    }

    l.$b = function (a, b) {
      Z(this);
      var c = this;
      return U(this).signInWithEmailAndPassword(a, b).then(function (d) {
        return An(c, function (e) {
          return e ? hm(c).then(function () {
            return Bn(c, {
              code: "auth/email-already-in-use"
            }, firebase.auth.EmailAuthProvider.credential(a, b));
          }) : d;
        });
      });
    };

    l.Wb = function (a, b) {
      Z(this);
      var c = this;
      return An(this, function (d) {
        if (d) {
          var e = firebase.auth.EmailAuthProvider.credential(a, b);
          return d.linkWithCredential(e);
        }

        return U(c).createUserWithEmailAndPassword(a, b);
      });
    };

    l.Zb = function (a) {
      Z(this);
      var b = this;
      return An(this, function (c) {
        return c ? c.linkWithCredential(a).then(function (d) {
          return d;
        }, function (d) {
          if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
          return Bn(b, d, a);
        }) : U(b).signInWithCredential(a);
      });
    };

    function Ol(a, b) {
      Z(a);
      return An(a, function (c) {
        return c && !zh(X(a)) ? c.linkWithPopup(b).then(function (d) {
          return d;
        }, function (d) {
          if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
          return Bn(a, d);
        }) : U(a).signInWithPopup(b);
      });
    }

    l.bc = function (a) {
      Z(this);
      var b = this,
          c = this.i;
      this.i = null;
      return An(this, function (d) {
        return d && !zh(X(b)) ? d.linkWithRedirect(a) : U(b).signInWithRedirect(a);
      }).then(function () {}, function (d) {
        b.i = c;
        throw d;
      });
    };

    l.ac = function (a, b) {
      Z(this);
      var c = this;
      return An(this, function (d) {
        return d ? d.linkWithPhoneNumber(a, b).then(function (e) {
          return new Sf(e, function (f) {
            if ("auth/credential-already-in-use" == f.code) return Bn(c, f);
            throw f;
          });
        }) : an(c).signInWithPhoneNumber(a, b).then(function (e) {
          return new Sf(e);
        });
      });
    };

    l.Yb = function () {
      Z(this);
      return an(this).signInAnonymously();
    };

    function Jl(a, b) {
      Z(a);
      return An(a, function (c) {
        if (a.j && !a.j.isAnonymous && di(W(a)) && !U(a).currentUser) return hm(a).then(function () {
          "password" == b.credential.providerId && (b.credential = null);
          return b;
        });
        if (c) return hm(a).then(function () {
          return c.linkWithCredential(b.credential);
        }).then(function (d) {
          b.user = d.user;
          b.credential = d.credential;
          b.operationType = d.operationType;
          b.additionalUserInfo = d.additionalUserInfo;
          return b;
        }, function (d) {
          if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
          return Bn(a, d, b.credential);
        });
        if (!b.user) throw Error('Internal error: An incompatible or outdated version of "firebase.js" may be used.');
        return hm(a).then(function () {
          return an(a).updateCurrentUser(b.user);
        }).then(function () {
          b.user = an(a).currentUser;
          b.operationType = "signIn";
          b.credential && b.credential.providerId && "password" == b.credential.providerId && (b.credential = null);
          return b;
        });
      });
    }

    l.Vb = function (a, b) {
      Z(this);
      return U(this).signInWithEmailAndPassword(a, b);
    };

    function hm(a) {
      Z(a);
      return U(a).signOut();
    }

    function Bn(a, b, c) {
      Z(a);

      if (b && b.code && ("auth/email-already-in-use" == b.code || "auth/credential-already-in-use" == b.code)) {
        var d = ei(W(a));
        return G().then(function () {
          return d(new Od("anonymous-upgrade-merge-conflict", null, c || b.credential));
        }).then(function () {
          a.g && (a.g.o(), a.g = null);
          throw b;
        });
      }

      return df(b);
    }

    function Kn(a, b, c, d) {
      P.call(this, el, void 0, d, "providerMatchByEmail", {
        F: b,
        D: c
      });
      this.i = a;
    }

    m(Kn, P);

    Kn.prototype.v = function () {
      this.u(this.i);
      this.w(this.i);
      this.l().focus();
      wm(this.l(), (this.l().value || "").length);
      P.prototype.v.call(this);
    };

    Kn.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    u(Kn.prototype, {
      l: ol,
      H: pl,
      u: ql,
      B: rl,
      j: sl,
      M: fl,
      w: hl
    });

    function Ln(a, b, c, d, e) {
      P.call(this, dl, {
        cc: b
      }, e, "selectTenant", {
        F: c,
        D: d
      });
      this.i = a;
    }

    m(Ln, P);

    Ln.prototype.v = function () {
      Mn(this, this.i);
      P.prototype.v.call(this);
    };

    Ln.prototype.m = function () {
      this.i = null;
      P.prototype.m.call(this);
    };

    function Mn(a, b) {
      function c(h) {
        b(h);
      }

      for (var d = a.g ? Uc("firebaseui-id-tenant-selection-button", a.g || a.s.a) : [], e = 0; e < d.length; e++) {
        var f = d[e],
            g = cn(f, "tenantId");
        O(a, f, za(c, g));
      }
    }

    function Nn(a) {
      P.call(this, zk, void 0, a, "spinner");
    }

    m(Nn, P);

    function On(a) {
      this.a = new Hh();
      I(this.a, "authDomain");
      I(this.a, "displayMode", Pn);
      I(this.a, "tenants");
      I(this.a, "callbacks");
      I(this.a, "tosUrl");
      I(this.a, "privacyPolicyUrl");

      for (var b in a) {
        if (a.hasOwnProperty(b)) try {
          Ih(this.a, b, a[b]);
        } catch (c) {
          og('Invalid config: "' + b + '"', void 0);
        }
      }
    }

    function Qn(a) {
      a = a.a.get("displayMode");

      for (var b in Rn) {
        if (Rn[b] === a) return Rn[b];
      }

      return Pn;
    }

    function Sn(a) {
      return a.a.get("callbacks") || {};
    }

    function Tn(a) {
      var b = a.a.get("tosUrl") || null;
      a = a.a.get("privacyPolicyUrl") || null;
      b && !a && tg("Privacy Policy URL is missing, the link will not be displayed.");

      if (b && a) {
        if ("function" === typeof b) return b;
        if ("string" === typeof b) return function () {
          rf(b);
        };
      }

      return null;
    }

    function Un(a) {
      var b = a.a.get("tosUrl") || null,
          c = a.a.get("privacyPolicyUrl") || null;
      c && !b && tg("Terms of Service URL is missing, the link will not be displayed.");

      if (b && c) {
        if ("function" === typeof c) return c;
        if ("string" === typeof c) return function () {
          rf(c);
        };
      }

      return null;
    }

    function Vn(a, b) {
      a = a.a.get("tenants");
      if (!a || !a.hasOwnProperty(b) && !a.hasOwnProperty(Wn)) throw Error("Invalid tenant configuration!");
    }

    function Xn(a, b, c) {
      a = a.a.get("tenants");
      if (!a) throw Error("Invalid tenant configuration!");
      var d = [];
      a = a[b] || a[Wn];
      if (!a) return og("Invalid tenant configuration: " + (b + " is not configured!"), void 0), d;
      b = a.signInOptions;
      if (!b) throw Error("Invalid tenant configuration: signInOptions are invalid!");
      b.forEach(function (e) {
        if ("string" === typeof e) d.push(e);else if ("string" === typeof e.provider) {
          var f = e.hd;
          f && c ? (f instanceof RegExp ? f : new RegExp("@" + f.replace(".", "\\.") + "$")).test(c) && d.push(e.provider) : d.push(e.provider);
        } else e = "Invalid tenant configuration: signInOption " + (JSON.stringify(e) + " is invalid!"), og(e, void 0);
      });
      return d;
    }

    function Yn(a, b, c) {
      a = Zn(a, b);
      (b = a.signInOptions) && c && (b = b.filter(function (d) {
        return "string" === typeof d ? c.includes(d) : c.includes(d.provider);
      }), a.signInOptions = b);
      return a;
    }

    function Zn(a, b) {
      var c = $n;
      var d = void 0 === d ? {} : d;
      Vn(a, b);
      a = a.a.get("tenants");
      return wf(a[b] || a[Wn], c, d);
    }

    var $n = ["immediateFederatedRedirect", "privacyPolicyUrl", "signInFlow", "signInOptions", "tosUrl"],
        Pn = "optionFirst",
        Rn = {
      nc: Pn,
      mc: "identifierFirst"
    },
        Wn = "*";

    function ao(a, b) {
      var c = this;
      this.s = sf(a);
      this.a = {};
      Object.keys(b).forEach(function (d) {
        c.a[d] = new On(b[d]);
      });
      this.ob = this.g = this.A = this.h = this.i = this.j = null;
      Object.defineProperty(this, "languageCode", {
        get: function get() {
          return this.ob;
        },
        set: function set(d) {
          this.ob = d || null;
        },
        enumerable: !1
      });
    }

    l = ao.prototype;

    l.Sb = function (a, b) {
      var c = this;
      bo(this);
      var d = a.apiKey;
      return new F(function (e, f) {
        if (c.a.hasOwnProperty(d)) {
          var g = Sn(c.a[d]).selectTenantUiHidden || null;

          if (Qn(c.a[d]) === Pn) {
            var h = [];
            b.forEach(function (r) {
              r = r || "_";
              var H = c.a[d].a.get("tenants");
              if (!H) throw Error("Invalid tenant configuration!");
              (H = H[r] || H[Wn]) ? r = {
                tenantId: "_" !== r ? r : null,
                V: H.fullLabel || null,
                displayName: H.displayName,
                za: H.iconUrl,
                ta: H.buttonColor
              } : (og("Invalid tenant configuration: " + (r + " is not configured!"), void 0), r = null);
              r && h.push(r);
            });

            var k = function k(r) {
              r = {
                tenantId: r,
                providerIds: Xn(c.a[d], r || "_")
              };
              e(r);
            };

            if (1 === h.length) {
              k(h[0].tenantId);
              return;
            }

            c.g = new Ln(function (r) {
              bo(c);
              g && g();
              k(r);
            }, h, Tn(c.a[d]), Un(c.a[d]));
          } else c.g = new Kn(function () {
            var r = c.g.j();

            if (r) {
              for (var H = 0; H < b.length; H++) {
                var Ba = Xn(c.a[d], b[H] || "_", r);

                if (0 !== Ba.length) {
                  r = {
                    tenantId: b[H],
                    providerIds: Ba,
                    email: r
                  };
                  bo(c);
                  g && g();
                  e(r);
                  return;
                }
              }

              c.g.a(Md({
                code: "no-matching-tenant-for-email"
              }).toString());
            }
          }, Tn(c.a[d]), Un(c.a[d]));

          c.g.render(c.s);
          (f = Sn(c.a[d]).selectTenantUiShown || null) && f();
        } else {
          var p = Error("Invalid project configuration: API key is invalid!");
          p.code = "invalid-configuration";
          c.pb(p);
          f(p);
        }
      });
    };

    l.Nb = function (a, b) {
      if (!this.a.hasOwnProperty(a)) throw Error("Invalid project configuration: API key is invalid!");
      var c = b || void 0;
      Vn(this.a[a], b || "_");

      try {
        this.i = firebase.app(c).auth();
      } catch (e) {
        var d = this.a[a].a.get("authDomain");
        if (!d) throw Error("Invalid project configuration: authDomain is required!");
        a = firebase.initializeApp({
          apiKey: a,
          authDomain: d
        }, c);
        a.auth().tenantId = b;
        this.i = a.auth();
      }

      return this.i;
    };

    l.Xb = function (a, b) {
      var c = this;
      return new F(function (d, e) {
        function f(H, Ba) {
          c.j = new wn(a);
          En(c.j, c.s, H, Ba);
        }

        var g = a.app.options.apiKey;
        c.a.hasOwnProperty(g) || e(Error("Invalid project configuration: API key is invalid!"));
        var h = Yn(c.a[g], a.tenantId || "_", b && b.providerIds);
        bo(c);
        e = {
          signInSuccessWithAuthResult: function signInSuccessWithAuthResult(H) {
            d(H);
            return !1;
          }
        };
        var k = Sn(c.a[g]).signInUiShown || null,
            p = !1;

        e.uiChanged = function (H, Ba) {
          null === H && "callback" === Ba ? ((H = Wc("firebaseui-id-page-callback", c.s)) && Kj(H), c.h = new Nn(), c.h.render(c.s)) : p || null === H && "spinner" === Ba || "blank" === Ba || (c.h && (c.h.o(), c.h = null), p = !0, k && k(a.tenantId));
        };

        h.callbacks = e;
        h.credentialHelper = "none";
        var r;
        b && b.email && (r = {
          emailHint: b.email
        });
        c.j ? c.j.Wa().then(function () {
          f(h, r);
        }) : f(h, r);
      });
    };

    l.reset = function () {
      var a = this;
      return G().then(function () {
        a.j && a.j.Wa();
      }).then(function () {
        a.j = null;
        bo(a);
      });
    };

    l.Tb = function () {
      var a = this;
      this.h || this.A || (this.A = window.setTimeout(function () {
        bo(a);
        a.h = new Nn();
        a.g = a.h;
        a.h.render(a.s);
        a.A = null;
      }, 500));
    };

    l.mb = function () {
      window.clearTimeout(this.A);
      this.A = null;
      this.h && (this.h.o(), this.h = null);
    };

    l.Ab = function () {
      bo(this);
      this.g = new Al();
      this.g.render(this.s);
      return G();
    };

    function bo(a) {
      a.j && a.j.reset();
      a.mb();
      a.g && a.g.o();
    }

    l.pb = function (a) {
      var b = this,
          c = Md({
        code: a.code
      }).toString() || a.message;
      bo(this);
      var d;
      a.retry && "function" === typeof a.retry && (d = function d() {
        b.reset();
        a.retry();
      });
      this.g = new El(c, d);
      this.g.render(this.s);
    };

    l.Pb = function (a) {
      var b = this;
      return G().then(function () {
        var c = b.i && b.i.app.options.apiKey;
        if (!b.a.hasOwnProperty(c)) throw Error("Invalid project configuration: API key is invalid!");
        Vn(b.a[c], a.tenantId || "_");
        if (!b.i.currentUser || b.i.currentUser.uid !== a.uid) throw Error("The user being processed does not match the signed in user!");
        return (c = Sn(b.a[c]).beforeSignInSuccess || null) ? c(a) : a;
      }).then(function (c) {
        if (c.uid !== a.uid) throw Error("User with mismatching UID returned.");
        return c;
      });
    };

    v("firebaseui.auth.FirebaseUiHandler", ao);
    v("firebaseui.auth.FirebaseUiHandler.prototype.selectTenant", ao.prototype.Sb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.getAuth", ao.prototype.Nb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.startSignIn", ao.prototype.Xb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.reset", ao.prototype.reset);
    v("firebaseui.auth.FirebaseUiHandler.prototype.showProgressBar", ao.prototype.Tb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.hideProgressBar", ao.prototype.mb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.completeSignOut", ao.prototype.Ab);
    v("firebaseui.auth.FirebaseUiHandler.prototype.handleError", ao.prototype.pb);
    v("firebaseui.auth.FirebaseUiHandler.prototype.processUser", ao.prototype.Pb);
    v("firebaseui.auth.AuthUI", wn);
    v("firebaseui.auth.AuthUI.getInstance", function (a) {
      a = xn(a);
      return yn[a] ? yn[a] : null;
    });
    v("firebaseui.auth.AuthUI.prototype.disableAutoSignIn", wn.prototype.Cb);
    v("firebaseui.auth.AuthUI.prototype.start", wn.prototype.start);
    v("firebaseui.auth.AuthUI.prototype.setConfig", wn.prototype.ib);
    v("firebaseui.auth.AuthUI.prototype.signIn", wn.prototype.Ub);
    v("firebaseui.auth.AuthUI.prototype.reset", wn.prototype.reset);
    v("firebaseui.auth.AuthUI.prototype.delete", wn.prototype.Wa);
    v("firebaseui.auth.AuthUI.prototype.isPendingRedirect", wn.prototype.nb);
    v("firebaseui.auth.AuthUIError", Od);
    v("firebaseui.auth.AuthUIError.prototype.toJSON", Od.prototype.toJSON);
    v("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM", Ii);
    v("firebaseui.auth.CredentialHelper.GOOGLE_YOLO", ni);
    v("firebaseui.auth.CredentialHelper.NONE", ci);
    v("firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID", "anonymous");
    F.prototype["catch"] = F.prototype.Ca;
    F.prototype["finally"] = F.prototype.dc;
  }).apply(typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : window);
}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : window);

if (typeof window !== 'undefined') {
  window.dialogPolyfill = dialogPolyfill;
}

var auth = firebaseui.auth;
export { auth };